let CERT_COLUMN;
let CLASS_COLUMN;
let stringOptions;
let sharesOwned = 0;
let builtGiftTransferModalAlready;
let addedGiftTransferListenersAlready;
let viewRecipients;
let confirmRequestRemove;

function resetGiftTransferState() {
	builtGiftTransferModalAlready = false;
	sharesOwned = 0;
	window._stepwiseMasterLen = undefined;
	window._stepwiseTargetLen = null;
}

function giftTransfer(shareholder, fromUser, options = {}) {
	/* NOTES
	This method creates the Gift / Transfer modal
	For each class, it gets relevant data for the active user
	The resultant display can be filtered by class

	Options:
	- dataOnly: boolean - If true, skip DOM operations and return processed data
	- clientData: object - Override client data (for dataOnly mode)
	- shareholderData: object - Override shareholder data (for dataOnly mode)
	*/
	const dataOnly = options.dataOnly === true;
	const _clientData = options.clientData;
	const _shareholderData = options.shareholderData;

	// In dataOnly mode, skip DOM checks and use provided data
	if (!dataOnly) {
		if (userData?.userid == 'consolidated.view' || shareholderData?.userid == 'consolidated.view') {
			// Use AppState shareholderData (bridged via window) rather than re-parsing sessionStorage
			if (!shareholderData) return;
			userData = shareholderData;
			shareholder = userData.userid;
		}
		let currentHeadline = document.getElementById('giftHeadline').innerText;
		currentHeadline = currentHeadline.replace('From:', '').trim();
		if (currentHeadline && currentHeadline != userData.user_name) {
			builtGiftTransferModalAlready = false;
			sharesOwned = 0;
		}

		if (builtGiftTransferModalAlready) return;
		builtGiftTransferModalAlready = true;
	}

	let members;
	let allGifts = [];
	let ttlBasis = 0;
	let ttlAfter = 0;
	let ttlBefore = 0;
	let pairedQty = 0;
	let selectedClass;
	let minDiff = 999; // arbitrarily large starting number used in tranche analysis
	let diffCount = 0; // counter used in tranche analysis
	let removeGiftId = '';
	let giftRecipients = [];
	let priorTransfers = [];
	let includedClasses = [];
	let giftTransactions = [];
	let historicHoldings = [];
	let origTransactions = [];
	let selectedTranches = [];
	let toggle = 'Show Positves';

	let giftUserData = dataOnly ? _shareholderData || {} : shareholderData;
	let giftUserId = giftUserData.userid || shareholder;

	let viewGiftTransferModal, userGiftTransferTable, BUY_BACK;
	if (!dataOnly) {
		BUY_BACK = pn == '/' && clientData.flags?.buy_back_active;
		viewGiftTransferModal = document.getElementById('viewGiftTransferModal');
		userGiftTransferTable = document.getElementById('userGiftTransferTable');
	}

	// Need to wait for external data - use provided data in dataOnly mode
	if (dataOnly && _clientData) {
		clientData = _clientData;
	} else {
		clientData = JSON.parse(sessionStorage.getItem(client + '.Data'));
	}

	// Helper functions used by both dataOnly mode and renderUserGiftTransModal
	function numberToLetters(num) {
		let letters = '';
		while (num >= 0) {
			letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters;
			num = Math.floor(num / 26) - 1;
		}
		return letters;
	}

	function lettersToNumbers(ltrs) {
		if (!ltrs) return '?';
		let n = 0;
		for (let p = 0; p < ltrs.length; p++) {
			n = ltrs[p].charCodeAt() - 64 + n * 26;
		}
		return n.toString().padStart(6, '0');
	}

	// By date then descending effective tax basis (unknowns last)
	function sortByClassThenBasisThenDateThenQty(transArray) {
		transArray.sort((a, b) => {
			if (isVERM) {
				// First, sort by 'class'
				if (a.shareClass < b.shareClass) return -1;
				if (a.shareClass > b.shareClass) return 1;

				// Next, sort by 'date' ascending
				let dateA = Number(a.date);
				let dateB = Number(b.date);
				if (dateA < dateB) return -1;
				if (dateA > dateB) return 1;
			} else if (!isBB) {
				// First, sort by 'date' descending
				let dateA = Number(a.date);
				let dateB = Number(b.date);
				if (dateA < dateB) return 1;
				if (dateA > dateB) return -1;

				// Next, sort by 'class'
				if (a.shareClass < b.shareClass) return -1;
				if (a.shareClass > b.shareClass) return 1;
			}

			// Then, sort by effective tax basis (descending, unknowns last)
			function normBasis(val) {
				return isKnownNumber(val) ? Number(val) : null;
			}

			let basisA = normBasis(a._effectiveTaxBasis);
			let basisB = normBasis(b._effectiveTaxBasis);

			// Unknowns go LAST
			if (basisA === null && basisB !== null) return 1;
			if (basisA !== null && basisB === null) return -1;

			// Both known → descending
			if (basisA !== null && basisB !== null) {
				if (basisA < basisB) return 1;
				if (basisA > basisB) return -1;
			}

			if (isBB) {
				// First, sort by 'class'
				if (a.shareClass < b.shareClass) return -1;
				if (a.shareClass > b.shareClass) return 1;

				// Next, sort by 'date' ascending
				let dateA = Number(a.date);
				let dateB = Number(b.date);
				if (dateA < dateB) return -1;
				if (dateA > dateB) return 1;
			}

			// Finally, sort by 'quantity'
			let quantityA = Number(a.quantity);
			let quantityB = Number(b.quantity);
			if (quantityA < quantityB) return -1;
			if (quantityA > quantityB) return 1;

			return 0;
		});

		return transArray;
	}

	// Build a new transactions list
	let classes = Object.keys(clientData.equity);
	if (classes.length > 1) CLASS_COLUMN = true;
	classes.sort();

	classes.forEach((c, i) => {
		// console.log(clientData.equity[c].transactions)
		let classIncluded = false;
		// Try looking at Transactions first, then Approved balances
		let classTransactions = clientData.equity[c].transactions || [];
		classTransactions.forEach(function (t) {
			if ((t.receiver && t.receiver.toLowerCase() == shareholder) || (t.sender && t.sender.toLowerCase() == shareholder)) {
				t.shareClass = classes[i];
				giftTransactions.push(t);
				classIncluded = true;
			}
		});
		CERT_COLUMN ||= classTransactions.some((t) => t.notes.includes('#'));

		// Dont't display future (beyond this year) Events or Transactions
		let nextYear = new Date(new Date().getFullYear() + 1, 1, 1) / 1000;
		giftTransactions = giftTransactions.filter((t) => Number(t.date) < nextYear);
		console.log('initialTransactions[' + c + ']: ', giftTransactions);

		let userShares = giftUserData.clients[client].shares[c];
		if (classIncluded) includedClasses.push(c);
		//clientEvents = clientEvents.concat(clientData.equity[c].events);

		let shareholderClientData = shareholderData.clients[client];
		let userTransactions = classTransactions.filter((t) => t.receiver == shareholder || t.sender == shareholder);
		if (userTransactions.length && shareholderClientData.shares[c]) {
			// Need to rationalize, or at least say, Owned vs Approved
			sharesOwned += Number(shareholderClientData.shares[c].approved || '0');
		}
	});

	let ttlCurrentValue = 'n.a.';
	let balanceBefore = sharesOwned;
	let balanceAfter = balanceBefore;
	// let shortName = giftUserData.clients[client].notes;

	let trancheLog = localStorage.getItem('TrancheLog');
	trancheLog += '\n' + 'Shares Owned: ' + balanceBefore;
	localStorage.setItem('TrancheLog', trancheLog);

	const giftHeadline = document.getElementById('giftHeadline');
	const balanceHeadline = document.getElementById('balanceHeadline');
	const stepwiseAnalysis = document.getElementById('stepwiseAnalysis');
	const giftTransferControls = document.getElementById('giftTransferControls');
	if (!sharesOwned || stepwiseAnalysis?.checked) giftTransferControls.classList.add('hidden');
	else giftTransferControls.classList.remove('hidden');
	giftHeadline.innerHTML = `From:&ensp;<span class="text-light">` + giftUserData.user_name + `</span>`;
	// giftHeadline.innerHTML = `From:&ensp;<span class="text-light">` + (shortName ? shortName + " | " : "") + giftUserData.user_name + `</span>`;
	balanceHeadline.innerHTML =
		'Shares Owned Now:&emsp;<span class="text-primary">' +
		balanceBefore.toLocaleString('en-US', customFormat()) +
		`</span>&nbsp;Before&emsp;<span id="balanceAfterElem" class="text-primary${balanceAfter.after < 0 ? ' red-text font-bold' : ''}">` +
		balanceAfter.toLocaleString('en-US', customFormat()) +
		`</span>&nbsp;After`;

	// SEE NOTES HERE: https://docs.google.com/document/d/1tASR37WcKOE-x_LJKlCy0JhD0g0cWPaTUCUPNAlRjNE/edit
	// First, sort all transactions chronologically, oldest to newest.
	// Next, scan for dates with multiple transactions.
	// Each of these dates must be analyzed separately for possible splits or related swaps.
	// In all cases, tax basis must be carried forward.

	// Determine if these transactions share the current account as both sender and receiver.
	// If all go only in one direction (single-leg) these transactions require no special treatment.

	// If the transactions go in opposite directions, start by sorting all of the transactions for a given date by descending dollar amounts.

	// Now look for matching quantities (swaps).
	// Do the total aggregate quantities in each direction match?
	// If not, do any individual quantities in each direction match?
	// If not, does any individual quantity match a group of opposite quantities?

	// If matching quantities are not found, look for matching dollar amounts (splits).
	// Do the total aggregate dollar amounts in each direction match?
	// If not, do any individual dollar amounts in each direction match?
	// If not, does any individual amount match a group of opposite amounts?
	// If any matches are found, determine and enter the new post-split tax basis.
	// Filter out first leg (cancellation) of stock swaps and stock splits.

	// No clue why, but we need new array objects...
	giftTransactions = JSON.parse(JSON.stringify(giftTransactions));

	// --- Stepwise: clamp giftTransactions to cutoff date  ---
	// In dataOnly mode (statement generation), reset stepwise state so all transactions are included
	if (dataOnly) window._stepwiseTargetLen = null;
	(function () {
		// build sorted unique list of all dates
		let allDates = Array.from(new Set(giftTransactions.map((t) => String(t.date)))).sort((a, b) => Number(a) - Number(b));

		// master and target length
		window._stepwiseMasterLen = allDates.length;
		if (window._stepwiseTargetLen == null) window._stepwiseTargetLen = _stepwiseMasterLen;

		// clamp target length
		if (_stepwiseMasterLen === 0) {
			window._stepwiseTargetLen = 0;
		} else {
			if (_stepwiseTargetLen < 1) _stepwiseTargetLen = 1;
			if (_stepwiseTargetLen > _stepwiseMasterLen) _stepwiseTargetLen = _stepwiseMasterLen;
		}

		// cutoff date = last visible date
		const cutoffSec = _stepwiseTargetLen > 0 ? Number(allDates[_stepwiseTargetLen - 1]) : 0;

		// filter giftTransactions IN PLACE
		if (cutoffSec > 0) {
			giftTransactions = giftTransactions.filter((t) => Number(t.date) <= cutoffSec);
		}

		// optional: update label/buttons
		const label = document.getElementById('stepLabel');
		if (label) {
			if (_stepwiseTargetLen === 0) {
				label.textContent = 'As of --/--/-- (0 of 0)';
			} else {
				const ms = cutoffSec * 1000;
				const dstr = window.moment ? moment(ms).format('MM/DD/YY') : new Date(ms).toLocaleDateString();
				label.textContent = `As of ${dstr} (${_stepwiseTargetLen} of ${_stepwiseMasterLen})`;
			}
		}
	})();

	function reduceToVestedOnly() {
		const userid = giftUserData.userid;
		const shareClasses = giftUserData.clients?.[client]?.shares || {};
		const grants = [];

		// Loop over all share classes
		for (const [classKey, classData] of Object.entries(shareClasses)) {
			const vestingData = classData.vesting || {};

			// Build array of structured grant data
			for (const [grantName, grant] of Object.entries(vestingData)) {
				const schedule = grant.schedule || {};
				const timestamps = Object.keys(schedule).map((t) => Number(t));
				const total = timestamps.reduce((sum, t) => sum + Number(schedule[t].amount || 0), 0);
				const vested = timestamps.filter((t) => schedule[t].posted).reduce((sum, t) => sum + Number(schedule[t].amount || 0), 0);

				// Extract a grant date from the title, e.g., "1/1/24"
				const dateMatch = grantName.match(/(\d{1,2}\/\d{1,2}\/\d{2,4})/);
				let titleDateStr = null;
				if (dateMatch) titleDateStr = dateMatch[1];

				grants.push({ grantName, total, vested, titleDateStr, classKey });
			}
		}

		// Adjust the transactions
		for (const tx of giftTransactions) {
			if (tx.notes.toLowerCase().includes('restricted stock grant') && tx.receiver === userid) {
				const txQty = Number(tx.quantity);
				const txDate = Number(tx.date);
				const txClass = tx.shareClass;

				// Format transaction date as "m/d/yy" and "m/d/yyyy"
				const txDateStr = moment.unix(txDate).utc().format('M/D/YYYY');
				const [m, d, y] = txDateStr.split('/');
				const altYear = y.length === 4 ? y.slice(2) : '20' + y;
				const altDateStr = `${m}/${d}/${altYear}`;

				// Match against grants
				const match = grants.find(
					(grant) =>
						grant.total === txQty &&
						grant.classKey === txClass &&
						grant.titleDateStr &&
						(grant.titleDateStr === txDateStr || grant.titleDateStr === altDateStr)
				);

				if (match) {
					tx.quantity = match.vested.toString(); // even if 0
				}
			}
		}
	}

	// Returns:
	// - null    => no deferral
	// - "LOCK"  => TBD / future use (admin must edit to unlock)
	// - number  => unix seconds at midnight of the "use on/after" day
	function deferUseTs(notes) {
		const s = String(notes || '').trim();
		if (!s) return null;

		// Must contain the "for use" concept (or "for future use")
		if (!/\bfor\s+(?:future\s+)?use\b/i.test(s)) return null;

		// "for future use" => locked until admin edits
		if (/\bfor\s+future\s+use\b/i.test(s)) return 'LOCK';

		// Recognize TBD in any common form: TBD, T.B.D., T. B. D, etc.
		const TBD_RE = /\bt\s*\.?\s*b\s*\.?\s*d\s*\.?\b/i;

		// Allow: "... for use TBD" (no on/after keyword)
		if (/\bfor\s+use\b/i.test(s) && TBD_RE.test(s)) return 'LOCK';

		// Allow: "for use on X", "for use after X", "for use on/after X"
		const m = s.match(/\bfor\s+use\b.*?\b(on\/after|on|after)\b\s*[:\-]?\s*([A-Za-z0-9,./\- ]{2,60}|\bt\s*\.?\s*b\s*\.?\s*d\s*\.?\b)\b/i);
		if (!m) return null;

		const raw = String(m[2] || '').trim();
		if (TBD_RE.test(raw)) return 'LOCK';

		// Parse "any date format" using moment loose first, then Date.parse fallback
		let ms = null;
		if (window.moment) {
			const mm = moment(raw);
			if (mm.isValid()) ms = mm.valueOf();
		}
		if (ms == null) {
			const dp = Date.parse(raw);
			if (!isNaN(dp)) ms = dp;
		}
		if (ms == null) return null;

		return moment(ms).utc().startOf('day').unix();
	}

	// too early for historical context
	// if (isEDM) reduceToVestedOnly();

	giftTransactions.sort((a, b) => Number(a.date) - Number(b.date));
	origTransactions = JSON.parse(JSON.stringify(giftTransactions));

	// normalize all dates to midnight of that date
	giftTransactions.forEach((t) => t.date && (t.date = moment.unix(t.date).utc().startOf('day').unix()));
	giftTransactions.forEach((t) => (t._useAfter = deferUseTs(t.notes)));
	console.log(
		'LOCK lots:',
		giftTransactions.filter((t) => t._useAfter === 'LOCK')
	);

	// NEW EFECTIVE TAX BASIS CODE //
	function isNA(val) {
		const s = String(val ?? '')
			.trim()
			.toLowerCase();
		return s === 'n/a' || s === 'n.a.' || s === 'na' || s === 'n.a';
	}

	function isKnownNumber(val) {
		if (val === null || val === undefined) return false;
		if (typeof val === 'string') {
			const s = val.trim().toLowerCase();
			if (s === '' || isNA(s)) return false;
		}
		return !isNaN(Number(val));
	}

	function getLatestValuationField(txn, clientData, fieldName) {
		if (!txn?.shareClass || !txn?.date) return null;
		let vals = clientData?.equity?.[txn.shareClass]?.valuations;
		if (!Array.isArray(vals) || !vals.length) return null;
		let txnDate = Number(txn.date);
		let bestValue = null;
		let bestDate = null;
		vals.forEach((v) => {
			let vDate = Number(v?.date);
			if (!isFinite(vDate) || vDate > txnDate) return;
			if (!isKnownNumber(v?.[fieldName])) return;
			if (bestDate === null || vDate > bestDate) {
				bestDate = vDate;
				bestValue = Number(v[fieldName]);
			}
		});
		return bestValue;
	}

	function resolveEffectiveTaxBasis(txn, clientData) {
		// 0) explicit n/a means "do not derive"
		let tb = String(txn.taxBasis || '')
			.trim()
			.toLowerCase();
		if (isNA(tb)) return { value: txn.taxBasis, source: 'explicitNA' };

		// 1) explicit tax basis
		if (isKnownNumber(txn.taxBasis)) return { value: Number(txn.taxBasis), source: 'taxBasis' };

		// 2) purchase price / transaction price
		if (isKnownNumber(txn.sharePrice)) return { value: Number(txn.sharePrice), source: 'sharePrice' };

		// 3) valuation-derived fallbacks
		let ref = getLatestValuationField(txn, clientData, 'referencePrice');
		if (isKnownNumber(ref)) return { value: ref, source: 'referencePrice' };

		let valPrice = getLatestValuationField(txn, clientData, 'sharePrice');
		if (isKnownNumber(valPrice)) return { value: valPrice, source: 'valuationSharePrice' };

		return { value: null, source: 'unresolved' };
	}

	giftTransactions.forEach((t) => {
		const basis = resolveEffectiveTaxBasis(t, clientData);
		t._effectiveTaxBasis = basis.value;
		t._basisSource = basis.source;
		console.log('EFFECTIVE BASIS = ' + basis.value + ' ' + basis.source);
	});

	// For each Recieve from company with no sharePrice, insert latest valuation or assumed price
	// giftTransactions.forEach(r => {
	// 	if (r.receiver == giftUserId && (r.sender == "" || r.sender == client || r.senderName.toLowerCase() == "issuer"))
	// 		r.sharePrice = toNumber(r.sharePrice).toString();
	// 		let classValuations = clientData.equity[r.shareClass].valuations.sort((a, b) => Number(a.date) - Number(b.date));
	// 		let nearestValuation = null;
	// 		for (const valuation of classValuations) {
	// 			if (Number(valuation.date) > Number(r.date)) break;
	// 			nearestValuation = valuation;
	// 		}
	// 		if (nearestValuation) r.sharePrice = nearestValuation.sharePrice;
	// });

	// On first pass, go class-by-class.  May need to revisit with mixed classes for swaps.
	classes.forEach((c) => {
		// First, find dates with multiple transations on the same date
		let transactionsDateCount = giftTransactions
			.filter((g) => g.shareClass == c)
			.reduce((t, r) => {
				t[r.date] = (t[r.date] || 0) + 1;
				return t;
			}, {});
		let multipleSameDates = Object.keys(transactionsDateCount).filter((date) => transactionsDateCount[date] >= 1);
		multipleSameDates.push(Math.floor(Date.now() / 1000).toString()); // add today to catch any recent single sends.
		multipleSameDates.sort((a, b) => Number(a) - Number(b));
		console.log('multipleSameDates[' + c + ']: ', multipleSameDates);

		const usedSendNrids = new Set();
		function addPriorTransfers(transArray) {
			transArray.forEach(addPriorTransfer);
		}
		function addPriorTransfer(trans) {
			if (!trans?.nrid || usedSendNrids.has(trans.nrid)) return false;
			priorTransfers.push(trans);
			usedSendNrids.add(trans.nrid);
			return true;
		}

		let carryOverDeduct = 0;

		// Now, examine each of these dates, starting with the oldest one
		multipleSameDates.forEach(function (d) {
			console.log('### SAME DATE ###: ', moment.unix(d).utc().format('DD-MMM-YY'));

			// First handle any earlier single Send that occurs on a given date by itself
			let singleSendTransactions = giftTransactions.filter((g) => sameClassAndSender(g) && earlierDate(g));
			singleSendTransactions.forEach((singleSend) => {
				let targetQty = Number(singleSend.quantity);
				if (handleDescriptionMatch(singleSend, targetQty, Number(singleSend.date))) {
					console.log('DESCRIPTION MATCH Transaction: ', singleSend);
					singleSend.tranche = c + '-' + singleSend.date;
					addPriorTransfer(singleSend);
					giftTransactions = giftTransactions.filter((g) => g.nrid != singleSend.nrid);
				} else if (handlePerfectFit(singleSend, targetQty, Number(singleSend.date) - 43200, false)) {
					// 1/2 day
					console.log('SINGLE SEND Transaction: ', singleSend);
					singleSend.tranche = c + '-' + singleSend.date;
					addPriorTransfer(singleSend);
					giftTransactions = giftTransactions.filter((g) => g.nrid != singleSend.nrid);
				} else if (handlePerfectFit(singleSend, targetQty, Number(singleSend.date), false)) {
					console.log('SINGLE SEND Transaction: ', singleSend);
					singleSend.tranche = c + '-' + singleSend.date;
					addPriorTransfer(singleSend);
					giftTransactions = giftTransactions.filter((g) => g.nrid != singleSend.nrid);
				} else {
					console.log('*** NO SEND-ONLY MATCH ***');
					let safety = 0;
					let firstHistoric;
					while (targetQty > 0 && safety < 20) {
						safety++;
						let firstPrior = giftTransactions
							.slice()
							.reverse()
							.find((g) => sameClassAndReceiver(g) && Number(g.date) <= Number(singleSend.date) && eligibleAsOf(g, singleSend.date));
						if (firstPrior) {
							if (firstPrior.quantity > targetQty) {
								firstPrior.quantity = (Number(firstPrior.quantity) - targetQty).toString();
								firstHistoric = JSON.parse(JSON.stringify(firstPrior));
								firstHistoric.quantity = targetQty.toString();
								firstHistoric.tranche = c + '-' + singleSend.date;
								historicHoldings.push(firstHistoric);
								targetQty = 0;
							} else {
								targetQty -= Number(firstPrior.quantity);
								firstPrior.tranche = c + '-' + singleSend.date;
								historicHoldings.push(firstPrior);
								giftTransactions = giftTransactions.filter((g) => g.nrid != firstPrior.nrid);
							}
						}
					}
					console.log('SINGLE SEND Transaction: ', singleSend);
					singleSend.tranche = c + '-' + singleSend.date;
					addPriorTransfer(singleSend);
					giftTransactions = giftTransactions.filter((g) => g.nrid != singleSend.nrid);
				}
			});

			let sameDateTransactions = giftTransactions.filter((t) => t.date == d && t.shareClass == c);
			let sameDateSends = sameDateTransactions.filter((t) => t.sender == giftUserId);
			let sameDateReceives = sameDateTransactions.filter((t) => t.receiver == giftUserId);

			const certPairs = matchSameDayByCertificate(sameDateTransactions);
			if (certPairs.length) {
				certPairs.forEach(({ send, receive }) => {
					send.tranche = c + '-' + d;
					receive.tranche = c + '-' + d;
					addPriorTransfer(send);
					historicHoldings.push({
						...receive,
						tranche: c + '-' + d,
						quantity: send.quantity,
					});

					giftTransactions = giftTransactions.filter((g) => g.nrid != send.nrid && g.nrid != receive.nrid);
				});

				sameDateTransactions = giftTransactions.filter((t) => t.date == d && t.shareClass == c);
				sameDateSends = sameDateTransactions.filter((t) => t.sender == giftUserId);
				sameDateReceives = sameDateTransactions.filter((t) => t.receiver == giftUserId);
			}

			// Next process any description-match transfers (remove as we go)
			const descMatchedSendNrids = new Set();
			// IMPORTANT: iterate a snapshot because we mutate giftTransactions inside the loop
			for (const send of [...sameDateSends]) {
				if (handleDescriptionMatch(send, Number(send.quantity), Number(send.date))) {
					console.log('DESCRIPTION MATCH Transaction: ', send);
					send.tranche = c + '-' + send.date;
					addPriorTransfer(send);
					// Remove the SEND from the active pool so later branches don't touch it
					descMatchedSendNrids.add(send.nrid);
				}
			}
			// Apply removals once (avoids mid-loop topology weirdness)
			if (descMatchedSendNrids.size) giftTransactions = giftTransactions.filter((t) => !descMatchedSendNrids.has(t.nrid));
			// Recompute same-day lists after removing desc-matched sends
			sameDateTransactions = giftTransactions.filter((t) => t.date == d && t.shareClass == c);
			sameDateSends = sameDateTransactions.filter((t) => t.sender == giftUserId);
			sameDateReceives = sameDateTransactions.filter((t) => t.receiver == giftUserId);

			// Next look for same day cancel/reissue (e.g. lost certificate)
			if (isEDM && sameDateSends.length && sameDateReceives.length >= 1) releaseRestrictedEquity(sameDateTransactions);

			const PREFER_CERT_LINEAGE = !isASP;
			const hasSelfContainedCertFlow = isSelfContainedCertificateFlow(sameDateTransactions);
			const shouldApplyCertLineage = PREFER_CERT_LINEAGE && !hasSelfContainedCertFlow && sameDateSends.length;
			if (shouldApplyCertLineage) cancelReissueCertificate(sameDateTransactions);

			// Next, more complex scenarios
			sameDateTransactions = giftTransactions.filter((t) => t.date == d && t.shareClass == c);
			sameDateTransactions.sort((a, b) => Number(b.quantity) - Number(a.quantity));
			sameDateSends = sameDateTransactions.filter((t) => t.sender == giftUserId);
			sameDateReceives = sameDateTransactions.filter((t) => t.receiver == giftUserId);
			let sameDateSenders = [...new Set(sameDateTransactions.map((t) => t.sender))];
			let sameDateReceivers = [...new Set(sameDateTransactions.map((t) => t.receiver))];
			let sameDateSendQtySum = sameDateSends.reduce((a, b) => a + Number(b.quantity), 0);
			let sameDateReceiveQtySum = sameDateReceives.reduce((a, b) => a + Number(b.quantity), 0);
			let sameDateSendAmtSum = sameDateSends.reduce((a, b) => a + Number(b.quantity) * toNumber(b.sharePrice), 0);
			let sameDateReceiveAmtSum = sameDateReceives.reduce((a, b) => a + Number(b.quantity) * toNumber(b.sharePrice), 0);
			let sameDateNetQty = Math.abs(sameDateSendQtySum - sameDateReceiveQtySum);
			let sameDateNetAmt = Math.abs(sameDateSendAmtSum - sameDateReceiveAmtSum);
			// console.log("sameDate: ", d);
			// console.log("sameDateTrans: ", sameDateTransactions);
			// console.log("Senders: ", sameDateSenders);
			// console.log("Receivers: ", sameDateReceivers);
			// console.log("Sends: ", sameDateSends);
			// console.log("Receives: ", sameDateReceives);
			// console.log("SendQtySum: ", sameDateSendQtySum);
			// console.log("ReceiveQtySum: ", sameDateReceiveQtySum);
			// console.log("SendAmtSum: ", sameDateSendAmtSum);
			// console.log("ReceiveAmtSum: ", sameDateReceiveAmtSum);

			let isSwapOrSplit = false;
			if (sameDateSends.length == 0) {
				// ONE WAY recieve transactions - do nothing
				console.log('ONE-WAY Receiving: ', sameDateReceives);
			} else if (sameDateReceives.length == 0) {
				// ONE WAY send transactions - look for matches
				console.log('ONE-WAY Sending: ', sameDateSends);

				if (moment.unix(Number(d)).utc().format('YYYY-MM-DD') == '2015-04-08' && c == 'C') {
					console.log(
						'AL sameDateSends:',
						sameDateSends.map((s) => ({
							nrid: s.nrid,
							notes: s.notes,
							quantity: s.quantity,
						}))
					);
				}

				// First try finding old certificates, where each exactly matches one of the Sends
				let exactMatches = oneForOneMatches(sameDateSends);
				if (exactMatches) return;

				// Attempt 1 - first look for one prior Receive that exactly matches the collection of Sends
				let exactMatchTrans = giftTransactions.find(
					(g) => sameClassAndReceiver(g) && earlierDate(g) && eligibleAsOf(g, d) && sameQty(g, sameDateSendQtySum)
				);
				if (exactMatchTrans) {
					let sendTransactions = giftTransactions.filter((g) => sameClassAndSender(g) && sameDate(g));
					sendTransactions.forEach((s) => (s.tranche = c + '-' + d));
					addPriorTransfers(sendTransactions);
					console.log('SEND Transactions: ', sendTransactions);
					// FIX: only remove the sends we *actually captured*, not everything <= date
					const sendNridSet = new Set(sendTransactions.map((t) => t.nrid).filter(Boolean));
					giftTransactions = giftTransactions.filter((g) => !sendNridSet.has(g.nrid));
					// giftTransactions = giftTransactions.filter(g => !sameClassAndSender(g) || !sameDate(g));
					giftTransactions = giftTransactions.filter((g) => g.nrid != exactMatchTrans.nrid);
					exactMatchTrans.tranche = c + '-' + d;
					historicHoldings.push(exactMatchTrans);
				} else {
					// Need to tear things apart, Send by Send
					let closeMatchTrans;
					sameDateSends.forEach((s) => {
						// Attempt 2 & 3 -Try to find one or more prior Receives that match this Send
						exactMatchTrans = giftTransactions.find(
							(g) =>
								sameClassAndReceiver(g) &&
								earlierDate(g) &&
								eligibleAsOf(g, s.date) &&
								sameQty(g, Number(s.quantity)) &&
								(notRestricted(g) || !isEDM)
						);
						if (exactMatchTrans || !parseTransfers()) {
							let sendTransaction = giftTransactions.filter((g) => g.nrid == s.nrid)[0];
							if (!sendTransaction) return;
							sendTransaction.tranche = c + '-' + d;
							addPriorTransfer(sendTransaction);
							giftTransactions = giftTransactions.filter((g) => g.nrid != s.nrid);
							if (exactMatchTrans) {
								// <- Good, a simple solution, all done (Attempt 2)
								giftTransactions = giftTransactions.filter((g) => g.nrid != exactMatchTrans.nrid);
								exactMatchTrans.tranche = c + '-' + d;
								historicHoldings.push(exactMatchTrans);
							} else if (!closeMatchTrans) {
								// <- Need to score "open" prior Receives to find the best one (Attempt 3 & 4)
								let openTransactions = giftTransactions.filter(
									(g) =>
										sameClassAndReceiver(g) &&
										earlierDate(g) &&
										!g.tranche &&
										eligibleAsOf(g, d) && // or sendTransaction.date ??
										(notRestricted(g) || !isEDM)
								);
								if (openTransactions.length) {
									// After finding the closest match, clone this Receive as a "Twin" and move on to the next Send for this date
									closeMatchTrans = scoreMatches(sendTransaction, openTransactions);
									console.log('CLOSE Match: ', closeMatchTrans);
									if (closeMatchTrans) {
										// need new object
										closeMatchTrans = JSON.parse(JSON.stringify(closeMatchTrans));
										// giftTransactions = giftTransactions.filter(g => g.nrid != bestMatchTrans.nrid);
										closeMatchTrans.tranche = c + '-' + d;
										if (!closeMatchTrans.before) closeMatchTrans.before = closeMatchTrans.quantity;
										closeMatchTrans.quantity = s.quantity;
										historicHoldings.push(closeMatchTrans);
									}
								}
							}
						}
						// For a close match (not exact), deduct the from the "Twin" the quantity of every Send
						if (closeMatchTrans) {
							let matchTwin = giftTransactions.find((h) => h.nrid == closeMatchTrans.nrid);
							if (!matchTwin.before) matchTwin.before = Number(matchTwin.quantity);
							matchTwin.quantity = Number(matchTwin.quantity) - Number(s.quantity);
							if (carryOverDeduct) {
								matchTwin.quantity += carryOverDeduct;
								carryOverDeduct = 0;
							}
							if (matchTwin.quantity < 0) {
								carryOverDeduct = matchTwin.quantity;
								matchTwin.quantity = 0;
							}
							matchTwin.quantity = matchTwin.quantity.toString();
						}
						closeMatchTrans = null; // reset
					});
				}
			} else if (sameDateReceivers.length < 3 && (sameDateNetQty < 0.1 || sameDateNetAmt < 0.1)) {
				if (sameDateNetQty < 0.1) {
					if (sameDateSenders.sort().toString() != sameDateReceivers.sort().toString()) {
						// Attempt 1 - it's a TRANSFER
						let uniqueSenders = sameDateSenders.filter((u) => !sameDateReceivers.includes(u));
						let uniqueReceivers = sameDateReceivers.filter((u) => !sameDateSenders.includes(u));
						console.log('TRANSFER Transactions: ', uniqueSenders.concat(uniqueReceivers));
					}
					// Attempt 1 - it's a SWAP
					isSwapOrSplit = true;
					parseTransfers();
				} else if (sameDateNetAmt < 0.1) {
					// Attempt 2 - it's a SPLIT
					isSwapOrSplit = true;
					parseTransfers();
				}
			} else {
				// Attempt 2 - it might be a Vermeer-style reissue transfer
				// Look for a pair transaction with the issuer (equal quantity, cancellation/re-issue)
				pairedQty = 0;
				let exactMatch = false;
				// Remove active certificates - NO!!
				// sameDateSends = sameDateSends.filter(s => !activeCertificate(s));
				sameDateSends.forEach((send) => {
					sameDateReceives.forEach((receive) => {
						if (Number(send.quantity) == Number(receive.quantity)) pairedQty += Number(receive.quantity);
					});
				});

				// First try finding old certificates, where each quantity exactly matches one of the Sends
				if (pairedQty && !exactMatch) exactMatch = oneForOneMatches(sameDateSends);

				// Next try to find one old certificate that is an exact match for the collection of Sends
				let exactMatchTrans = giftTransactions.find((g) => sameClassAndReceiver(g) && earlierDate(g) && sameQty(g, sameDateSendQtySum));
				if (exactMatchTrans) {
					giftTransactions = giftTransactions.filter((g) => g.nrid != exactMatchTrans.nrid);
					exactMatchTrans.tranche = c + '-' + d;
					historicHoldings.push(exactMatchTrans);
					// Remove all of the associated send transactions
					let sendTransactions = giftTransactions.filter((g) => sameClassAndSender(g) && thisDateOrEarlier(g));
					sendTransactions.forEach((s) => (s.tranche = c + '-' + d));
					sendTransactions.forEach((adjTrans) => {
						carryForwardBasisFields(adjTrans, exactMatchTrans);
					});
					addPriorTransfers(sendTransactions);
					console.log('SEND Transactions: ', sendTransactions);
					// FIX: only remove the sends we *actually captured*, not everything <= date
					const sendNridSet = new Set(sendTransactions.map((t) => t.nrid).filter(Boolean));
					giftTransactions = giftTransactions.filter((g) => !sendNridSet.has(g.nrid));
					// giftTransactions = giftTransactions.filter(g => !sameClassAndSender(g) || !thisDateOrEarlier(g));
					sameDateReceives.forEach((adjTrans) => {
						carryForwardBasisFields(adjTrans, exactMatchTrans);
					});
					exactMatch = true;
				}

				let handledByParseTransfers = false;

				// If that fails, start rolling up old certificates using stub logic below
				if (pairedQty && !exactMatch) handledByParseTransfers = parseTransfers();

				// It's not a Vermeer-style reissue...
				if (!pairedQty && sameDateReceives.length == 1 && sameDateSends.length > 1) {
					// If net sending (no STUB), bail out.  Not sure how to handle if mult-legged....
					if (sameDateReceiveAmtSum > sameDateSendAmtSum + 1) {
						console.log('NET Receive Amount: ', sameDateReceiveAmtSum - sameDateSendAmtSum);
					}
					// It's a STUB
					console.log('NET Send Amount: ', sameDateSendAmtSum - sameDateReceiveAmtSum);
					handledByParseTransfers = parseTransfers();
				}

				// Finally look for cancel/reissue certificate number
				if (!handledByParseTransfers) canceledCertificate(sameDateSends);
			}

			function matchSameDayByCertificate(sameDateTransactions) {
				const sends = sameDateTransactions.filter((t) => t.sender == giftUserId);
				const receives = sameDateTransactions.filter((t) => t.receiver == giftUserId);

				const usedReceiveNrids = new Set();
				const exactPairs = [];

				sends.forEach((send) => {
					const sendRefs = parseCertificateRefs(send.notes);
					const sendCert = sendRefs.newCert || (sendRefs.sourceCerts?.length == 1 ? sendRefs.sourceCerts[0] : '');
					if (!sendCert) return;

					const match = receives.find((r) => {
						if (usedReceiveNrids.has(r.nrid)) return false;

						const receiveRefs = parseCertificateRefs(r.notes);
						const receiveCert = receiveRefs.newCert || (receiveRefs.sourceCerts?.length == 1 ? receiveRefs.sourceCerts[0] : '');
						if (!receiveCert) return false;

						return receiveCert == sendCert && Number(r.quantity) == Number(send.quantity);
					});

					if (match) {
						usedReceiveNrids.add(match.nrid);
						exactPairs.push({ send, receive: match });
					}
				});

				return exactPairs;
			}

			function isSelfContainedCertificateFlow(transactions) {
				const getSourceCert = (notes) => {
					const match = notes?.match(/from (\d+)/);
					if (match) return match[1];
					const fallback = notes?.match(/\(#?(\d+)/);
					return fallback ? fallback[1] : null;
				};
				let sourceCerts = new Set();
				transactions.forEach((t) => {
					if (t.sender !== 'asplundh') {
						const cert = getSourceCert(t.notes);
						if (cert) sourceCerts.add(cert);
					}
				});
				return sourceCerts.size === 1;
			}

			function releaseRestrictedEquity(sameDaySends) {
				console.log('Begining sameDateSends: ', sameDaySends);
				// First try finding certificates, where each exactly matches one of the Sends
				let nonMatch;
				let matchCount = 0;
				sameDaySends.forEach((send) => {
					if (!toIssuer(send)) return;
					console.log('This Send: ', send);
					let exactMatches = giftTransactions.filter(
						(g) =>
							send.nrid != g.nrid && send.quantity == g.quantity && sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, send.notes)
					);
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					console.log('Very close match: ', exactMatch);
					if (exactMatch) {
						let sendQty = Number(send.quantity);
						let otherSends = giftTransactions.filter((g) => send.nrid != g.nrid && sameClassAndSender(g) && sameDate(g) && !isReleaseLike(g));
						console.log('Other sends: ', otherSends);
						let otherSend = otherSends.length == 1 ? otherSends[0] : scoreDifferences(send, otherSends);
						let otherSendQty = otherSend ? Number(otherSend.quantity) : 0;
						// if (otherSends.length) otherSendQty = otherSends.reduce((sum, g) => sum + Number(g.quantity), 0);

						// Get the other receive tranche, the non-match
						let nonMatches = giftTransactions.filter(
							(g) =>
								g.nrid !== exactMatch.nrid &&
								sameClassAndReceiver(g) &&
								thisDateOrEarlier(g) &&
								eligibleAsOf(g, send.date) &&
								Number(g.quantity) >= sendQty
						);
						if (nonMatches?.length) {
							// handle the nonMatch as new object
							nonMatch = JSON.parse(JSON.stringify(nonMatches.length == 1 ? nonMatches[0] : scoreDifferences(send, nonMatches)));
							let nonMatchQty = Number(nonMatch.quantity);
							// If excess quantity, split the NON MATCH. otherwise remove the NON MATCH from current gift transactions
							if (nonMatchQty < sendQty || otherSendQty > sendQty) return false;
							else {
								let origNonMatch = giftTransactions.find((g) => g.nrid == nonMatch.nrid);
								origNonMatch.quantity = (nonMatchQty - sendQty).toString();
								send.quantity = (sendQty - otherSendQty).toString();
								exactMatch.quantity = send.quantity;
							}

							nonMatch.quantity = sendQty.toString();
							nonMatch.tranche = c + '-' + d;
							historicHoldings.push(nonMatch);

							matchCount++;
							processSendTransaction(send);
							// if (otherSends.length) otherSends.forEach(processSendTransaction);
							if (otherSend) processSendTransaction(otherSend);
						}
					}
				});
				console.log('Ending sameDateSends: ', sameDaySends);
				return matchCount > 0;

				function processSendTransaction(g) {
					g.tranche = c + '-' + d;
					giftTransactions = giftTransactions.filter((x) => x.nrid !== g.nrid);
					carryForwardBasisFields(g, nonMatch);
					addPriorTransfer(g);
					console.log('SEND Transaction: ', g);
					sameDateSends = sameDateSends.filter((s) => s.nrid !== g.nrid);
				}
			}

			function cancelReissueCertificate(sameDateSends) {
				console.log('sameDateSends: ', sameDateSends);
				// First try finding certificates, where each exactly matches one of the Sends
				let matchCount = 0;
				sameDateSends.forEach((send) => {
					if (!toIssuer(send)) return;
					console.log('This Send: ', send);
					let exactMatches = giftTransactions.filter(
						(g) =>
							send.nrid != g.nrid && send.quantity == g.quantity && sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, send.notes)
					);
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					console.log('SAME Certificate: ', exactMatch);
					if (exactMatch) {
						matchCount++;
						send.tranche = c + '-' + d;
						// Remove the SEND from current gift transactions
						giftTransactions = giftTransactions.filter((g) => g.nrid != send.nrid);
						let matches = giftTransactions.filter(
							(g) =>
								send.nrid != g.nrid &&
								send.quantity == g.quantity &&
								sameClassAndReceiver(g) &&
								sameDate(g) &&
								sameCertificate(g.notes, send.notes)
						);
						if (matches.length) {
							// there should only be one match, alert otherwise??
							let match = matches.length == 1 ? matches[0] : scoreMatches(send, matches);
							match.tranche = c + '-' + d;
							// Add the MATCH to historic holdings
							historicHoldings.push(match);
							// Remove the MATCH from current gift transactions
							giftTransactions = giftTransactions.filter((g) => g.nrid != match.nrid);
							carryForwardBasisFields(send, match);
							// Add the SEND to prior transfers
							addPriorTransfer(send);
							console.log('SEND Transaction: ', send);
						}
					}
				});
				return matchCount > 0;
			}

			function canceledCertificate(sameDateSends) {
				// First, see whether this path applies at all
				let foundAny = sameDateSends.some((send) => {
					let exactMatches = giftTransactions.filter(
						(g) =>
							send.quantity == g.quantity &&
							sameClassAndReceiver(g) &&
							earlierDate(g) &&
							eligibleAsOf(g, send.date) &&
							sameCertificate(g.notes, send.notes)
					);
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					return !!exactMatch;
				});

				if (!foundAny) return false;

				// Process the whole send set ONCE
				sameDateSends.forEach((s) => {
					s.tranche = c + '-' + d;
					giftTransactions = giftTransactions.filter((g) => g.nrid != s.nrid);

					let matches = giftTransactions.filter(
						(g) => sameClassAndReceiver(g) && earlierDate(g) && eligibleAsOf(g, s.date) && sameCertificate(g.notes, s.notes)
					);

					if (!matches.length) {
						matches = giftTransactions.filter(
							(g) => s.quantity == g.quantity && sameClassAndReceiver(g) && sameDate(g) && sameCertificate(g.notes, s.notes)
						);
					}

					if (matches.length) {
						let match = matches.length == 1 ? matches[0] : scoreMatches(s, matches);
						match.tranche = c + '-' + d;
						historicHoldings.push(match);
						giftTransactions = giftTransactions.filter((g) => g.nrid != match.nrid);
						carryForwardBasisFields(s, match);
					}
				});

				addPriorTransfers(sameDateSends);
				console.log('SEND Transactions: ', sameDateSends);
				return true;
			}

			function oneForOneMatches(sameDateSends) {
				// First try finding old certificates, where each exactly matches one of the Sends
				let matchCount = 0;
				// need clone of giftTransactions to handle potential duplicate quantities
				let giftClone = JSON.parse(JSON.stringify(giftTransactions));
				if (isEDM) giftClone = giftClone.filter((g) => notRestricted(g));
				sameDateSends.forEach((send) => {
					let exactMatches = giftClone.filter(
						(g) =>
							!activeCertificate(g) &&
							sameClassAndReceiver(g) &&
							earlierDate(g) &&
							eligibleAsOf(g, send.date) &&
							(notRestricted(g) || !isEDM) &&
							sameQty(g, Number(send.quantity))
					);
					let exactMatch = !exactMatches ? null : exactMatches.length == 1 ? exactMatches[0] : scoreMatches(send, exactMatches);
					console.log('EXACT Match: ', exactMatch);
					if (exactMatch) {
						giftClone = giftClone.filter((g) => g.nrid != exactMatch.nrid);
						matchCount++;
					}
				});

				if (moment.unix(Number(d)).utc().format('YYYY-MM-DD') == '2015-04-08' && c == 'C') {
					console.log('AL oneForOne matchCount:', matchCount, 'needed:', sameDateSends.length);
				}

				if (matchCount == sameDateSends.length) {
					sameDateSends.forEach((s) => {
						s.tranche = c + '-' + d;
						giftTransactions = giftTransactions.filter((g) => g.nrid != s.nrid);
						let matches = giftTransactions.filter(
							(g) =>
								!activeCertificate(g) &&
								sameClassAndReceiver(g) &&
								earlierDate(g) &&
								eligibleAsOf(g, s.date) &&
								(notRestricted(g) || !isEDM) &&
								sameQty(g, Number(s.quantity))
						);
						if (matches.length) {
							let match = matches.length == 1 ? matches[0] : scoreMatches(s, matches);
							match.tranche = c + '-' + d;
							historicHoldings.push(match);
							giftTransactions = giftTransactions.filter((g) => g.nrid != match.nrid);
							carryForwardBasisFields(s, match);
						}
					});
					addPriorTransfers(sameDateSends);
					console.log('SEND Transactions: ', sameDateSends);
					return true;
				}
				return false;
			}

			// This method identifies the best combination of Prior Receives to match a collection of Sends
			// It also handles swaps and splits, if identified
			function parseTransfers() {
				let splitRatio = 1;
				if (isSwapOrSplit) {
					splitRatio = sameDateReceiveQtySum / sameDateSendQtySum;
					console.log('SPLIT Ratio: ', splitRatio);
				}
				// If stub, get stub info
				let stubs = sameDateTransactions.filter((b) => b.receiver == giftUserId);
				// let stubMatches = sameDateTransactions.filter(m => sameClassAndSender(m));
				let stubMatches = giftTransactions.filter((m) => sameClassAndSender(m) && sameDate(m));
				// Remove active certificates - Maybe...
				// stubMatches = stubMatches.filter(s => !activeCertificate(s));
				console.log('STUB Transactions: ', stubs);
				console.log('STUB Matches: ', stubMatches);

				// For each re-issue, remove the returned cert(s)
				// Find matching old cert(s), and calculate gross cost
				// Move old cert(s) to Prior list

				let foundGroupFit;
				let priorGrossQty = stubMatches.reduce((a, b) => a + Number(b.quantity), 0);
				let priorGrossCost = stubMatches.reduce((a, b) => a + Number(b.quantity) * toNumber(b.sharePrice), 0);
				let newPrice = priorGrossQty ? priorGrossCost / priorGrossQty : 0;
				console.log('PRIOR grossQty = ' + priorGrossQty);
				console.log('PRIOR grossCost = ' + priorGrossCost);
				console.log('NEW price = ' + newPrice);
				if (!sameDateReceives.length) {
					// Look for perfect match
					// find and remove the prior receive transaction(s) that sum to targetQty
					let priorTrans = giftTransactions.filter((g) => thisDateOrEarlier(g) && sameClassAndReceiver(g));
					priorTrans = priorTrans.filter((p) => eligibleAsOf(p, d));
					// Remove active certificates
					priorTrans = priorTrans.filter((p) => !activeCertificate(p));
					priorTrans.sort((a, b) => (Number(a.date) > Number(b.date) ? -1 : 1)); // newest to oldest
					priorTrans.sort((a, b) => Number(b.quantity) - Number(a.quantity)); // largest to smallest
					console.log('PRIOR Transactions: ', priorTrans);
					minDiff = 999; // reset arbitrarily large starting number used in tranche analysis
					findSubset.callCount = 0;
					let perfectFit = findSubset(priorGrossQty, priorTrans);
					if (perfectFit) {
						foundGroupFit = true;
						console.log('PERFECT Fit: ', perfectFit);
						perfectFit.forEach((p) => (p.tranche = c + '-' + d));
						historicHoldings = historicHoldings.concat(perfectFit);
						let perfectNrids = new Set(perfectFit.map((item) => item.nrid));
						giftTransactions = giftTransactions.filter((g) => !perfectNrids.has(g.nrid));
						priorGrossQty = perfectFit.reduce((acc, val) => acc + Number(val.quantity), 0);
						priorGrossCost = perfectFit.reduce((acc, val) => acc + Number(val.quantity) * toNumber(val.sharePrice), 0);
					} else console.log('no further fit');

					// let thisTransaction = giftTransactions.find(g => g.nrid == trans.nrid);
					// if (thisTransaction) thisTransaction.sharePrice = (priorGrossCost / (isSwapOrSplit ? Number(thisTransaction.quantity) : priorGrossQty)).toString();
					// console.log("ADJUSTED Transaction: ", thisTransaction);
					// return perfectFit ? true : false;
				} else {
					let totalReceived = 0;
					let targetQuantity = priorGrossQty * splitRatio;
					sameDateReceives.forEach((receiveTran) => {
						if (foundGroupFit && totalReceived >= targetQuantity) return;
						// if (foundGroupFit) return; <-- FAILS with Walt at Mazzetti
						if (isSwapOrSplit) {
							priorGrossQty = Number(receiveTran.quantity) / splitRatio;
							console.log('SPLIT grossQty = ' + priorGrossQty);
						}
						if (handlePerfectFit(receiveTran, priorGrossQty, Number(d), isSwapOrSplit)) {
							totalReceived += Number(receiveTran.quantity);
							console.log('TOTAL received = ' + totalReceived);
							receiveTran.tranche = c + '-' + d;
							foundGroupFit = true;
						}
					});
				}
				if (foundGroupFit) {
					// remove all of the associated send transactions
					let sendTransactions = giftTransactions.filter((g) => sameClassAndSender(g) && sameDate(g));
					let sendSum = sendTransactions.reduce((a, b) => a + Number(b.quantity), 0);
					console.log('PRIOR GrossQty = ' + priorGrossQty, ' SEND Sum = ' + sendSum);
					sendTransactions.forEach((s) => (s.tranche = c + '-' + d));
					addPriorTransfers(sendTransactions);
					console.log('SEND Transactions: ', sendTransactions);
					giftTransactions = giftTransactions.filter((g) => !sameClassAndSender(g) || !sameDate(g));
				}
				return foundGroupFit ? true : false;
			}

			// Utility functions
			function toIssuer(trans) {
				return (
					trans.receiver == client ||
					String(trans.receiver || '').toLowerCase() == 'issuer' ||
					String(trans.receiverName || '').toLowerCase() == 'issuer' ||
					itsTreasury(trans.receiver, trans.receiverName)
				);
			}
			function fromIssuer(trans) {
				return (
					trans.sender == client ||
					String(trans.sender || '').toLowerCase() == 'issuer' ||
					String(trans.senderName || '').toLowerCase() == 'issuer' ||
					itsTreasury(trans.sender, trans.senderName)
				);
			}
			function thisDateOrEarlier(trans) {
				return Number(trans.date) <= Number(d);
			}
			function earlierDate(trans) {
				return Number(trans.date) < Number(d);
			}
			function sameDate(trans) {
				return Number(trans.date) == Number(d);
			}
			function sameQty(trans, qty) {
				return Number(trans.quantity) == qty;
			}
			function areSimilar(a, b) {
				const setA = new Set(a.toLowerCase());
				const setB = new Set(b.toLowerCase());
				const overlap = [...setA].filter((c) => setB.has(c)).length;
				const avgLen = (setA.size + setB.size) / 2;
				return overlap / avgLen > 0.6; // tweak threshold as needed
			}
			function isReleaseLike(trans) {
				const s = trans.notes;
				if (!s) return false;
				const t = s.toLowerCase();
				// specific phrase first
				if (/release\s+of\s+unvested\s+shares\s+granted/.test(t)) return true;
				// broader release signal
				if (t.includes('release') && (t.includes('unvested') || t.includes('restricted'))) return true;
				return false;
			}

			// Check historicHoldings for negative quantities
			historicHoldings.forEach((h, i) => {
				if (Number(h.quantity) < 0) alert(`Negative quantity in historicHoldings[${i}]:`, h);
			});

			// Check giftTransactions for negative quantities
			giftTransactions.forEach((g, i) => {
				if (Number(g.quantity) < 0) alert(`Negative quantity in giftTransactions[${i}]:`, g);
			});
		});

		function allocateCarryOver() {
			let remaining = -carryOverDeduct; // Make positive for internal logic
			while (remaining > 0.0001) {
				// Step 1: get valid candidates with quantity > 0
				const candidates = giftTransactions.filter((gt) => {
					const qty = Number(gt.quantity);
					return !isNaN(qty) && qty > 0 && eligibleAsOf(gt, gt.date || 0);
				});

				// Step 2: pick tranche already being reduced
				let target = candidates.find((gt) => Number(gt.before) > Number(gt.quantity));

				// Step 3: otherwise pick by lowest basis + oldest date
				if (!target) {
					candidates.sort((a, b) => {
						const basisA = isKnownNumber(a._effectiveTaxBasis) ? Number(a._effectiveTaxBasis) : Infinity;
						const basisB = isKnownNumber(b._effectiveTaxBasis) ? Number(b._effectiveTaxBasis) : Infinity;
						if (basisA !== basisB) return basisA - basisB;
						return Number(a.date || 0) - Number(b.date || 0);
					});
					target = candidates[0];
				}

				if (!target) break; // Nothing valid left

				// Initialize .before if not already set
				if (target.before == null) target.before = Number(target.quantity);

				const qty = Number(target.quantity);
				const deductNow = Math.min(remaining, qty);

				target.quantity = (qty - deductNow).toFixed(6).replace(/\.?0+$/, '');
				remaining -= deductNow;
			}
		}

		// Must account for any remaining carryOverDeduct
		if (carryOverDeduct) allocateCarryOver();

		// For Edmund Optics, never include SARS, RSGs, or Awards
		if (isEDM) giftTransactions = giftTransactions.filter((g) => notRestricted(g));

		function carryForwardBasisFields(targetTrans, sourceTrans) {
			if (!sourceTrans) return;
			if (!isKnownNumber(targetTrans.sharePrice) && isKnownNumber(sourceTrans.sharePrice)) targetTrans.sharePrice = sourceTrans.sharePrice;
			if (!isKnownNumber(targetTrans.taxBasis)) {
				if (isKnownNumber(sourceTrans.taxBasis)) targetTrans.taxBasis = sourceTrans.taxBasis;
				else if (isKnownNumber(sourceTrans._effectiveTaxBasis)) targetTrans.taxBasis = Number(sourceTrans._effectiveTaxBasis).toString();
			}
			let basis = resolveEffectiveTaxBasis(targetTrans, clientData);
			targetTrans._effectiveTaxBasis = basis.value;
			targetTrans._basisSource = basis.source;
			console.log('ADJUSTED Transaction: ', targetTrans);
		}

		// This method looks for one or more prior transactions specified precisely in the send description
		function handleDescriptionMatch(trans, targetQty, date) {
			let priorTrans = giftTransactions.filter((g) => Number(g.date) <= date && sameClassAndReceiver(g));
			priorTrans = priorTrans.filter((p) => eligibleAsOf(p, date));

			// NEW: explicit source-cert handling
			const explicitSourceCerts = getExplicitSourceCertSet(trans.notes);
			if (explicitSourceCerts) {
				let certMatches = priorTrans.filter((p) => {
					const lotCert = getLotCertToken(p.notes);
					return lotCert && explicitSourceCerts.has(lotCert);
				});

				if (certMatches.length) {
					console.log('CERT LIST MATCHES:', certMatches);

					let remainingTarget = Number(targetQty) || 0;
					const stagedItems = [];
					const stagedUpdates = [];

					certMatches.sort((a, b) => Number(a.date) - Number(b.date));

					certMatches.forEach((match) => {
						if (remainingTarget <= 0) return;

						const priorGrossQty = Number(match.quantity) || 0;
						const consumeQty = Math.min(remainingTarget, priorGrossQty);

						stagedItems.push({
							...match,
							tranche: c + '-' + trans.date,
							quantity: consumeQty.toString(),
						});

						stagedUpdates.push({
							nrid: match.nrid,
							remaining: priorGrossQty - consumeQty,
						});

						remainingTarget -= consumeQty;
					});

					// IMPORTANT: commit only if the explicit cert list fully satisfies the send
					if (remainingTarget <= 0) {
						historicHoldings = historicHoldings.concat(stagedItems);

						stagedUpdates.forEach((u) => {
							if (u.remaining <= 0) {
								giftTransactions = giftTransactions.filter((g) => g.nrid != u.nrid);
							} else {
								const idx = giftTransactions.findIndex((g) => g.nrid == u.nrid);
								if (idx >= 0) giftTransactions[idx].quantity = u.remaining.toString();
							}
						});

						let thisTransaction = giftTransactions.find((g) => g.nrid == trans.nrid);
						if (thisTransaction) carryForwardBasisFields(thisTransaction, certMatches[0]);
						return true;
					}

					// If cert-linked lots are insufficient, do NOTHING here and let later logic handle it
					return false;
				}
			}

			// EXISTING behavior for simpler notes
			let notesMatch = findNotesMatch(trans.notes, priorTrans);
			if (notesMatch) {
				console.log('NOTES MATCH: ', notesMatch);

				const priorGrossQty = Number(notesMatch.quantity) || 0;
				const consumeQty = Math.min(Number(targetQty) || 0, priorGrossQty);

				// Clone BEFORE pushing so we don't mutate the pushed reference
				const trancheItem = {
					...notesMatch,
					tranche: c + '-' + trans.date,
					quantity: consumeQty.toString(),
				};
				// Immutable List -> reassign
				historicHoldings.push(trancheItem);

				// Update/remove the ORIGINAL in giftTransactions
				const remaining = priorGrossQty - consumeQty;
				if (remaining <= 0) {
					giftTransactions = giftTransactions.filter((g) => g.nrid != notesMatch.nrid);
				} else {
					const idx = giftTransactions.findIndex((g) => g.nrid == notesMatch.nrid);
					if (idx >= 0) giftTransactions[idx].quantity = remaining.toString();
				}

				// Carry price to the current transaction
				let thisTransaction = giftTransactions.find((g) => g.nrid == trans.nrid);
				if (thisTransaction) carryForwardBasisFields(thisTransaction, notesMatch);
				return true;
			}

			console.log('no notes match');
			return false;
		}

		function getExplicitSourceCertSet(notesText) {
			const refs = parseCertificateRefs(notesText);
			return refs.sourceCerts?.length ? new Set(refs.sourceCerts) : null;
		}

		function getLotCertToken(notesText) {
			const refs = parseCertificateRefs(notesText);

			// For old lots like "Issuance (Cert 0002475)", use the cert on the lot itself
			if (refs.newCert) return refs.newCert;

			// If somehow the lot only parses as a single source cert, allow that too
			if (refs.sourceCerts?.length == 1) return refs.sourceCerts[0];

			return '';
		}

		function findNotesMatch(transNotes, priorTrans) {
			console.log('transNotes', transNotes);

			const tn = String(transNotes || '').trim();
			const tnLower = tn.toLowerCase();

			// --- HARD GATE ---
			// Only allow description-match logic when the notes explicitly look like " ... from ... "
			// This prevents accidental substring matches on busy accounts.
			//
			// Accepts:
			// - " ... from ... "
			// - " ... from: ... "
			// - " ... from - ... "
			//
			// Rejects:
			// - notes that merely contain the prior note text but don't explicitly say "from ..."
			const hasFromPhrase = /\bfrom\b\s*[:\-]?\s+\S+/i.test(tn);
			if (!hasFromPhrase) {
				console.log("findNotesMatch: skipping (no '... from ...' phrase)");
				return false;
			}

			function extractPossibleDate(str) {
				if (!str) return null;
				const dateRegex = /(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\.?\s*\d{1,2},?\s*\d{2,4}|\b\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}\b/i;
				const match = str.match(dateRegex);
				return match ? match[0] : null;
			}

			const possibleDateString = extractPossibleDate(tn);
			const transMoment = possibleDateString ? moment(possibleDateString, dateFormats, true) : null;

			for (const t of priorTrans) {
				if (!t || !t.notes || !t.date) continue;

				const priorNotes = String(t.notes || '').trim();
				if (!priorNotes) continue;

				// Keep your original "notes contain prior notes" behavior
				const notesHit = tnLower.includes(priorNotes.toLowerCase());
				if (!notesHit) continue;

				let dateMatch = true; // allow notes-only when no parseable date
				if (transMoment && moment.unix(Number(t.date)).utc().isValid()) {
					const tMoment = moment.unix(Number(t.date)).utc();
					dateMatch = tMoment.isSame(transMoment, 'day');
				}

				if (dateMatch) {
					console.log('Matched prior transaction:', t);
					return t; // <- returns a single OBJECT
				}
			}

			return false;
		}

		// true if this prior lot is eligible to be consumed as-of "asOfSec"
		// true if this prior lot is eligible to be consumed as-of "asOf"
		function eligibleAsOf(priorLot, asOf) {
			const u = priorLot?._useAfter;
			if (!u) return true;
			if (u === 'LOCK') return false;

			const asOfSec = Number(asOf);
			const useAfterSec = Number(u);

			if (!Number.isFinite(asOfSec) || !Number.isFinite(useAfterSec)) return false;

			return asOfSec >= useAfterSec;
		}

		function normalizeCertToken(token) {
			let s = String(token || '')
				.trim()
				.toUpperCase();
			if (!s) return '';

			s = s.replace(/[.\-_:\/\\•|\s#]/g, '');

			let m = s.match(/^([A-Z]*)(\d+)$/);
			if (m) return m[1] + (m[2].replace(/^0+/, '') || '0');

			s = s.replace(/^0+(\d)/, '$1');
			return s;
		}

		function parseCertificateRefs(notesText) {
			const s = String(notesText || '');
			const result = {
				newCert: '',
				sourceCerts: [],
			};

			// First cert inside parens is often the new cert
			// e.g. Transfer (#15954 from ...)
			let m = s.match(/\((?:cert\s*)?#?\s*([A-Za-z]*0*\d+)/i);
			if (m && m[1]) result.newCert = normalizeCertToken(m[1]);

			// Anything after "from" is a source list
			// e.g. from 14479, 14506, 14507
			m = s.match(/\bfrom\b(.*?)(?:\)|$)/i);
			if (m && m[1]) {
				result.sourceCerts = m[1]
					.split(',')
					.map((part) => {
						const mm = part.match(/([A-Za-z]*0*\d+)/);
						return mm && mm[1] ? normalizeCertToken(mm[1]) : '';
					})
					.filter(Boolean);
			}

			// Fallback for simple cases like Cancellation (0006620)
			if (!result.newCert && !result.sourceCerts.length) {
				m = s.match(/\((?:cert\s*)?#?\s*([A-Za-z]*0*\d+)\)/i);
				if (m && m[1]) result.newCert = normalizeCertToken(m[1]);
			}

			return result;
		}

		function sameCertificate(transNotes, notes) {
			if (!CERT_COLUMN) return areSimilar(transNotes, notes);

			// PRIOR EFFORTS
			// console.log("transNotes", (transNotes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2])
			// console.log("notes", (notes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2])
			// return (transNotes.match(/\((\d+)\)/) || [])[1] == (notes.match(/\((\d+)\)/) || [])[1];
			// if ((transNotes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2] == (notes.match(/\(([^)]*?(\d+)[^)]*?)\)/) || [])[2]) {
			// 	console.log("***MATCH***");
			// 	return true;
			// } else return false;

			// NEW WORKING SOLUTION
			// Extract a "certificate token" from the first (...) group:
			// - Must contain at least one digit (prevents matching "(Cancelled)" etc.)
			// - Allows: . - _ : / \ •
			// - Token can be letters+digits with allowed separators anywhere

			const a = parseCertificateRefs(transNotes);
			const b = parseCertificateRefs(notes);

			console.log('CERT PARSE:', { a, b });

			// Best case: overlap of source cert lists
			if (a.sourceCerts.length || b.sourceCerts.length) {
				const aSet = new Set(a.sourceCerts.length ? a.sourceCerts : a.newCert ? [a.newCert] : []);
				const bSet = new Set(b.sourceCerts.length ? b.sourceCerts : b.newCert ? [b.newCert] : []);

				for (const cert of aSet) {
					if (bSet.has(cert)) {
						console.log('***MATCH via source overlap***');
						return true;
					}
				}
				return false;
			}

			// Simple fallback: compare single certs
			if (a.newCert && b.newCert && a.newCert == b.newCert) {
				console.log('***MATCH via single cert***');
				return true;
			}

			return false;
		}

		// This method takes a given Send and tries to find a collection of Prior Receives that fits perfectly
		function handlePerfectFit(trans, targetQty, date, isSwapOrSplit) {
			// Look for perfect match
			let priorGrossQty = 0;
			let priorGrossCost = 0;
			// find and remove the prior receive transaction(s) that sum to targetQty
			let priorTrans = giftTransactions.filter((g) => Number(g.date) <= date && sameClassAndReceiver(g));
			priorTrans = priorTrans.filter((p) => eligibleAsOf(p, date));
			// Remove active certificates
			priorTrans = priorTrans.filter((p) => !activeCertificate(p));
			// Remove restricted stock
			if (isEDM) priorTrans = priorTrans.filter((p) => !p.notes.startsWith('Restricted'));
			// Sort according to priority
			if (isVERM)
				priorTrans.sort((a, b) => (Number(a.date) > Number(b.date) ? 1 : -1)); // oldest to newest
			else {
				priorTrans.sort((a, b) => (Number(a.date) > Number(b.date) ? -1 : 1)); // newest to oldest
				priorTrans.sort((a, b) => Number(b.quantity) - Number(a.quantity)); // largest to smallest
			}
			console.log('PRIOR Transactions: ', priorTrans);
			// first try with only older transactions
			minDiff = 999; // reset arbitrarily large starting number used in tranche analysis
			findSubset.callCount = 0;
			let perfectFit = findSubset(
				targetQty,
				priorTrans.filter((g) => Number(g.date) < date)
			);
			// now include same-date transactions
			minDiff = 999; // reset arbitrarily large starting number used in tranche analysis
			findSubset.callCount = 0;
			if (!perfectFit) perfectFit = findSubset(targetQty, priorTrans);
			if (perfectFit) {
				console.log('PERFECT Fit: ', perfectFit);
				perfectFit.forEach((p) => (p.tranche = c + '-' + trans.date));
				historicHoldings = historicHoldings.concat(perfectFit);
				let perfectNrids = new Set(perfectFit.map((item) => item.nrid));
				giftTransactions = giftTransactions.filter((g) => !perfectNrids.has(g.nrid));
				priorGrossQty = perfectFit.reduce((acc, val) => acc + Number(val.quantity), 0);
				priorGrossCost = perfectFit.reduce((acc, val) => acc + Number(val.quantity) * toNumber(val.sharePrice), 0);
			} else console.log('no further fit');

			let thisTransaction = giftTransactions.find((g) => g.nrid == trans.nrid);
			if (thisTransaction) thisTransaction.sharePrice = (priorGrossCost / (isSwapOrSplit ? Number(thisTransaction.quantity) : priorGrossQty)).toString();
			console.log('ADJUSTED Transaction: ', thisTransaction);
			return perfectFit ? true : false;
		}

		// This subroutine finds a subset of Receives that sum exactly to a target quantity
		function findSubset(targetQty, priorTrans, subset = [], index = 0, currentSum = 0) {
			if (!findSubset.callCount) findSubset.callCount = 0;
			findSubset.callCount++;
			if (findSubset.callCount > 500000) return null; // hard stop

			// tolerate tiny decimal noise
			if (Math.abs(currentSum - targetQty) < 0.000001) return subset;

			let diff = Math.abs(targetQty - currentSum);
			if (diff < minDiff) {
				minDiff = diff;
				diffCount = 0;
				console.log('minDiff = ' + minDiff);
			}
			diffCount++;

			if (diff < 1 && diffCount > 99) return subset;

			if (currentSum > targetQty || index >= priorTrans.length) return null;

			let qty = Number(priorTrans[index].quantity) || 0;

			let includeCurrent = findSubset(targetQty, priorTrans, [...subset, priorTrans[index]], index + 1, currentSum + qty);
			if (includeCurrent) return includeCurrent;

			return findSubset(targetQty, priorTrans, subset, index + 1, currentSum);
		}

		// This method scores potential matches, and returns the one with the highest score
		function scoreMatches(transfer, historics) {
			let bestMatch;
			let bestScore = 0;
			if (historics.length) bestMatch = historics[0];
			historics.forEach((h) => {
				let score = areSimilar(transfer.notes, h.notes);
				if (transfer.sharePrice == h.sharePrice) score += 3;
				if (transfer.quantity == h.quantity) score += 7;
				if (transfer.notes.toLowerCase().includes(h.notes.toLowerCase())) score += 5;
				if (Number(transfer.sharePrice) < Number(h.sharePrice)) score = 0;
				if (Number(h.quantity) > Number(transfer.quantity)) score += 1;
				if (Number(h.quantity) < Number(transfer.quantity)) score = 0;
				if (Number(transfer.date) < Number(h.date)) score = 0;
				// if (activeCertificate(h)) score = 0;
				if (score > bestScore) {
					bestScore = score;
					bestMatch = h;
				}
			});
			return bestMatch;
		}

		function scoreDifferences(transfer, historics) {
			let bestMatch;
			let bestScore = -Infinity; // allow 0 scores
			if (historics.length) bestMatch = historics[0];

			historics.forEach((h) => {
				let score = areSimilar(transfer.notes, h.notes);
				if (score > 0.9) score = 0; // handle EO Releases

				// Extract dates from notes
				const transferNoteDate = extractDate(transfer.notes);
				const historicNoteDate = extractDate(h.notes);

				// Strongly prefer a note-date ≈ record .date
				const dateBoost =
					(transferNoteDate && isCloseInTime(transferNoteDate, h.date) ? 1.0 : 0) +
					(historicNoteDate && isCloseInTime(historicNoteDate, transfer.date) ? 0.5 : 0);

				// Small bonus if share prices match (helps pick the Grant @ 318.03)
				const priceBoost = +transfer.sharePrice && +h.sharePrice && Math.abs(+transfer.sharePrice - +h.sharePrice) < 0.005 ? 0.5 : 0;

				// Down-weight loose text similarity; up-weight structured signals
				const totalScore = score * 0.3 + dateBoost + priceBoost;

				if (totalScore > bestScore) {
					bestScore = totalScore;
					bestMatch = h;
				}
			});

			return bestMatch;

			// Extract timestamp (ms) from note string if any recognizable date found
			function extractDate(text) {
				const match = text.match(/(\d{1,4}[\/\-]\d{1,2}[\/\-]\d{1,4}|\w{3} \d{1,2}, \d{4})/);
				if (match) {
					const m = moment(match[0], dateFormats, true);
					if (m.isValid()) return m.valueOf(); // ms since epoch
				}
				return null;
			}

			// True if two dates are within ±5 days (input: ms, seconds)
			function isCloseInTime(msFromNote, dateStampSeconds) {
				const dateFromItem = Number(dateStampSeconds) * 1000;
				const delta = Math.abs(msFromNote - dateFromItem);
				return delta <= 5 * 24 * 60 * 60 * 1000; // ±5 days in ms
			}
		}

		// !!! THESE 'NEW AND IMPROVED' FUNCTIONS BREAK MARISA'S ANALYSIS !!!
		// ● keep existing sharePrice logic intact
		// ● harden price checks so unknown ≠ 0
		// ● add only mild taxBasis bumps
		// ● do not let taxBasis become a gate or disqualifier

		// ● preserves your old weighting
		// ● preserves the old sharePrice gate
		// ● but only applies it when both prices are actually known
		// ● adds just a small taxBasis bump
		function scoreMatches_NEW(transfer, historics) {
			let bestMatch;
			let bestScore = 0;
			if (historics.length) bestMatch = historics[0];
			historics.forEach((h) => {
				let score = areSimilar(transfer.notes, h.notes);
				const transferHasPrice = isKnownNumber(transfer.sharePrice);
				const historicHasPrice = isKnownNumber(h.sharePrice);
				const transferHasBasis = isKnownNumber(transfer.taxBasis);
				const historicHasBasis = isKnownNumber(h.taxBasis);
				if (transferHasPrice && historicHasPrice && Number(transfer.sharePrice) == Number(h.sharePrice)) score += 3;
				if (transfer.quantity == h.quantity) score += 7;
				if (transfer.notes.toLowerCase().includes(h.notes.toLowerCase())) score += 5;
				// Mild bump for matching tax basis (never a gate)
				if (transferHasBasis && historicHasBasis && Math.abs(Number(transfer.taxBasis) - Number(h.taxBasis)) < 0.005) score += 1;
				// Preserve old intent, but only when both prices are actually known
				if (transferHasPrice && historicHasPrice && Number(transfer.sharePrice) < Number(h.sharePrice)) score = 0;
				if (Number(h.quantity) > Number(transfer.quantity)) score += 1;
				if (Number(h.quantity) < Number(transfer.quantity)) score = 0;
				if (Number(transfer.date) < Number(h.date)) score = 0;
				// if (activeCertificate(h)) score = 0;
				if (score > bestScore) {
					bestScore = score;
					bestMatch = h;
				}
			});
			return bestMatch;
		}

		// ● keeps the price bump modest
		// ● adds an even smaller basis bump
		// ● still lets structured date signals dominate
		function scoreDifferences_NEW(transfer, historics) {
			let bestMatch;
			let bestScore = -Infinity; // allow 0 scores
			if (historics.length) bestMatch = historics[0];
			historics.forEach((h) => {
				let score = areSimilar(transfer.notes, h.notes);
				if (score > 0.9) score = 0; // handle EO Releases
				// Extract dates from notes
				const transferNoteDate = extractDate(transfer.notes);
				const historicNoteDate = extractDate(h.notes);
				// Strongly prefer a note-date ≈ record .date
				const dateBoost =
					(transferNoteDate && isCloseInTime(transferNoteDate, h.date) ? 1.0 : 0) +
					(historicNoteDate && isCloseInTime(historicNoteDate, transfer.date) ? 0.5 : 0);
				const transferHasPrice = isKnownNumber(transfer.sharePrice);
				const historicHasPrice = isKnownNumber(h.sharePrice);
				const transferHasBasis = isKnownNumber(transfer.taxBasis);
				const historicHasBasis = isKnownNumber(h.taxBasis);
				// Small bonus if share prices match
				const priceBoost = transferHasPrice && historicHasPrice && Math.abs(Number(transfer.sharePrice) - Number(h.sharePrice)) < 0.005 ? 0.5 : 0;
				// Very mild bonus if tax basis also matches
				const basisBoost = transferHasBasis && historicHasBasis && Math.abs(Number(transfer.taxBasis) - Number(h.taxBasis)) < 0.005 ? 0.25 : 0;
				// Down-weight loose text similarity; up-weight structured signals
				const totalScore = score * 0.3 + dateBoost + priceBoost + basisBoost;
				if (totalScore > bestScore) {
					bestScore = totalScore;
					bestMatch = h;
				}
			});
			return bestMatch;

			// Extract timestamp (ms) from note string if any recognizable date found
			function extractDate(text) {
				const match = text.match(/(\d{1,4}[\/\-]\d{1,2}[\/\-]\d{1,4}|\w{3} \d{1,2}, \d{4})/);
				if (match) {
					const m = moment(match[0], dateFormats, true);
					if (m.isValid()) return m.valueOf(); // ms since epoch
				}
				return null;
			}

			// True if two dates are within ±5 days (input: ms, seconds)
			function isCloseInTime(msFromNote, dateStampSeconds) {
				const dateFromItem = Number(dateStampSeconds) * 1000;
				const delta = Math.abs(msFromNote - dateFromItem);
				return delta <= 5 * 24 * 60 * 60 * 1000; // ±5 days in ms
			}
		}

		// Character overlap similarity (basic fuzzy match)
		function areSimilar(a, b) {
			const setA = new Set(a.toLowerCase());
			const setB = new Set(b.toLowerCase());
			const overlap = [...setA].filter((c) => setB.has(c)).length;
			const avgLen = (setA.size + setB.size) / 2;
			return overlap / avgLen;
		}

		function notRestricted(trans) {
			const note = trans.notes?.toLowerCase() || '';
			return !['restricted stock grant', 'stock award', 'appreciation rights grant'].some((term) => note.includes(term));
		}

		function activeCertificate(trans) {
			return /\(.*?#.*?\)/.test(trans.notes);
		}

		function sameClassAndSender(trans) {
			return trans.shareClass == c && trans.sender == giftUserId;
		}

		function sameClassAndReceiver(trans) {
			return trans.shareClass == c && trans.receiver == giftUserId;
		}
	});

	let filterViewGT = document.getElementById('filterViewGiftTrans');

	stringOptions = m0;
	if (document.getElementById('showDecimals').checked) stringOptions = m2;

	if (true) {
		//includedClasses.length <= 1) {
		document.getElementById('filterWrapViewGiftTrans').style.display = 'none';
	} else {
		document.getElementById('filterWrapViewGiftTrans').style.display = 'block';
		let labelViewGT = document.getElementById('labelViewGiftTrans');
		if (labelViewGT) labelViewGT.innerHTML = clientData.use_real_estate_language ? 'Property' : UFL ? 'Fund' : 'Share&nbsp;Class';

		if (isJMS || isACC) selectedClass = classes[0];
		else includedClasses.unshift('ALL');

		filterViewGT.innerHTML = `
			<option value="" disabled selected>Select</option>
			${includedClasses
				.map(
					(className, index) =>
						`
					<option ${index == 0 ? 'selected' : ''} value="${className}">${className}</option>
				`
				)
				.join('')}
			<label>Fund</label>

		`;
	}

	let treasuryId;
	let giftSources;
	let lastCertNum;
	let nextCertNum;
	let recipientId;
	let recipientName;
	let currentTranche;
	let originalLastCertNum;

	let holders = [];
	let gifts = [' '];
	let theseGifts = {};
	const NEW_CODE = true;
	let trancheAutoTimers = {};
	theseGifts[' '] = ['', '', ,];

	let recipientSearchData = [];
	let recipientSearchIndex = -1;
	let recipientSearchMatches = [];

	// Remove giftTransactions with quantity == 0;  <-- NO !!
	// giftTransactions = giftTransactions.filter(g => g.quantity != "0");

	// In dataOnly mode, apply sorting and tranche letters, then return data
	if (dataOnly) {
		console.log('giftTransfer: dataOnly mode - sorting and assigning tranches for', shareholder);

		// Sort: non-zero quantities first, then zero quantities (same as renderUserGiftTransModal)
		let nonZero = giftTransactions.filter((t) => Number(t.quantity) != 0);
		let zeroQty = giftTransactions.filter((t) => Number(t.quantity) == 0).sort((a, b) => Number(b.date) - Number(a.date));
		giftTransactions = sortByClassThenBasisThenDateThenQty(nonZero).concat(zeroQty);
		historicHoldings = sortByClassThenBasisThenDateThenQty(historicHoldings);
		priorTransfers = sortByClassThenBasisThenDateThenQty(priorTransfers);

		// Sort historicHoldings by tranche (class-date format)
		historicHoldings.sort((a, b) => {
			if (!a.tranche || !b.tranche) return 0;
			let [classA, dateA] = a.tranche.toString().split('-');
			let [classB, dateB] = b.tranche.toString().split('-');
			dateA = Number(dateA);
			dateB = Number(dateB);
			if (dateA < dateB) return 1;
			if (dateA > dateB) return -1;
			if (classA < classB) return -1;
			if (classA > classB) return 1;
			return 0;
		});

		// Assign tranche letters (A, B, C, etc.) - same logic as renderUserGiftTransModal
		let letterCount = 0;
		giftTransactions.forEach(function (h) {
			let trancheLetter = numberToLetters(letterCount);
			if (!h.tranche || h.tranche.length > 3) {
				h.tranche = trancheLetter;
				letterCount++;
			}
			if (!h.before) h.before = h.quantity;
		});
		historicHoldings.forEach(function (h) {
			let trancheLetter = numberToLetters(letterCount);
			if (!h.tranche) {
				h.tranche = trancheLetter;
				letterCount++;
			} else if (h.tranche.length > 3) {
				let timeStamp = h.tranche;
				historicHoldings.forEach((k) => {
					if (k.tranche == timeStamp) {
						k.tranche = trancheLetter;
					}
				});
				priorTransfers.forEach((p) => {
					if (p.tranche == timeStamp) p.tranche = trancheLetter;
				});
				letterCount++;
			}
			if (!h.before) h.before = h.quantity;
		});

		console.log('giftTransfer: dataOnly mode - returning', giftTransactions.length, 'transactions');
		return {
			giftTransactions: JSON.parse(JSON.stringify(giftTransactions)),
			historicHoldings: JSON.parse(JSON.stringify(historicHoldings)),
			priorTransfers: JSON.parse(JSON.stringify(priorTransfers)),
			origTransactions: JSON.parse(JSON.stringify(origTransactions)),
		};
	}

	if (giftTransactions.length > 0 || NEW_CODE) showFilteredGiftTrans();

	function showFilteredGiftTrans() {
		console.log('origTransactions: ', origTransactions);
		console.log('giftTransactions: ', giftTransactions);
		console.log('historicHoldings: ', historicHoldings);
		console.log('priorTransfers: ', priorTransfers);
		// let filteredTransactions = isMAZ ? giftTransactions : origTransactions;
		let filteredTransactions = NEW_CODE ? giftTransactions.concat(historicHoldings).concat(priorTransfers) : origTransactions;
		filteredTransactions = filteredTransactions.filter(
			(t) => !(clientData.equity[t.shareClass] && clientData.equity[t.shareClass].hasOwnProperty('interestRate'))
		);
		if (selectedClass && selectedClass != 'ALL') {
			filteredTransactions = filteredTransactions.filter(function (item) {
				if (item.shareClass) return item.shareClass == selectedClass;
				else return true;
			});
		}
		renderUserGiftTransModal(filteredTransactions);
	}

	function renderUserGiftTransModal(filteredGiftTransactions) {
		// Put giftTransactions with quantityu == "0" at the end
		let nonZero = filteredGiftTransactions.filter((t) => Number(t.quantity) != 0);
		let zeroQty = filteredGiftTransactions.filter((t) => Number(t.quantity) == 0).sort((a, b) => Number(b.date) - Number(a.date));

		filteredGiftTransactions = sortByClassThenBasisThenDateThenQty(nonZero).concat(zeroQty);

		// Compile list of reference prices from Valuations
		let referenceVals = [];
		classes.forEach(function (c) {
			let clientEquity = clientData.equity[c];
			if (clientEquity) {
				if (clientEquity.valuations) {
					clientEquity.valuations.forEach(function (v) {
						let ref = {
							class: c,
							date: v.date,
							price: v.sharePrice,
							ref: v.referencePrice,
						};
						referenceVals.push(ref);
					});
				}
				if (clientEquity.transactions) CERT_COLUMN ||= clientEquity.transactions.some((t) => t.notes.includes('#'));
			}
		});

		// insert reference price if available
		let ttlTrans = 0;
		Object.keys(filteredGiftTransactions).forEach(function (trans, i) {
			let t = filteredGiftTransactions[trans];
			let refPrice = referenceVals.find(
				(v) => v.class == t.shareClass && Number(v.price) == Number(t.sharePrice) && Math.abs(Number(v.date) - Number(t.date)) <= 2 * 86400
			);
			if (refPrice) filteredGiftTransactions[i].referencePrice = refPrice.ref;
			ttlTrans += filteredGiftTransactions[i].receiver == shareholder ? Number(filteredGiftTransactions[i].quantity) : 0;
		});

		console.log(filteredGiftTransactions.filter((t) => !t.receiver));

		// Put giftTransactions with quantityu == "0" at the end
		nonZero = giftTransactions.filter((t) => Number(t.quantity) != 0);
		zeroQty = giftTransactions.filter((t) => Number(t.quantity) == 0).sort((a, b) => Number(b.date) - Number(a.date));

		giftTransactions = sortByClassThenBasisThenDateThenQty(nonZero).concat(zeroQty);
		historicHoldings = sortByClassThenBasisThenDateThenQty(historicHoldings);
		priorTransfers = sortByClassThenBasisThenDateThenQty(priorTransfers);
		historicHoldings.sort((a, b) => {
			let [classA, dateA] = a.tranche.split('-');
			let [classB, dateB] = b.tranche.split('-');
			dateA = Number(dateA);
			dateB = Number(dateB);
			if (dateA < dateB) return 1;
			if (dateA > dateB) return -1;
			if (classA < classB) return -1;
			if (classA > classB) return 1;
			return 0;
		});
		historicHoldings.sort((a, b) => {
			a.tranche > b.tranche ? -1 : 1;
		});
		console.log('POST giftTransactions: ', giftTransactions);
		console.log('POST historicHoldings: ', historicHoldings);
		console.log('POST priorTransfers: ', priorTransfers);

		let letterCount = 0;
		giftTransactions.forEach(function (h, i) {
			let trancheLetter = numberToLetters(letterCount);
			if (!h.tranche || h.tranche.length > 3) {
				h.tranche = trancheLetter;
				letterCount++;
			}
			if (!h.before) h.before = h.quantity;
		});
		historicHoldings.forEach(function (h, i) {
			let trancheLetter = numberToLetters(letterCount);
			if (!h.tranche) {
				h.tranche = trancheLetter;
				letterCount++;
			} else if (h.tranche.length > 3) {
				let timeStamp = h.tranche;
				historicHoldings.forEach((k) => {
					if (k.tranche == timeStamp) {
						k.tranche = trancheLetter;
					}
				});
				priorTransfers.forEach((p) => {
					if (p.tranche == timeStamp) p.tranche = trancheLetter;
				});
				letterCount++;
			}
			if (!h.before) h.before = h.quantity;
		});

		// If there remain unmatched prior transfers, start assigning them to tranches with the highest tax basis
		priorTransfers.forEach(function (p, i) {
			if (!p.tranche && nthAdmin) alert('Unmatched Prior Transfer: ' + JSON.stringify(p));
		});

		let ttlPrior = 0;
		let ttlHist = 0;
		priorTransfers.forEach((p) => (ttlPrior += Number(p.quantity)));
		historicHoldings.forEach((h) => (ttlHist += Number(h.quantity)));

		priorTransfers = priorTransfers.sort((a, b) => (a.tranche < b.tranche ? -1 : 1));
		stringOptions = isTBC ? m6 : m5;
		if (CERT_COLUMN) {
			// insert certificate number if available
			filteredGiftTransactions.forEach(function (f, index) {
				let certNumber = '';
				if (f.notes) {
					certNumber = getCertNumber(f.notes);
				}
				if (certNumber && certNumber[2]) {
					filteredGiftTransactions[index].certNumber = certNumber[2];
					let certSort = certNumber[2].split('-')[1];
					filteredGiftTransactions[index].certSort = Number((certSort ? certSort : certNumber[2]).replace(/[^\d.]/g, ''));
				} else {
					filteredGiftTransactions[index].certNumber = '';
					filteredGiftTransactions[index].certSort = 0;
				}
			});
			historicHoldings.sort((a, b) => (a.certSort < b.certSort ? -1 : 1));
		}

		// Restore original sharePrice after temporary adjustments used during matching
		// giftTransactions.forEach((t) => {
		// 	let origTrans = origTransactions.find((o) => o.nrid == t.nrid);
		// 	if (origTrans) t.sharePrice = origTrans.sharePrice;
		// });

		// NEW VERSION
		// Restore original pricing / basis fields after temporary matching adjustments
		// giftTransactions.forEach((t) => {
		// 	let origTrans = origTransactions.find((o) => o.nrid == t.nrid);
		// 	if (!origTrans) return;
		// 	t.sharePrice = origTrans.sharePrice != null ? origTrans.sharePrice : '';
		// 	t.taxBasis = origTrans.taxBasis != null ? origTrans.taxBasis : '';
		// 	let basis = resolveEffectiveTaxBasis(t, clientData);
		// 	t._effectiveTaxBasis = basis.value;
		// 	t._basisSource = basis.source;
		// });

		const labelTaxBasis = language.label_tax_basis || 'Tax Basis';

		function friendlyBasisTooltip(source) {
			switch (source) {
				case 'taxBasis':
					return 'Recorded Tax Basis';
				case 'sharePrice':
					return 'From Share Price';
				case 'referencePrice':
					return 'From Reference Price';
				case 'valuationSharePrice':
					return 'From Valuation';
				default:
					return '';
			}
		}

		function basisColorClass(source) {
			switch (source) {
				case 'taxBasis':
					return ''; // default
				case 'sharePrice':
					return 'text-secondary'; // subtle
				case 'referencePrice':
					return 'text-warning'; // more noticeable
				case 'valuationSharePrice':
					return 'text-warning darken-2'; // strongest fallback
				default:
					return 'text-secondary';
			}
		}

		let userTransactionsMarkup = `
			<div class="table-wrap card p-1 mt-4 mb-2">
				<div class="sm-hz-scroll-no-margin">
					${
						!giftTransactions.length
							? `
						<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1 mt-4">
							No available holdings to send. To create a new holding, click <a id="newHoldingButton" class="link-accent">here</a>.<br><span class="text-sm">Gift Transfers require at least one "open" (unmatched) Transaction with ${giftUserData.user_name} as the receiver.</span>
						</div>
					`
							: `
					<table id="historicalsSortTable" class="highlight table-content">
						<thead>
							<tr style="height: 30px;">
								<th class="text-sm center-align p-0" style="width:8%" data-sort-default>Tranche</th>
								${CLASS_COLUMN ? `<th class="text-sm center-align p-0" style="width:8%">Class</th>` : ``}
								${CERT_COLUMN ? `<th class="text-sm center-align p-0" style="width:8%">Cert #</th>` : ``}
								<th class="text-sm center-align p-0" style="width:15%">Date</th>
								<th class="text-sm p-0">Description</th>
								<!-- <th>Sender</th> -->
								<!-- <th>Receiver</th> -->
								<th class="text-sm center-align p-0" style="width:12%">Initial</th>
								<th class="text-sm center-align p-0" style="width:12%">Remaining</th>
								<th class="hidden">Exact Basis</th>
								<th class="hidden">Reference Basis</th>
								<th class="hidden">Qty * Exact Basis</th>
								<th class="hidden">Qty * Ref. Basis</th>
								<th class="center-align">${labelTaxBasis}<span class="text-xxs text-secondary" style="vertical-align: super; color:#299AA4;"> *</span></th>
							</tr>
						</thead>
						<tbody>
							${giftTransactions
								.map(
									(t, i) => `
								<tr id="historicsTable${i}" ${t.quantity == '0' ? 'class="hidden"' : ''} style="height: 10px;">
									<td class="p-0" data-sort='${lettersToNumbers(t.tranche)}'>
										<div class="shareholder-row" style="position: relative;">
											<p id="cbElem-${t.tranche}" class="${fromUser ? '' : 'selectShareholder'} ml-6 mt-0 mb-0" style="overflow: hidden; text-align: center;">
												${
													fromUser
														? ``
														: `
													<label>
														<input class="selectTrancheInput" type="checkbox" data-tranche=${t.tranche} data-class=${t.shareClass} />
														<span></span>
													</label>
												`
												}
											</p>
											<div id="imgElem-${t.tranche}" class="text-sm font-bold ${fromUser ? '' : 'shareholder-img'} center-align ml-6">${t.tranche}</div>
										</div>
									</td>
									${
										CLASS_COLUMN
											? `
										<td class="text-xs center-align p-0" style="width: 80px; max-width: 80px;">
											${t.shareClass}
										</td>
									`
											: ``
									}
									${
										CERT_COLUMN
											? `
										<td class="text-xs center-align p-0" style="width: 80px; max-width: 80px;" data-sort='${t.certSort}'>
											${t.certNumber}
										</td>
									`
											: ``
									}
									<td class="text-xs center-align p-0" data-sort='${t.date}'>
										${moment.unix(t.date).utc().format('MMM D, YYYY')}
									</td>
									<td class="text-xs p-0">
										${t.notes}
									</td>
									<td class="text-xs center-align p-0">
										${Number(t.before).toLocaleString('en-US', m5)}
									</td>
									<td id="quantity${t.tranche}" class="text-xs center-align p-0">
										${Number(t.quantity.replace(/[^.\d]/g, '')).toLocaleString('en-US', m5)}
									</td>
									<td class="hidden">
										${t.sharePrice && !isNaN(t.sharePrice) ? Number(t.sharePrice.replace(/[^.\d]/g, '')).toLocaleString('en-US', usp) : 'n.a.'}
									</td>
									<td class="hidden">
										${t.referencePrice && !isNaN(t.referencePrice) ? Number(t.referencePrice.replace(/[^.\d]/g, '')).toLocaleString('en-US', usp) : ''}
									</td>
									<td class="hidden">
										${t.quantity && t.sharePrice && !isNaN(t.sharePrice) ? (Number(t.quantity.replace(/[^.\d]/g, '')) * Number(t.sharePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ''}
									</td>
									<td class="hidden">
										${t.quantity && t.referencePrice && !isNaN(t.referencePrice) ? (Number(t.quantity.replace(/[^.\d]/g, '')) * Number(t.referencePrice.replace(/[^.\d]/g, ''))).toLocaleString('en-US', usp) : ''}
									</td>
									<td class="text-xs center-align p-0"
										title="${friendlyBasisTooltip(t._basisSource)}">
										${
											/^(n\/?a|n\.a\.?)$/i.test(String(t._effectiveTaxBasis).trim())
												? `<span class="${basisColorClass(t._basisSource)}">${t._effectiveTaxBasis}</span>`
												: Number.isFinite(t._effectiveTaxBasis)
													? `<span class="${basisColorClass(t._basisSource)}">${t._effectiveTaxBasis.toLocaleString('en-US', usp)}</span>`
													: ''
										}
									</td>
								</tr>
							`
								)
								.join('')}
							<tfoot id="historicalsFooter">
								<tr style="height: 36px;">
									<td id="consolidate" class="text-xs py-0 px-4" style="max-width: 50px; white-space: nowrap; overflow: visible; position: relative; z-index: 2;"></td>
									${CLASS_COLUMN ? `<td class="p-0"></td>` : ``}
									${CERT_COLUMN ? `<td class="p-0"></td>` : ``}
									<td class="p-0"></td>
									<td class="p-0"></td>
									<td id="totalBefore" class="text-xs font-bold center-align p-0"></td>
									<td id="totalAfter" class="text-xs font-bold center-align p-0"></td>
									<td class="hidden"></td>
									<td class="hidden"></td>
									<td class="hidden"></td>
									<td class="hidden"></td>
									<td id="avgCostBasis" class="text-xs font-bold center-align p-0"></td>
								</tr>
							</tfoot>
						</tbody>
					</table>
					`
					}
				</div>
				${
					priorTransfers.length
						? `
				<div id="showHidePriorsDiv" class="mb-0 mt-3 flex justify-between items-center">
					<span id="showHidePriors" class="text-xs ml-6 p-0 link-accent">
						Show Prior Tranches
					</span>

					<span class="text-xxs text-secondary mr-6 text-right">
						* Tax Basis uses reported tax basis when available; otherwise derived from share price or latest valuation.
					</span>
				</div>
				`
						: `
				<div class="mb-0 mt-3 flex justify-end">
					<span class="text-xxs text-secondary mr-6 text-right">
						* Tax Basis uses reported tax basis when available; otherwise derived from share price or latest valuation.
					</span>
				</div>
				`
				}
				<table id="trancheTable" class="highlight table-content hidden">
					<thead>
						<tr>
							<th class="text-xs center-align p-05" style="width:4%" data-sort-default>Tranche</th>
							<th class="text-xs center-align p-05" style="width:6%">Class</th>
							<th class="text-xs p-05">Historic Holdings (source)</th>
							<th class="text-xs p-05">Prior Transfers (destination)</th>
						</tr>
					</thead>
					<tbody id="tableBody">
						<!-- Table rows will be added here -->
					</tbody>
				</table>
			</div>
		`;

		let table, sort;
		userGiftTransferTable.innerHTML = userTransactionsMarkup;
		table = document.getElementById('historicalsSortTable');
		if (table) sort = new Tablesort(table, { ascending: true });

		let tranches = new Set([...priorTransfers, ...historicHoldings].map((item) => item.tranche));
		let sortedTranches = Array.from(tranches).sort((a, b) => lettersToNumbers(a) - lettersToNumbers(b));

		sortedTranches.forEach((tranche) => {
			let transfers = priorTransfers.filter((item) => item.tranche == tranche);
			let holdings = collapseHistoricHoldingsForDisplay(historicHoldings.filter((item) => item.tranche == tranche));
			if (transfers.length) {
				let sumTransfers = transfers.reduce((a, b) => a + Number(b.quantity), 0);
				let sumHoldings = holdings.reduce((a, b) => a + Number(b.quantity), 0);
				// if (sumTransfers != sumHoldings) alert ("Tranche " + tranche + " sum mismatch (" + sumHoldings + " <> " + sumTransfers + ").");
				if (Math.abs(sumTransfers - sumHoldings) >= 1) {
					let trancheError = 'Tranche ' + tranche + ' sum mismatch (' + sumHoldings + ' != ' + sumTransfers + ').';
					let trancheLog = localStorage.getItem('TrancheLog');
					trancheLog += '\n' + trancheError;
					localStorage.setItem('TrancheLog', trancheLog);
					if (!getCookie('userIndex') && authedUser == 'cmcconnell@nthround.com') showToast('warning-toast', trancheError, 10000);
				}
				holdings.sort((a, b) => Number(a.quantity) - Number(b.quantity));
				transfers.sort((a, b) => Number(a.quantity) - Number(b.quantity));
				addTableRow(tranche, holdings, transfers, sumTransfers);
			}
		});

		function collapseHistoricHoldingsForDisplay(holdings) {
			const merged = [];
			holdings.forEach((h) => {
				const qty = Number(h.quantity) || 0;

				// Only merge rows that are really the same source lot for display purposes
				let existing = merged.find(
					(m) =>
						(m.notes || '') == (h.notes || '') &&
						(m.shareClass || '') == (h.shareClass || '') &&
						(m.tranche || '') == (h.tranche || '') &&
						String(m.sender || '') == String(h.sender || '') &&
						String(m.receiver || '') == String(h.receiver || '') &&
						String(m.sharePrice || '') == String(h.sharePrice || '') &&
						String(m.taxBasis || '') == String(h.taxBasis || '')
				);

				if (existing) existing.quantity = (Number(existing.quantity) + qty).toString();
				else merged.push({ ...h });
			});
			return merged;
		}

		function trancheValueLabel(row) {
			const hasPrice = isKnownNumber(row?.sharePrice);
			const hasBasis = isKnownNumber(row?.taxBasis);
			const priceNum = hasPrice ? Number(String(row.sharePrice).replace(/[^.\d]/g, '')) : null;
			const basisNum = hasBasis ? Number(String(row.taxBasis).replace(/[^-.\d]/g, '')) : null;
			const priceText = priceNum == null || isNaN(priceNum) ? '' : priceNum.toLocaleString('en-US', usp);
			const basisText = basisNum == null || isNaN(basisNum) ? '' : basisNum.toLocaleString('en-US', usp);
			if (basisNum != null && priceNum != null) {
				if (Math.abs(basisNum - priceNum) < 0.005) return basisText;
				return priceText + ' | TB ' + basisText;
			}
			if (basisNum != null) return 'TB ' + basisText;
			if (priceNum != null) return priceText;
			return '';
		}

		function addTableRow(tranche, holdings, transfers, sumTransfers) {
			let tableBody = document.getElementById('tableBody');
			let row = document.createElement('tr');

			let trancheCell = document.createElement('td');
			let trancheDate = transfers[0] ? moment.unix(Number(transfers[0].date)).utc() : moment.utc();
			trancheCell.innerHTML =
				tranche + '<p class="text-xxs font-md mt-1 mb-0">' + trancheDate.format('MMM D') + '<br>' + trancheDate.format('YYYY') + '</p>';
			trancheCell.classList.add('text-xs', 'font-bold', 'center-align', 'p-0');
			trancheCell.setAttribute('data-sort', lettersToNumbers(tranche));
			row.appendChild(trancheCell);

			let classCell = document.createElement('td');
			let trancheClass = transfers[0] ? transfers[0].shareClass : '?';
			classCell.innerHTML = trancheClass + '<p class="text-xxs mt-1 mb-0">' + sumTransfers.toLocaleString() + '<br>shares</p>';
			classCell.classList.add('text-xs', 'center-align', 'p-0');
			row.appendChild(classCell);

			let holdingsCell = document.createElement('td');
			holdingsCell.innerHTML = holdings
				.map((h) => {
					let valueLabel = trancheValueLabel(h);
					return (
						h.notes +
						' - ' +
						Number(h.quantity).toLocaleString() +
						' shares from ' +
						h.senderName.replace('Issuer', capitalize(client)) +
						(valueLabel ? '<span class="text-secondary">&ensp;' + valueLabel + '</span>' : '')
					);
				})
				.join('<br>');
			if (isVERM) holdingsCell.innerHTML = holdingsCell.innerHTML.replace(/from Vermeer/g, 'reissued');
			holdingsCell.classList.add('text-xs');
			row.appendChild(holdingsCell);

			let transfersCell = document.createElement('td');
			transfersCell.innerHTML = transfers
				.map((t) => {
					let valueLabel = trancheValueLabel(t);
					return (
						t.notes +
						' - ' +
						Number(t.quantity).toLocaleString() +
						' shares to ' +
						t.receiverName.replace('Issuer', capitalize(client)) +
						(valueLabel ? '<span class="text-secondary">&ensp;' + valueLabel + '</span>' : '')
					);
				})
				.join('<br>');
			if (isVERM) transfersCell.innerHTML = transfersCell.innerHTML.replace(/to Vermeer/g, 'cancelled');
			transfersCell.classList.add('text-xs');
			row.appendChild(transfersCell);

			tableBody.appendChild(row);
		}

		let tableP, sortP;
		tableP = document.getElementById('trancheTable');
		if (tableP) sortP = new Tablesort(tableP, { ascending: true });

		if (addedGiftTransferListenersAlready) showTotals();
	}

	const debtEquityTabs = document.getElementById('debtEquityTabs');
	const trancheTable = document.getElementById('trancheTable');
	const showHidePriors = document.getElementById('showHidePriors');
	const selectRecipient = document.getElementById('selectRecipient');
	const addRecipientBtn = document.getElementById('addRecipientBtn');
	const newHoldingButton = document.getElementById('newHoldingButton');
	const showHidePriorsDiv = document.getElementById('showHidePriorsDiv');
	const selectRecipientDiv = document.getElementById('selectRecipientDiv');
	const previewGiftTransfer = document.getElementById('previewGiftTransfer');
	const statementWaitHeader = document.getElementById('statementWaitHeader');
	const totalCurrentValueDiv = document.getElementById('totalCurrentValueDiv');
	const historicalsSortTable = document.getElementById('historicalsSortTable');
	const consolidateTransfers = document.getElementById('consolidateTransfers');

	if (showHidePriors)
		showHidePriors.addEventListener('click', function (e) {
			document.getElementById('viewGiftTransferModal').style.overflowY = 'auto';
			if (trancheTable.classList.contains('hidden')) {
				trancheTable.classList.remove('hidden');
				showHidePriorsDiv.classList.remove('mb-0');
				showHidePriorsDiv.classList.add('mb-2');
				this.innerText = 'Hide Prior Tranches';
			} else {
				showHidePriorsDiv.classList.remove('mb-2');
				showHidePriorsDiv.classList.add('mb-0');
				trancheTable.classList.add('hidden');
				this.innerText = 'Show Prior Tranches';
			}
		});

	if (!addedGiftTransferListenersAlready) {
		addedGiftTransferListenersAlready = true;
		let showHideZeros = document.getElementById('showHideZeros');
		if (showHideZeros) {
			showHideZeros.addEventListener('click', function (e) {
				historicalsSortTable?.classList.toggle('hidden', toggle === 'Hide All');
				if (toggle !== 'Hide All') {
					let len = giftTransactions.length; //historicHoldings.length;
					for (let i = 0; i < len; i++) {
						let thisRow = document.getElementById('historicsTable' + i);
						let isZero = thisRow.cells[4].innerText.trim() === '0';
						if (toggle === 'Show All' || (toggle === 'Show Positves' && !isZero) || (toggle === 'Show Zeros' && isZero))
							thisRow.classList.remove('hidden');
						else thisRow.classList.add('hidden');
					}
				}
				if (toggle === 'Show All' || toggle === 'Show Positves') showTotals();
				switch (toggle) {
					// case "Open Modal": toggle = "Hide All"; break;
					case 'Show Positves':
						toggle = 'Hide All';
						break;
					case 'Show Zeros':
						toggle = 'Show Positves';
						break;
					case 'Show All':
						toggle = 'Show Zeros';
						break;
					case 'Hide All':
						toggle = 'Show All';
						break;
				}
				this.innerText = toggle;
			});
		}
		addRecipientBtn.addEventListener('click', async function (e) {
			e.preventDefault();

			if (selectRecipientDiv.classList.contains('hidden')) {
				selectRecipient.selectedIndex = 0;
				selectRecipient.dispatchEvent(new Event('change'));
				selectRecipientDiv.classList.remove('hidden');

				const recipientPicker = document.getElementById('recipientPicker');
				if (recipientPicker) recipientPicker.classList.remove('hidden');

				const oldSelectWrapper = selectRecipientDiv.querySelector('.select-wrapper');
				if (oldSelectWrapper) oldSelectWrapper.classList.add('hidden');

				totalCurrentValueDiv.classList.add('hidden');
			} else {
				selectRecipientDiv.classList.add('hidden');
				totalCurrentValueDiv.classList.remove('hidden');
			}

			await getNextCertNumber();
		});
		selectRecipient.addEventListener('change', function (e) {
			if (!this.value) return;
			// document.getElementById('viewGiftTransferModal').style.overflowY = "auto";
			let id, recip;
			let name = DOMPurify.sanitize(this.value.trim());
			// let name = this.value.includes('|') ? this.value.split('|')[1].trim() : this.value.trim();
			if (name == 'Issuer') {
				id = 'Issuer';
				recip = { userid: 'issuer', user_name: `${clientData.company_name} (Issuer)`, clients: { [client]: { shares: {} } } };
			} else {
				// see if the name has the email already, or if it's BB-style name
				let id = name.split('|')[1].trim();
				if (!validator.isEmail(id)) id = capTableData.find((u) => u.user_name == name).userid;
				if (!id || id == giftUserId) return;
				recip = members ? members.find((u) => u.userid == id) : capTableData ? capTableData.find((u) => u.userid == id) : null;
			}
			if (recip && !giftRecipients.find((r) => r.userid == id)) giftRecipients.push(recip);
			selectRecipientDiv.classList.add('hidden');
			totalCurrentValueDiv.classList.remove('hidden');
			renderGiftRecipients();
			// viewGiftTransferModal.scrollTo({ top: 0, behavior: 'smooth' });
			renderNewGiftListeners();
			buildSelectRecipientOptions();
			document.getElementById(recip.userid + 'AddGift').dispatchEvent(new Event('click'));
		});
		document.getElementById('removeRecipientBtn').addEventListener('click', function (e) {
			let giftsToRemove = allGifts.filter((g) => g.receiver == removeGiftId);
			giftsToRemove.forEach((g) => {
				adjustBalances(-Number(g.quantity.replace(/[^-.\d]/g, '')), g.receiver, g.tranche);
				if (g.notes.includes(lastCertNum[g.shareClass])) nextCertNum[g.shareClass] = lastCertNum[g.shareClass];
			});
			giftRecipients = giftRecipients.filter((r) => r.userid != removeGiftId);
			allGifts = allGifts.filter((g) => g.receiver != removeGiftId);
			M.Modal.getInstance(document.getElementById('confirmRecipientRemove')).close();
			let recipientDiv = document.getElementById(removeGiftId + '|Div');
			recipientDiv.outerHTML = '';
			if (giftRecipients.length < 1) {
				document.getElementById('viewRecipients').innerHTML = `
					<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1 mt-4">
						Recipients will appear here.
						<!-- <p class="mt-0"><a href="#addRecipient" class="modal-trigger">Add Recipient</a></p> -->
					</div>
				`;
				viewRecipients.addEventListener('click', (e) => addRecipientBtn.dispatchEvent(new Event('click')));
			}
			if (!allGifts.length) previewGiftTransfer.classList.add('disabled');
			renderNewGiftListeners();
			buildSelectRecipientOptions();
		});
		filterViewGT.addEventListener('change', function (e) {
			selectedClass = filterViewGT.value;
			showFilteredGiftTrans();
			if (selectedClass == 'ALL') initializeDebtEquityTabs(); //viewEventsIconLarge.dispatchEvent(new Event('click'));
		});
		document.getElementById('showDecimals').addEventListener('change', function (e) {
			e.preventDefault();
			if (includedClasses.length > 1) {
				if (!selectedClass) selectedClass = 'ALL';
				showFilteredGiftTrans();
			} else {
				showFilteredGiftTrans();
			}
		});
		if (newHoldingButton) {
			newHoldingButton.addEventListener('click', function (e) {
				window.location.replace('/admin/ledgers/?action=newtransaction&recipient=' + encodeURIComponent(shareholder));
			});
		}
		document.getElementById('exportGiftTransfer').addEventListener('click', async function (e) {
			e.preventDefault();

			let origHistoricalsHtml = historicalsSortTable.innerHTML;
			let origTrancheHtml = trancheTable.innerHTML;

			// export-only cleanup
			let footer = historicalsSortTable.querySelector('tfoot');
			if (footer) footer.remove();

			trancheTable.querySelectorAll('tbody tr').forEach((row) => {
				let cells = row.querySelectorAll('td');
				if (!cells.length) return;

				// Column A: AH | Dec 11 2025
				if (cells[0]) {
					let main = cells[0].innerHTML.split('<p')[0].trim();
					let sub = cells[0].querySelector('p')?.innerHTML.replace(/<br>/g, ', ').trim() || '';
					cells[0].innerHTML = sub ? main + ' | ' + sub : main;
				}

				// Column B: C | 680 shares
				if (cells[1]) {
					let main = cells[1].innerHTML.split('<p')[0].trim();
					let sub = cells[1].querySelector('p')?.innerHTML.replace(/<br>/g, ' ').trim() || '';
					cells[1].innerHTML = sub ? main + ' | ' + sub : main;
				}
			});

			try {
				await export_table_to_excel(
					'historicalsSortTable|trancheTable',
					giftUserData.user_name + ' Gift / Transfer Report (' + new Date().toLocaleString() + ').csv'
				);
			} finally {
				historicalsSortTable.innerHTML = origHistoricalsHtml;
				trancheTable.innerHTML = origTrancheHtml;
			}
		});
		previewGiftTransfer.addEventListener('click', async function (e) {
			if (fromUser) sendThisRequest();
			else {
				const giftsForPreview = consolidateTransfers?.checked ? await getConsolidatedTransferGifts() : allGifts;
				renderTransactionMapTable(giftsForPreview);
			}
		});
		if (historicalsSortTable)
			historicalsSortTable.addEventListener('click', async function (e) {
				// 🔹 Add `async`
				if (e.target.classList.contains('selectTrancheInput')) {
					let selected = e.target.getAttribute('data-tranche');
					let consolidate = document.getElementById('consolidate');
					let cbElem = document.getElementById('cbElem-' + selected);
					let imgElem = document.getElementById('imgElem-' + selected);
					let cbElems = document.querySelectorAll('.selectTrancheInput');

					if (selected == 'all') {
						selectedTranches = [];
						if (e.target.checked) {
							currentData.forEach((u) => selectedTranches.push(u.userid));
							document.querySelectorAll('input[type=checkbox]').forEach((el) => {
								if (el.classList.contains('selectTrancheInput')) el.checked = true;
							});
						} else {
							document.querySelectorAll('input[type=checkbox]').forEach((el) => {
								if (el.classList.contains('selectTrancheInput')) el.checked = false;
							});
						}
					} else {
						if (e.target.checked) {
							let thisClass = e.target.dataset.class;
							cbElem.style.display = 'block';
							imgElem.style.display = 'none';
							selectedTranches.push(selected);
							for (let i = 0; i < cbElems.length; i++) {
								if (cbElems[i].dataset.class != thisClass) cbElems[i].disabled = true;
								else cbElems[i].disabled = false;
							}
							addRecipientBtn.classList.add('text-secondary');
							addRecipientBtn.style.pointerEvents = 'none';
						} else {
							cbElem.style.display = 'none';
							imgElem.style.display = 'block';
							selectedTranches = selectedTranches.filter(function (tr) {
								return tr !== selected;
							});
						}
					}

					let trLen = selectedTranches.length;
					if (trLen == 0) {
						for (let i = 0; i < cbElems.length; i++) cbElems[i].disabled = false;
						addRecipientBtn.classList.remove('text-secondary');
						addRecipientBtn.style.pointerEvents = null;
					} else if (trLen == 1) {
						await getNextCertNumber();
						consolidate.innerHTML = 'Reissue Tranche: ' + (selectedTranches[0] || '');
						previewGiftTransfer.classList.remove('disabled');
						previewGiftTransfer.innerHTML = 'Preview This Reissuance';
					} else if (trLen > 1) {
						await getNextCertNumber();
						selectedTranches.sort();
						consolidate.innerHTML =
							'Consolidate Tranches: ' +
							(trLen > 1 ? `${selectedTranches.slice(0, -1).join(', ')} and ${selectedTranches[trLen - 1]}` : selectedTranches[0] || '');
						previewGiftTransfer.classList.remove('disabled');
						previewGiftTransfer.innerHTML = 'Preview This Consolidation';
					} else {
						consolidate.innerHTML = '';
						previewGiftTransfer.classList.add('disabled');
						previewGiftTransfer.innerHTML = 'Preview These Transfers';
					}

					console.log(selectedTranches);
				}
			});

		if (isAdmin) {
			const stepwiseControls = document.getElementById('stepwiseControls');
			const stepwiseCheckBox = document.getElementById('stepwiseCheckBox');
			stepwiseCheckBox?.classList.remove('hidden');
			if (stepwiseAnalysis)
				stepwiseAnalysis.addEventListener('change', function (e) {
					if (stepwiseAnalysis.checked) {
						balanceHeadline.classList.add('hidden');
						stepwiseControls.classList.remove('hidden');
						giftTransferControls.classList.add('hidden');
						showTrancheTable();

						// --- Step 2: Instantiate listeners once (no behavior yet) ---
						let _stepwiseBound = false;
						let _stepwisePaintLock = false; // simple re-entry guard for repaint

						function repaintGiftModal(reason) {
							if (_stepwisePaintLock) return; // avoid double-fires
							_stepwisePaintLock = true;
							try {
								console.log(`[stepwise] repaint due to: ${reason}`);
								builtGiftTransferModalAlready = false;
								giftTransfer(giftUserId, false); // 🔁 repaint entire modal
							} catch (err) {
								console.error('[stepwise] repaint error', err);
							} finally {
								setTimeout(() => {
									_stepwisePaintLock = false;
								}, 0);
							}
						}

						function initStepwiseListenersOnce() {
							if (_stepwiseBound) return; // idempotent
							const firstBtn = document.getElementById('stepFirst');
							const prevBtn = document.getElementById('stepPrev');
							const nextBtn = document.getElementById('stepNext');
							const lastBtn = document.getElementById('stepLast');

							// Guard in case controls aren't in DOM yet
							if (!firstBtn || !prevBtn || !nextBtn || !lastBtn) return;

							const onClick = (name) => (e) => {
								e.preventDefault();
								// adjust target length
								if (name === 'First') window._stepwiseTargetLen = 1;
								else if (name === 'Prev') window._stepwiseTargetLen = Math.max(1, (window._stepwiseTargetLen || 1) - 1);
								else if (name === 'Next')
									window._stepwiseTargetLen = Math.min(window._stepwiseMasterLen || 1, (window._stepwiseTargetLen || 1) + 1);
								else if (name === 'Last') window._stepwiseTargetLen = window._stepwiseMasterLen || 1;

								// repaint modal (your existing call)
								giftTransfer(giftUserId, false);
								showTrancheTable();
							};

							firstBtn.addEventListener('click', onClick('First'));
							prevBtn.addEventListener('click', onClick('Prev'));
							nextBtn.addEventListener('click', onClick('Next'));
							lastBtn.addEventListener('click', onClick('Last'));

							// Optional: keyboard hooks (Left/Right/Home/End) — logs only
							document.addEventListener(
								'keydown',
								(e) => {
									if (e.key === 'Home') return onClick('First')(e);
									if (e.key === 'ArrowLeft') return onClick('Prev')(e);
									if (e.key === 'ArrowRight') return onClick('Next')(e);
									if (e.key === 'Last') return onClick('Last')(e);
								},
								{ passive: false }
							);

							_stepwiseBound = true;
							console.log('[stepwise] listeners bound');
						}

						initStepwiseListenersOnce();
					} else {
						stepwiseControls.classList.add('hidden');
						balanceHeadline.classList.remove('hidden');
						giftTransferControls.classList.remove('hidden');
						window._stepwiseTargetLen = null; // set clamp set to end
						giftTransfer(giftUserId, false); // repaint with full range
					}
				});

			function showTrancheTable() {
				showHidePriorsDiv.classList.add('mb-2');
				showHidePriorsDiv.classList.remove('mb-0');
				trancheTable.classList.remove('hidden');
				const showHide = document.getElementById('showHidePriors');
				if (showHide) showHide.innerText = 'Hide Prior Tranches';
			}

			const proTips = document.getElementById('proTips');
			if (proTips)
				proTips.addEventListener('click', function (e) {
					e.preventDefault();
					const helpModalEl = document.getElementById('trancheAnalysisHelpModal');
					const giftModal = M.Modal.getInstance(viewGiftTransferModal);
					const helpModal = M.Modal.getInstance(helpModalEl);
					if (giftModal && giftModal.isOpen) {
						giftModal.options.onCloseEnd = () => helpModal.open();
						giftModal.close();
					} else helpModal.open();
				});
		}

		function initializeDebtEquityTabs() {
			let instance = M.Tabs.init(debtEquityTabs, {});
			debtEquityTabs.classList.add('hidden');
			setTimeout(() => {
				if (showTabs) {
					debtEquityTabs.classList.remove('hidden');
					instance.updateTabIndicator();
					console.log('Intialized Debt-Equity tabs');
				}
			}, 100);
		}

		showHideZeros.dispatchEvent(new Event('click'));
		renderGiftRecipients();

		const removeThisRequest = document.getElementById('removeThisRequest');
		confirmRequestRemove = document.getElementById('confirmRequestRemove');
		const shareholderTransferRequests = shareholderData.clients[client].transfer_requests || {};

		// Extract all gifts that are "Open"
		const openGifts = Object.values(shareholderTransferRequests)
			.flat() // Flatten nested arrays
			.filter((gift) => gift.status === 'Open');

		if (openGifts.length > 0) {
			removeThisRequest.classList.remove('hidden');

			allGifts = openGifts;
			renderNewGiftListeners();
			getNextCertNumber();

			// Extract unique recipients
			const uniqueRecipients = new Set(allGifts.map((gift) => gift.receiver));

			// Fire events for each unique recipient
			uniqueRecipients.forEach((recipientId) => {
				// 🔹 Add `async`
				let recip = capTableData.find((u) => u.userid == recipientId);
				if (!recip) {
					alert('⛔ Missing recipient account: ' + recipientId + '.\n\n⚠️ Please add this account to the cap table before continuing.');
					return;
				}
				if (!giftRecipients.find((r) => r.userid == recipientId)) giftRecipients.push(recip);
				// await getNextCertNumber();
				renderGiftRecipients();
				renderNewGiftListeners();
				buildSelectRecipientOptions();
				document.getElementById(recip.userid + 'AddGift').dispatchEvent(new Event('click'));
			});

			// Adjust balances based on gifts
			allGifts.forEach((g) => adjustBalances(Number(g.quantity), g.receiver, g.tranche));

			// Add event listeners for request removal
			document.getElementById('removeThisRequest').addEventListener('click', function (e) {
				M.Modal.getInstance(confirmRequestRemove).open();
			});
			document.getElementById('removeRequestBtn').addEventListener('click', function (e) {
				M.Modal.getInstance(viewGiftTransferModal).close();
				M.Modal.getInstance(confirmRequestRemove).close();
				M.Modal.getInstance(statementWaitState).open();
				clearPendingRequests('Removed');
			});
		} else {
			removeThisRequest?.classList.add('hidden');
		}
	}

	let labelBB = clientData.language?.label_buy_back?.includes('Redemption') ? 'Redemption' : 'Buy-Back';

	if (BUY_BACK) {
		let treasuryAccount = clientData.treasury_account;
		if (!treasuryAccount) treasuryAccount = 'Treasury | temp_treasury@' + client + '.com';
		holders.push(treasuryAccount);
		treasuryId = treasuryAccount.split('|')[1].trim();
		let treasuryName = treasuryAccount.split('|')[0].trim();
		members = [{ userid: treasuryId, user_name: treasuryName, clients: { [client]: { shares: {} } } }];
		buildSelectRecipientOptions();
		selectRecipient.value = treasuryAccount;
		selectRecipient.dispatchEvent(new Event('change'));

		// now do these
		addRecipientBtn.classList.add('hidden');
		totalCurrentValueDiv.classList.remove('hidden');
		previewGiftTransfer.innerHTML = 'Request This ' + labelBB;
		document.getElementById('toTheseRecipientsDiv').classList.add('hidden');
		document.getElementById('requestHeadline').classList.remove('hidden');
		document.getElementById('requestInstructions').classList.remove('hidden');
		totalCurrentValueDiv.innerHTML = `Total Current Value${isEDM ? ` (${currentPrice('C')?.toLocaleString('en-US', usd)} per share)` : ``}:&ensp;<span id="totalCurrentValue" class="text-black"></span>`;
		const firstTranche = document.getElementById(' |' + treasuryId + '|TrancheId');
		if (firstTranche)
			setTimeout(() => {
				firstTranche.focus();
			}, 10);
	} else if (capTableData && !fromUser) {
		// <-- 2/10/2025 added !fromUser to more accurately preview user experience
		capTableData.forEach(function (i) {
			if (i.userid == giftUserId) return;
			if ((isBB && !client == 'onwardfe') || i.user_name.includes('|')) holders.push(i.user_name);
			else holders.push(i.user_name + ' | ' + i.userid);
		});
		// capTableData.forEach(function (i) { if (i.userid != giftUserId) holders.push((i.clients[client].notes ? (i.clients[client].notes + "\xa0\xa0|\xa0\xa0") : "") + i.user_name); });
		// capTableData.forEach(function (i) { if (i.userid != giftUserId) holders.push(i.user_name + "\xa0\xa0|\xa0\xa0" + i.userid); });
		// capTableData.forEach(function (i) { holders.push(i.user_name); });
		holders.sort();
		buildSelectRecipientOptions();
	} else {
		// regular user needs members
		addRecipientBtn.classList.add('text-secondary');
		addRecipientBtn.style.pointerEvents = 'none';
		addRecipientBtn.innerHTML = '<i class="material-icons align-middle mb-1 mr-05">person_add</i>One moment...';
		axios
			.post(
				'https://api.nthround.io/portal/user/alias-names',
				JSON.stringify({
					eventName: 'gift-transfer.family_members',
					alias_list: [], // workspaces are trust accounts
					client: client,
					userid: authedUser,
					cookie: cookie,
				})
			)
			.then(function (res) {
				addRecipientBtn.classList.remove('text-secondary');
				addRecipientBtn.style.pointerEvents = null;
				addRecipientBtn.innerHTML = '<i class="material-icons align-middle mb-1 mr-05">person_add</i>Add Recipient';
				members = removeNthAdmins(res.data);

				// Family Filter for USV
				const FF = isUSV || client == 'onwardfe';
				const sliceFF = isUSV ? 1 : 2;
				const familyCode = userData.clients[client]?.tags?.[0]?.slice(0, sliceFF) || '';
				if (FF && fromUser && familyCode) members = members.filter((r) => r.tags?.[0]?.slice(0, sliceFF) === familyCode);

				members.forEach(function (i) {
					if (i.userid == giftUserId) return;
					if ((isBB && !client == 'onwardfe') || i.user_name.includes('|')) holders.push(i.user_name);
					else holders.push(i.user_name + ' | ' + i.userid);
				});
				holders.sort();
				buildSelectRecipientOptions();
			})
			.catch(function (error) {
				console.error(error);
			});
	}

	function showTotals() {
		ttlAfter = 0;
		ttlBefore = 0;
		let totalBasisDollars = 0;
		let basisUnknown = false;
		let len = giftTransactions.length;
		if (len < 1) return;

		for (let i = 0; i < len; i++) {
			let row = giftTransactions[i];
			let beforeQty = Number(row.before);
			let afterQty = row.after != null ? Number(row.after) : Number(row.quantity);

			ttlBefore += beforeQty;
			ttlAfter += afterQty;
			if (afterQty > 0) {
				let basisPerShare = isKnownNumber(row._effectiveTaxBasis) ? Number(row._effectiveTaxBasis) : null;
				if (basisPerShare === null) basisUnknown = true;
				else totalBasisDollars += afterQty * basisPerShare;
			}
		}

		let totals = 'ttlBefore = ' + ttlBefore + ' | ttlAfter = ' + ttlAfter;
		console.log(totals);
		let trancheLog = localStorage.getItem('TrancheLog');
		trancheLog += '\n' + totals;
		localStorage.setItem('TrancheLog', trancheLog);

		document.getElementById('totalBefore').innerHTML = ttlBefore.toLocaleString('en-US', stringOptions);
		document.getElementById('totalAfter').innerHTML = ttlAfter.toLocaleString('en-US', stringOptions);
		document.getElementById('avgCostBasis').innerHTML =
			basisUnknown || ttlAfter <= 0 ? 'n.a.' : (totalBasisDollars / ttlAfter).toLocaleString('en-US', usd);
	}

	function updateRecipientSearchHighlight() {
		const resultsDiv = document.getElementById('recipientSearchResults');
		if (!resultsDiv) return;

		const rows = resultsDiv.querySelectorAll('.recipient-search-row');
		rows.forEach((row, idx) => {
			row.classList.toggle('active', idx === recipientSearchIndex);
		});

		const activeRow = rows[recipientSearchIndex];
		if (activeRow) {
			activeRow.scrollIntoView({ block: 'nearest' });
		}
	}

	function closeRecipientSearchResults() {
		const resultsDiv = document.getElementById('recipientSearchResults');
		if (!resultsDiv) return;
		resultsDiv.classList.add('hidden');
		recipientSearchIndex = -1;
	}

	function selectRecipientSearchMatch(idx) {
		const match = recipientSearchMatches[idx];
		if (!match) return;

		let value;
		if (match.name === 'Issuer') value = 'Issuer';
		else if (match.userid) value = match.name + ' | ' + match.userid;
		else value = match.name;

		selectRecipient.value = value;
		selectRecipient.dispatchEvent(new Event('change'));

		const input = document.getElementById('recipientSearchInput');
		if (input) input.value = '';

		closeRecipientSearchResults();
	}

	function buildRecipientSearchDataset() {
		recipientSearchData = [];

		const selectedRecipientIds = new Set(giftRecipients.map((r) => r.userid).filter(Boolean));

		let sourceRecipients = Array.isArray(members) && members.length ? members : Array.isArray(capTableData) ? capTableData : [];

		sourceRecipients.forEach((m) => {
			if (!m || m.userid === giftUserId) return;
			if (selectedRecipientIds.has(m.userid)) return;

			const idNumber = m.clients?.[client]?.idNumber || '';
			const name = m.user_name || '';
			const userid = m.userid || '';

			if (!name && !userid) return;

			recipientSearchData.push({
				idNumber,
				name,
				userid,
				searchText: `${idNumber} ${name} ${userid}`.toLowerCase(),
			});
		});

		recipientSearchData.unshift({
			idNumber: '',
			name: 'Issuer',
			userid: 'Cancellation or Redemption',
			searchText: 'issuer cancellation redemption',
		});
	}

	function initializeRecipientPickerShell() {
		const recipientPicker = document.getElementById('recipientPicker');
		const recipientSearchInput = document.getElementById('recipientSearchInput');
		const recipientSearchResults = document.getElementById('recipientSearchResults');

		if (!recipientPicker || !recipientSearchInput || !recipientSearchResults) return;

		recipientPicker.classList.remove('hidden');
		recipientSearchInput.value = '';
		recipientSearchResults.innerHTML = `
			<div class="recipient-search-empty text-xs text-secondary p-1">
				Start typing to search recipients.
			</div>
		`;
		recipientSearchResults.classList.add('hidden');

		if (!recipientSearchInput.dataset.bound) {
			function openRecipientSearchResults() {
				const q = recipientSearchInput.value.trim().toLowerCase();
				if (q) {
					const matches = recipientSearchData.filter((r) => r.searchText.includes(q));
					renderRecipientSearchResults(matches, 25);
				} else {
					recipientSearchMatches = [];
					recipientSearchIndex = -1;
					recipientSearchResults.innerHTML = `
						<div class="recipient-search-empty text-xs text-secondary p-1">
							Start typing (Name, Email,or Id Number) to list matching potential recipients
						</div>
					`;
					recipientSearchResults.classList.remove('hidden');
				}

				recipientSearchIndex = -1;
				if (recipientSearchMatches.length) recipientSearchResults.classList.remove('hidden');
			}

			recipientSearchInput.addEventListener('input', function () {
				const q = this.value.trim().toLowerCase();

				if (!q) {
					recipientSearchMatches = [];
					recipientSearchIndex = -1;
					recipientSearchResults.classList.add('hidden');
					return;
				}

				const matches = recipientSearchData.filter((r) => r.searchText.includes(q));
				renderRecipientSearchResults(matches, 25);
			});

			recipientSearchInput.addEventListener('keydown', function (e) {
				const resultsOpen = !recipientSearchResults.classList.contains('hidden');

				if (e.key === 'ArrowDown') {
					if (!recipientSearchMatches.length) return;
					e.preventDefault();
					if (!resultsOpen) recipientSearchResults.classList.remove('hidden');
					recipientSearchIndex = Math.min(recipientSearchIndex + 1, recipientSearchMatches.length - 1);
					updateRecipientSearchHighlight();
					return;
				}

				if (e.key === 'ArrowUp') {
					if (!recipientSearchMatches.length) return;
					e.preventDefault();
					if (!resultsOpen) recipientSearchResults.classList.remove('hidden');
					recipientSearchIndex = Math.max(recipientSearchIndex - 1, 0);
					updateRecipientSearchHighlight();
					return;
				}

				if (e.key === 'Enter' || e.key === 'Tab') {
					if (resultsOpen && recipientSearchIndex >= 0 && recipientSearchMatches.length) {
						e.preventDefault();
						selectRecipientSearchMatch(recipientSearchIndex);
					}
					return;
				}

				if (e.key === 'Escape') {
					e.preventDefault();
					closeRecipientSearchResults();
					return;
				}
			});

			recipientSearchInput.addEventListener('focus', function () {
				openRecipientSearchResults();
			});

			recipientSearchInput.addEventListener('click', function () {
				openRecipientSearchResults();
			});

			recipientSearchInput.addEventListener('blur', function () {
				setTimeout(() => {
					closeRecipientSearchResults();
				}, 150);
			});

			recipientSearchInput.dataset.bound = 'true';
		}
	}

	function buildSelectRecipientOptions() {
		let recips = [];
		selectRecipient.options.length = 1;
		giftRecipients.forEach((r) => recips.push(r.user_name));
		selectRecipient.options[1] = new Option('Issuer | Cancellation or Redemption', 'Issuer');
		holders.forEach((h) => {
			if (!recips.includes(h)) selectRecipient.options[selectRecipient.options.length] = new Option(h, h);
		});
		let options = {
			dropdownOptions: {
				container: 'authed',
				coverTrigger: false,
			},
		};
		let selects = document.querySelectorAll('select');
		let instances = M.FormSelect.init(selects, options);
		selectRecipient.parentElement.style.display = 'none';
		const oldSelectWrapper = selectRecipientDiv.querySelector('.select-wrapper');
		if (oldSelectWrapper) oldSelectWrapper.classList.add('hidden');

		initializeRecipientPickerShell();
		buildRecipientSearchDataset();
	}

	function renderRecipientSearchResults(results, maxRows = 25) {
		const resultsDiv = document.getElementById('recipientSearchResults');
		if (!resultsDiv) return;
		resultsDiv.innerHTML = '';
		const sortedResults = results.slice().sort((a, b) => {
			if (a.name === 'Issuer') return -1;
			if (b.name === 'Issuer') return 1;
			return String(a.name || '').localeCompare(String(b.name || ''));
		});
		const visibleResults = sortedResults.slice(0, maxRows);
		recipientSearchMatches = visibleResults.slice();
		recipientSearchIndex = recipientSearchMatches.length ? 0 : -1;
		if (!visibleResults.length) {
			resultsDiv.innerHTML = `
				<div class="recipient-search-empty text-xs text-secondary p-1">
					No recipients found
				</div>
			`;
			resultsDiv.classList.remove('hidden');
			return;
		}

		visibleResults.forEach((r, idx) => {
			const row = document.createElement('div');
			row.className = 'recipient-search-row' + (idx === recipientSearchIndex ? ' active' : '');
			row.dataset.index = idx;
			row.innerHTML = `
				<div class="recipient-row-main">
					<span class="recipient-id">${r.idNumber || ''}</span>
					<span class="recipient-name">${r.name}</span>
				</div>
				<div class="recipient-row-sub">${r.userid}</div>
			`;

			row.addEventListener('mousedown', function (e) {
				e.preventDefault();
				selectRecipientSearchMatch(idx);
			});

			resultsDiv.appendChild(row);
		});

		resultsDiv.classList.remove('hidden');
	}

	function renderGiftRecipients() {
		let recipientsMarkup = '';
		let emptyState = `
			<div class="bg-grey-lightest rounded border-grey grey-text center-align p-1 mt-4">
				Recipients will appear here.
				<!-- <p class="mt-0"><a href="#addRecipient" class="modal-trigger">Add Recipient</a></p> -->
			</div>
		`;

		let index = giftRecipients.length - 1;
		if (index < 0) {
			recipientsMarkup = emptyState;
		} else {
			let recipOwned = 0;
			let recip = giftRecipients[index];
			let recipClientData = recip.clients ? recip.clients[client] : recip;
			let recipNotes = recip.clients ? recip.clients[client].notes : recip.notes;
			classes.forEach((c) => (recipOwned += Number(recipClientData.shares?.[c]?.owned || '0')));
			giftRecipients[index].before = recipOwned;
			giftRecipients[index].after = recipOwned;

			recipientsMarkup = `
				<div id="${recip.userid}|Div" class="recip-div card px-4 mt-4 mb-0 rounded">
					${
						BUY_BACK
							? ``
							: `
						<div class="row center-align mt-0 mb-0">
							<!-- <div class="col s12 m6 left-align mt-2" title="${
								recip.friendly_name ? recip.userid + ' [' + recip.friendly_name.replace(/_/g, ' ') + ']' : recip.userid
							}">${(recipNotes ? recipNotes + '\xa0\xa0|\xa0\xa0' : '') + recip.user_name}</div> -->
							<div class="col s12 m6 left-align mt-2" title="${recip.userid}">${recip.user_name}</div>
							<div class="text-sm text-secondary col s12 m5 mt-2 right-align">Shares Owned:&emsp;<span class="text-primary">${recip.before.toLocaleString()}</span>&nbsp;Before&emsp;
								<span id="${recip.userid}|After" class="text-primary">${recip.after.toLocaleString()}</span>&nbsp;After</div>
							<a href="#confirmRecipientRemove" class="col s12 m1 modal-trigger remove-gift-recipient waves-effect waves-red btn-flat red-text text-xxs right" data-key="${recip.userid}">Remove</a>
						</div>
					`
					}
					<div id="${recip.userid}Gifts"></div>
					<div class="flex center-align mb-0 hidden">
						<p class="text-xs mt-2 mb-0 left"><a id="${recip.userid}AddGift" href="#" class="add-recip text-sm" data-key="${recip.userid}">+ Add Gift/Transfer</a></p>
						<a href="#confirmRecipientRemove" class="col s12 m1 modal-trigger remove-gift-recipientHIDDEN waves-effect waves-red btn-flat p-0 mt-2 mb-0 right" data-key="${recip.userid}">Remove</a>
					</div>
				</div>
			`;
		}

		viewRecipients = document.getElementById('viewRecipients');
		if (index == 0) viewRecipients.innerHTML = recipientsMarkup;
		else viewRecipients.innerHTML += recipientsMarkup;
		// viewRecipients.addEventListener('click', e => addRecipientBtn.dispatchEvent(new Event('click')));
	}

	function renderNewGiftListeners() {
		document.querySelectorAll('.add-recip').forEach((recip) => {
			// console.log("ADDED add-recip", recip);
			recip.addEventListener('click', function (e) {
				currentTranche = '';
				recipientId = e.target.dataset.key;
				let recipient = capTableData ? capTableData.find((u) => u.userid == recipientId) : members.find((u) => u.userid == recipientId); // for regular users, not admins
				recipientName = recipientId == 'issuer' ? clientData.company_name : recipient ? recipient.user_name : 'UNKNOWN';

				theseGifts = {};
				let giftArray = allGifts.filter((g) => g.receiver == recipientId);
				giftArray.forEach((g) => (theseGifts[g.tranche] = g));
				// theseGifts[" "] = ["","",,];
				if (!theseGifts.length) theseGifts[' '] = ['', '', ,];
				gifts = Object.keys(theseGifts);

				const HIDE_COST_BASIS = BUY_BACK && isEDM;
				const ce = BUY_BACK ? '' : 'contenteditable';
				let giftTable = document.getElementById(recipientId + 'Gifts');
				let giftTableMarkup = `
					${
						gifts.length
							? `
					<div class="table-wrap mb-0">
						<div class="sm-hz-scroll-no-margin">
							<table id="recipientsGiftTable" class="recip-table highlight table-content">
								<thead>
									<tr class="text-xs">
										<th class="center-align p-05">Tranche</th>
										${CLASS_COLUMN ? `<th class="center-align -05">Class</th>` : ``}
										<th class="center-align p-05">Date</th>
										<!-- <th class="sm-fixed-left p-05">Notes</th> -->
										<th class="sm-fixed-left p-05">Description</th>
										<th id="qtyHeader|${recipientId}" class="center-align p-05">Quantity</th>
										${HIDE_COST_BASIS ? `` : `<th class="center-align p-05">Tax&nbsp;Basis</th>`}
										<th class="center-align p-05">Current Value</th>
									</tr>
								</thead>
								<tbody>
								${gifts
									.map(
										(gift, index) => `
									<tr id="${gift + '|' + recipientId + '|'}Tranche" class="add-tranche">
										<td id="${gift + '|' + recipientId + '|'}TrancheId"
											class="new-tranche text-xs center-align font-bold p-05" contenteditable style="${index === gifts.length - 1 ? 'outline: 1px solid rgba(0,0,0,0.1); outline-offset: -1px; background-color: #ffffcc;' : ''}">
											${gift}
										</td>
										${
											CLASS_COLUMN
												? `
										<td class="text-xs center-align p-05">
											${theseGifts[gift].shareClass ? theseGifts[gift].shareClass : ''}
										</td>
										`
												: ``
										}
										<td id="editableDate-${gift}" class="gift-date text-xs center-align p-05" ${ce} ${isAdmin ? '' : 'title="Must be within the next 60 days."'}>
											${
												theseGifts[gift].date
													? moment
															.unix(theseGifts[gift].date / 1000)
															.utc()
															.format('MMM D, YYYY')
													: ''
											}
										</td>
										<!-- <td id="editablePre-${gift + '|' + recipientId}" class="select-notes text-xs sm-fixed-left p-05" ${ce}>
											${theseGifts[gift].pre ? theseGifts[gift].pre : ''}
										</td> -->
										<td id="editableNotes-${gift}" class="text-xs sm-fixed-left p-05" title="${gift}" ${ce}>
											${theseGifts[gift].notes ? theseGifts[gift].notes.replace(/_/g, ' ') : ''}
										</td>
										<td id="${recipientId + '|' + gift}-tranche" class="gift-qty text-xs center-align p-05" contenteditable>
											${theseGifts[gift].quantity ? Number(theseGifts[gift].quantity).toLocaleString('en-US', stringOptions) : ''}
										</td>
										${
											HIDE_COST_BASIS
												? ``
												: `
											<td id="editableBasis-${gift}" class="select-gift text-xs center-align p-05" ${isAdmin ? ce : ''}>
											${
												isKnownNumber(theseGifts[gift].taxBasis)
													? Number(String(theseGifts[gift].taxBasis).replace(/[^-.\d]/g, '')).toLocaleString('en-US', usp)
													: isNA(theseGifts[gift].taxBasis)
														? theseGifts[gift].taxBasis
														: gift.trim()
															? 'n.a.'
															: ''
											}
										</td>
										`
										}
										<td id="currentValue-${gift + '|' + recipientId}" class="text-xs center-align p-05">
											${!theseGifts[gift].quantity ? '' : isNaN(currentPrice(theseGifts[gift].shareClass)) ? 'n.a.' : (Number(theseGifts[gift].quantity) * currentPrice(theseGifts[gift].shareClass)).toLocaleString('en-US', usd)}
										</td>
									</tr>
									`
									)
									.join('')}
								</tbody>
							</table>
						</div>
					</div>
					`
							: `
					<div class="bg-grey-lightest rounded border-grey grey-text center-align p-2">
						No gifts found
					</div>
					`
					}
				`;

				giftTable.innerHTML = giftTableMarkup;

				// scroll to bottom
				viewGiftTransferModal.scrollTop = viewGiftTransferModal.scrollHeight;

				renderTrancheListeners();

				let newTranche = document.getElementById(' |' + recipientId + '|Tranche');
				if (gifts.length > 1) newTranche.focus();
				// Should automatically inject new tranche if only one possibility, but...
				// else if (historicHoldings.length == 1) {
				// 	newTranche.children[0].innerHTML = "A";
				// 	let thisTranche = document.querySelectorAll('.new-tranche')[0];
				// 	thisTranche.dispatchEvent(new Event('keyup'));
				// }
				else newTranche.children[0].focus();
			});
		});

		// document.querySelectorAll('.recip-div').forEach(table => {
		// 	console.log("ADDED recip-div", table);
		// 	table.addEventListener('focusin', function(e) {
		// 		recipientId = e.target.id.split('|')[0];
		// 		console.log("table focus, recipientId = " + recipientId);
		// 	});
		// });

		document.querySelectorAll('.remove-gift-recipient').forEach((remove) => {
			// console.log("ADDED remove-gift-recipient", remove);
			remove.addEventListener('click', function (e) {
				e.preventDefault();
				removeGiftId = e.target.getAttribute('data-key');
				let recipientRemoveName = document.getElementById('recipientRemoveName');
				recipientRemoveName.innerHTML = e.target.parentElement.innerText.split('Shares Owned:')[0].trim();
			});
		});

		function renderTrancheListeners() {
			document.querySelectorAll('.add-tranche').forEach((tranche) => {
				const trancheCell = tranche.children[0] || tranche;
				const rowRecipientId = tranche.id.split('|')[1];

				function getAvailableTranches() {
					let priorTranches = priorTransfers.map((t) => t.tranche);
					let availableTranches = giftTransactions.filter((t) => Number(t.quantity) != 0).map((t) => t.tranche);

					availableTranches = availableTranches.filter((a) => {
						let thisHH = giftTransactions.find((h) => h.tranche == a);
						let balance = thisHH ? Number(thisHH.quantity) : 0;
						return !priorTranches.includes(a) || balance > 0;
					});

					return availableTranches;
				}

				function getApplicableTranches(typed) {
					return getAvailableTranches().filter((a) => a.startsWith(typed));
				}

				function commitTranche(resolvedTranche) {
					let availableTranches = getAvailableTranches();
					let gifts = allGifts.filter((g) => g.receiver == rowRecipientId).map((g) => g.tranche);
					gifts.push(' ');

					if (gifts.includes(resolvedTranche) || !availableTranches.includes(resolvedTranche)) {
						trancheCell.innerHTML = '';
						return false;
					}

					trancheCell.innerHTML = resolvedTranche;

					gifts.splice(-1, 0, resolvedTranche);
					let thisTrans = giftTransactions.find((t) => t.tranche == resolvedTranche);
					if (!thisTrans) return false;

					let qtyTrans = thisTrans.quantity;
					let qtyAfterElem = document.getElementById('quantity' + resolvedTranche);
					let qtyAfter = qtyAfterElem ? qtyAfterElem.innerHTML : '';
					if (qtyAfter) qtyTrans = Number(qtyAfter.replace(/[^-.\d]/g, '')).toString();

					// Use prior quantity rather than remaining balance, if available and new recipient
					if (allGifts.length && rowRecipientId != allGifts[allGifts.length - 1].receiver) {
						let priorQty = Number(allGifts[allGifts.length - 1].quantity);
						let availQty = Number(qtyTrans);
						if (availQty >= priorQty) qtyTrans = priorQty.toString();
					}

					let newDate = allGifts.length ? allGifts[allGifts.length - 1].date : Date.now().toString();
					let newNotes = labelBB + ' (' + thisTrans.notes.trim() + ' dated ' + moment.unix(Number(thisTrans.date)).utc().format('M/D/YY') + ')';
					if (thisTrans.certNumber) newNotes = labelBB + ' (' + thisTrans.certNumber + ')';

					if (!BUY_BACK) {
						if (rowRecipientId != 'issuer') {
							if (CERT_COLUMN) {
								const transClass = thisTrans.shareClass;
								const nextCert = nextCertNum[transClass];
								const lastCert = lastCertNum[transClass];
								incrementNextCertNumber(transClass);
								newNotes = nextCert
									? 'Transfer (' + nextCert + (thisTrans.certNumber ? ' from ' + thisTrans.certNumber.replace(/^0+/, '') + ')' : ')')
									: 'Transfer';
								const lastCertNumber = document.getElementById('lastCertNumber');
								const originalLastCert = originalLastCertNum?.[transClass] || lastCertNum[transClass];
								lastCertNumber.innerHTML = lastCert
									? 'Last issued certificate number: ' +
										originalLastCert +
										'&emsp;&emsp;Next available certificate number: ' +
										nextCertNum[transClass]
									: '';
								lastCertNumber.classList.remove('hidden');
							} else {
								newNotes = 'Transfer (' + thisTrans.notes.trim() + ' dated ' + moment.unix(Number(thisTrans.date)).utc().format('M/D/YY') + ')';
							}
						}
						if (isBB) {
							let firstWord = thisTrans.notes.split(' ')[0];
							let dateStart =
								Number.isInteger(Date.parse(firstWord)) ||
								['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].some((m) =>
									firstWord.toLowerCase().startsWith(m)
								);
							newNotes =
								'Gift from ' +
								(giftUserData.user_name.includes('|') ? giftUserData.user_name.split('|')[1].trim() : giftUserData.user_name.trim()) +
								' - ' +
								moment.unix(Number(thisTrans.date)).utc().format('M/D/YY') +
								' ' +
								(dateStart ? '| ' : '') +
								thisTrans.notes.trim();
						}
					}

					let effectiveTaxBasis = '';
					if (isKnownNumber(thisTrans.taxBasis)) effectiveTaxBasis = Number(thisTrans.taxBasis).toString();
					else if (isKnownNumber(thisTrans._effectiveTaxBasis)) effectiveTaxBasis = Number(thisTrans._effectiveTaxBasis).toString();

					theseGifts[resolvedTranche] = {
						tranche: resolvedTranche,
						shareClass: thisTrans.shareClass,
						securityType: thisTrans.securityType,
						date: newDate,
						notes: newNotes,
						sender: shareholder,
						senderName: nameWithOverride(shareholder),
						receiver: rowRecipientId,
						receiverName: recipientName,
						quantity: qtyTrans,
						sharePrice: thisTrans.sharePrice,
						taxBasis: effectiveTaxBasis,

						// NEW
						certNumber: thisTrans.certNumber || '',
						sourceCert: thisTrans.certNumber || '',
						sourceNotes: thisTrans.notes || '',
						sourceDate: thisTrans.date || '',
					};

					allGifts.push(theseGifts[resolvedTranche]);
					updateConsolidatedTransferCheckbox();
					previewGiftTransfer.classList.remove('disabled');
					adjustBalances(Number(qtyTrans.replace(/[^-.\d]/g, '')), rowRecipientId, resolvedTranche);
					document.getElementById(rowRecipientId + 'AddGift').dispatchEvent(new Event('click'));
					if (isVERM) checkVermeerRule(rowRecipientId);
					return true;
				}

				tranche.addEventListener('focusin', function () {
					currentTranche = trancheCell.innerText.trim().toUpperCase();
					recipientId = rowRecipientId;
				});

				trancheCell.addEventListener('keydown', function (e) {
					let typed = trancheCell.innerText.trim().toUpperCase();
					let availableTranches = getAvailableTranches();
					let applicableTranches = getApplicableTranches(typed);

					if (e.key === 'Tab' || e.key === 'Enter') {
						e.preventDefault();

						if (!typed) return;

						// Prefer exact typed tranche, so "A" wins over AA/AB/...
						if (availableTranches.includes(typed)) {
							commitTranche(typed);
							return;
						}

						// Otherwise accept a unique prefix match
						if (applicableTranches.length === 1) {
							commitTranche(applicableTranches[0]);
							return;
						}
					}
				});

				tranche.addEventListener('keyup', function (e) {
					const isTrancheInput = e.target === trancheCell;
					const onTarget = e.target?.id?.endsWith('|TrancheId') ?? false;
					let thisTranche = trancheCell.innerText.trim().toUpperCase();

					recipientId = rowRecipientId;

					// Ignore bubbled tranche logic from non-tranche cells
					if (!isTrancheInput && onTarget) return;

					// Clear any pending auto-commit for this row
					const timerKey = tranche.id;
					if (trancheAutoTimers[timerKey]) {
						clearTimeout(trancheAutoTimers[timerKey]);
						delete trancheAutoTimers[timerKey];
					}

					if (!thisTranche && !onTarget) {
						e.target.innerText = '';
						return;
					}

					if (!thisTranche) {
						let thisQty = document.getElementById(rowRecipientId + '|' + currentTranche + '-tranche');
						thisQty = thisQty ? thisQty.innerText : null;
						if (thisQty) {
							adjustBalances(-Number(thisQty.replace(/[^-.\d]/g, '')), rowRecipientId, currentTranche);
							allGifts = allGifts.filter((g) => g.receiver != rowRecipientId || g.tranche != currentTranche);
							updateConsolidatedTransferCheckbox();
							document.getElementById(rowRecipientId + 'AddGift').dispatchEvent(new Event('click'));
							renderNewGiftListeners();
							if (isVERM) checkVermeerRule(rowRecipientId);
						}
						return;
					}

					if (onTarget) {
						let availableTranches = getAvailableTranches();
						let applicableTranches = getApplicableTranches(thisTranche);

						if (applicableTranches.length == 1) thisTranche = applicableTranches[0];
						else if (applicableTranches.length > 1 && e.key != 'Tab' && e.key != 'Enter') {
							trancheAutoTimers[timerKey] = setTimeout(() => {
								let pausedTranche = trancheCell.innerText.trim().toUpperCase();
								if (!pausedTranche) return;
								if (getAvailableTranches().includes(pausedTranche)) commitTranche(pausedTranche);
							}, 1000);
							return;
						}

						// For plain typing, auto-commit only when there is exactly one match
						if (availableTranches.includes(thisTranche) && applicableTranches.length == 1) {
							commitTranche(thisTranche);
						}
					} else {
						let i = allGifts.findIndex((g) => g.receiver == rowRecipientId && g.tranche == thisTranche);
						if (i < 0) return;

						switch (e.target.id.split('-')[0]) {
							case 'editableDate':
								allGifts[i].date = Date.parse(e.target.innerText).toString();
								break;
							// case 'editablePre': allGifts[i].pre = e.target.innerText; break;
							case 'editableNotes':
								allGifts[i].notes = e.target.innerText;
								break;
							case 'editableBasis':
								{
									let rawBasis = e.target.innerText.replace(/[^-.\d]/g, '');
									allGifts[i].taxBasis = rawBasis ? Number(rawBasis).toString() : '';
									e.target.innerText = rawBasis ? Number(rawBasis).toLocaleString('en-US', usp) : '';
								}
								break;
						}
					}
				});
			});

			document.querySelectorAll('.gift-date').forEach((dateElem) => {
				dateElem.addEventListener('blur', function () {
					const rawText = this.innerText.trim();

					let parsed = moment(rawText, ['MMMM D, YYYY', 'MMM D, YYYY', 'M/D/YYYY', 'M-D-YYYY', 'YYYY-MM-DD'], true);

					const today = moment().startOf('day');
					const maxDate = moment().add(60, 'days').startOf('day');

					// Replace junk or empty with today
					if (!parsed.isValid()) parsed = today;

					// Clamp to range
					if (!isAdmin) {
						if (parsed.isBefore(today)) parsed = today;
						if (parsed.isAfter(maxDate)) parsed = maxDate;
					}

					// Update display
					this.innerText = parsed.format('MMMM D, YYYY');
				});
			});

			let origQuantity;
			let newQuantity;
			document.querySelectorAll('.gift-qty').forEach((qty) => {
				if (gifts.length > 1 && recipientId != qty.id.split('|')[0]) return;
				qty.addEventListener('focus', function () {
					recipientId = this.id.split('|')[0];
					let thisElem = document.getElementById(this.id);
					origQuantity = Number(thisElem.innerHTML.replace(/[^-.\d]/g, ''));
					if (origQuantity == 0) thisElem.innerHTML = '';
				});
				qty.addEventListener('blur', function () {
					let thisElem = document.getElementById(this.id);
					origQuantity = Number(thisElem.innerHTML.replace(/[^-.\d]/g, ''));
					thisElem.innerHTML = origQuantity.toLocaleString('en-US', stringOptions);
				});
				qty.addEventListener('input', function () {
					let targetTranche = this.id.split('|')[1].replace('-tranche', '').trim();
					let foundTranche = giftTransactions.find((g) => g.tranche == targetTranche);
					let maxQuantity = Number(foundTranche ? foundTranche.quantity : 0);
					let thisElem = document.getElementById(this.id);
					let newText = thisElem.innerHTML.replace(/[^-.\d]/g, '');
					newQuantity = Number(newText);
					thisElem.innerHTML = newQuantity || newText.includes('.') || newText == '0' ? newText : '';
					document.getSelection().collapse(this, this.childNodes.length);
					if (newQuantity > maxQuantity || newQuantity < 0) {
						newQuantity = maxQuantity;
						thisElem.innerHTML = newQuantity ? newText : '';
						document.getSelection().collapse(this, this.childNodes.length);
					}
					let difference = newQuantity - origQuantity;
					adjustBalances(difference, recipientId, targetTranche);
					let thisGiftIndex = allGifts.findIndex((g) => g.receiver == recipientId && g.tranche == targetTranche);
					if (thisGiftIndex >= 0) allGifts[thisGiftIndex].quantity = newQuantity.toString();
					let correntValueElem = document.getElementById('currentValue-' + targetTranche + '|' + recipientId);
					let newPrice = currentPrice(allGifts[thisGiftIndex].shareClass);
					correntValueElem.innerHTML = isNaN(newPrice) ? 'n.a.' : (newQuantity * newPrice).toLocaleString('en-US', usd);
					origQuantity = newQuantity;
					if (isVERM) checkVermeerRule(recipientId);
				});
			});
		}
	}

	function adjustBalances(adjustment, recipient, tranche) {
		if (isNaN(adjustment)) adjustment = 0;
		// TO headline
		console.log('adjustBalances: ', adjustment, recipient, tranche);
		let thisRecip = giftRecipients.find((r) => r.userid == recipient);
		if (thisRecip) {
			thisRecip.after += adjustment;
			if (!BUY_BACK) document.getElementById(recipient + '|After').innerHTML = thisRecip.after.toLocaleString('en-US', stringOptions);
		}

		// FROM headline
		balanceAfter -= adjustment;
		document.getElementById('balanceAfterElem').innerHTML = balanceAfter.toLocaleString('en-US', stringOptions);

		// FROM table
		let quantityTranche = document.getElementById('quantity' + tranche);
		let quantityBefore = Number(quantityTranche.innerHTML.replace(/[^-.\d]/g, ''));
		let quantityAfter = quantityBefore - adjustment;
		quantityTranche.innerHTML = quantityAfter.toLocaleString('en-US', stringOptions);
		if (quantityAfter < 0) {
			quantityTranche.classList.add('red-text');
			quantityTranche.classList.add('font-bold');
			previewGiftTransfer.classList.add('disabled');
		} else {
			quantityTranche.classList.remove('red-text');
			quantityTranche.classList.remove('font-bold');
			previewGiftTransfer.classList.remove('disabled');
		}

		// FROM total footer
		if (toggle != 'Show Zeros') {
			ttlAfter -= adjustment;
			document.getElementById('totalAfter').innerHTML = ttlAfter.toLocaleString('en-US', stringOptions);
		}

		let thisGift = allGifts.find((g) => g.receiver === recipient && g.tranche === tranche);
		let thisShareClass = thisGift ? thisGift.shareClass : '';
		let price = currentPrice(thisShareClass);
		let totalCurrentValue = document.getElementById('totalCurrentValue'); // need re-rendered element
		if (!isNaN(price)) {
			if (!isKnownNumber(ttlCurrentValue)) ttlCurrentValue = 0;
			ttlCurrentValue += adjustment * price;
		}
		totalCurrentValue.innerHTML = isNaN(ttlCurrentValue) ? 'n.a.' : ttlCurrentValue.toLocaleString('en-US', usd);
		totalCurrentValueDiv.classList.remove('hidden');

		// resize modal
		document.getElementById('viewGiftTransferModal').style.overflowY = 'auto';
	}

	function currentPrice(shareClass) {
		let classVals = clientData.equity[shareClass].valuations;
		classVals.sort((a, b) => Number(b.date) - Number(a.date)); // newest to oldest
		if (!classVals?.[0]) return 'n.a.';
		return Number(classVals[0].sharePrice.replace(/[^.\d]/g, ''));
	}

	async function getNextCertNumber() {
		if (!nextCertNum) {
			lastCertNum = {};
			nextCertNum = {};
			if (EXTERNAL_DATA) {
				const dataFile = clientData.transactions_data ? clientData.transactions_data : '';
				if (!dataFile) return;
				let dataFileUrl = await getContentUrl(dataFile);
				try {
					const response = await fetch(dataFileUrl); // 🔹 Ensure fetch waits
					console.log(response);
					const results = await response.text(); // 🔹 Ensure text conversion waits
					// NOTE BENE (3/9/2025): External Data may or may not have a dedicated Certificate column. Painful...
					const data = Papa.parse(results).data;
					const certColumn = data[0][3].toLowerCase().startsWith('cert');
					CERT_COLUMN ||= data.some((row) => row[3]?.includes('#'));
					if (CERT_COLUMN || certColumn) {
						classes.forEach((c) => {
							nextCertNum[c] = '';
							let highestCertNum = 0;
							let classData = data.filter((d) => d[0] == c);
							classData = classData.filter((row) => row[3]?.includes('#') || row[4]?.includes('#'));
							classData.forEach((row) => {
								[3, 4].forEach((index) => {
									// Check only columns 3 and 4
									let cell = row[index];
									if (cell.includes('#')) {
										let match = getCertNumber(cell);
										if (match) {
											let certString = `#${match[2]}`; // Full matched cert (e.g., "#PA-22")
											// Extract numeric portion from certificate (e.g., "22" from "#PA-22")
											let numMatch = certString.match(/(\d+)/);
											if (numMatch) {
												let certNum = Number(numMatch[1], 10);
												if (certNum > highestCertNum) {
													highestCertNum = certNum;
													nextCertNum[c] = certString; // Store full certificate string
												}
											}
										}
									}
								});
							});
							incrementNextCertNumber(c);
							originalLastCertNum ||= {};
							originalLastCertNum[c] = lastCertNum[c];
						});
					}
				} catch (err) {
					console.warn('Something went wrong.', err);
				}
			} else {
				let clientEquity = clientData.equity;
				for (let c in clientEquity) {
					let transactions = clientEquity[c].transactions;
					nextCertNum[c] =
						'#' +
						transactions.reduce((maxCertNum, transaction) => {
							let match = transaction.notes.match(/\(#(\d+)\)/);
							let certNumber = match ? Number(match[1]) : 0;
							return Math.max(maxCertNum, certNumber);
						}, 0); // Start from 1 above the highest certificate number
					incrementNextCertNumber(c);
					originalLastCertNum ||= {};
					originalLastCertNum[c] = lastCertNum[c];
				}
			}
		}
	}

	function incrementNextCertNumber(c) {
		lastCertNum[c] = nextCertNum[c];
		const certNumber = getCertNumber(nextCertNum[c]);
		if (certNumber && certNumber[2]) {
			let newNumber;
			const whole = certNumber[2];
			const suffix = whole.split('-')[1];
			if (suffix) newNumber = suffix.replace(/[^\d.]/g, '');
			else newNumber = whole.replace(/[^\d.]/g, '');
			if (isNaN(newNumber)) nextCertNum[c] = '';
			else nextCertNum[c] = certNumber[0].replace(newNumber, Number(newNumber) + 1);
		} else nextCertNum[c] = '';
	}

	function checkVermeerRule(recipient) {
		let header = document.getElementById('qtyHeader|' + recipient);
		let recipGifts = allGifts.filter((g) => g.receiver == recipient);
		if (!recipGifts) {
			header.innerHTML = 'Quantity';
			return;
		}
		let qtyClassE = recipGifts.filter((g) => g.shareClass == 'E').reduce((a, b) => a + Number(b.quantity), 0);
		let qtyOther = recipGifts.filter((g) => ['V', 'NV'].includes(g.shareClass)).reduce((a, b) => a + Number(b.quantity), 0);
		if (qtyClassE == qtyOther) header.innerHTML = 'Quantity';
		else header.innerHTML = '<span class="orange-text" title="E != V + NV">⚠</span> Quantity';
		console.log('header.innerHTML = ' + header.innerHTML);
	}

	function updateConsolidatedTransferCheckbox() {
		const consolidateTransfers = document.getElementById('consolidateTransfers');
		if (!consolidateTransfers) return;

		const counts = {};
		allGifts.forEach((g) => {
			if (!g?.receiver || !g?.tranche) return;
			counts[g.receiver] = (counts[g.receiver] || 0) + 1;
		});

		const enable = Object.values(counts).some((n) => n > 1);
		consolidateTransfers.disabled = !enable;
		if (!enable) consolidateTransfers.checked = false;
	}

	async function getConsolidatedTransferGifts() {
		const out = [];
		const giftsByRecipient = {};
		await getNextCertNumber();

		allGifts.forEach((g) => {
			if (!g?.receiver) return;
			if (!giftsByRecipient[g.receiver]) giftsByRecipient[g.receiver] = [];
			giftsByRecipient[g.receiver].push(g);
		});

		Object.values(giftsByRecipient).forEach((gifts) => {
			if (gifts.length < 2) {
				out.push(...gifts);
				return;
			}

			const first = gifts[0];
			const qtyTotal = gifts.reduce((sum, g) => sum + Number(String(g.quantity || 0).replace(/[^-.\d]/g, '')), 0);

			const basisNumerator = gifts.reduce((sum, g) => {
				const qty = Number(String(g.quantity || 0).replace(/[^-.\d]/g, ''));
				const basis = isKnownNumber(g.taxBasis) ? Number(g.taxBasis) : isKnownNumber(g.sharePrice) ? Number(g.sharePrice) : 0;
				return sum + qty * basis;
			}, 0);

			const sourceLabel = compactSourceLabel(gifts);
			const newCertNum = CERT_COLUMN ? nextCertNum[first.shareClass] || '' : '';
			if (newCertNum) incrementNextCertNumber(first.shareClass);

			out.push({
				...first,
				tranche: gifts.map((g) => g.tranche).join('+'),
				quantity: qtyTotal.toString(),
				taxBasis: qtyTotal ? (basisNumerator / qtyTotal).toString() : first.taxBasis,
				notes: CERT_COLUMN ? 'Transfer (' + newCertNum + ' from ' + sourceLabel + ')' : 'Transfer (from ' + sourceLabel + ')',
				sourceTranches: gifts.map((g) => ({
					tranche: g.tranche,
					quantity: g.quantity,
					taxBasis: g.taxBasis,
					sharePrice: g.sharePrice,
					nrid: g.nrid,
					certNumber: g.certNumber || '',
					sourceNotes: g.sourceNotes || '',
					sourceDate: g.sourceDate || '',
				})),
			});
		});

		return out;
	}

	function compactSourceLabel(gifts) {
		const certs = gifts
			.map((g) => g.sourceCert || g.certNumber)
			.filter(Boolean)
			.map((c) => String(c).replace(/^0+/, ''));

		if (certs.length) return certs.join(', ');
		return gifts
			.map((g) => g.tranche)
			.filter(Boolean)
			.join(', ');
	}

	function renderTransactionMapTable(giftsForPreview) {
		let rowErrors;
		giftSources = [];
		let badDataCounter = 0;
		let importTransCounter = 0;
		let importGiftTransferMarkup;
		// need new object
		let importTransMap = JSON.parse(JSON.stringify(giftsForPreview || allGifts));
		const CANCEL_REISSUE = CERT_COLUMN; //isVERM;	// need for Ausable and Etnyre too.  Maybe Lucas??

		function expandConsolidatedGifts(gifts) {
			const expanded = [];
			gifts.forEach((g) => {
				if (!Array.isArray(g.sourceTranches) || g.sourceTranches.length < 2) {
					expanded.push(g);
					return;
				}

				// Break back into source-level gifts
				g.sourceTranches.forEach((s) => {
					expanded.push({
						...g,
						tranche: s.tranche,
						quantity: s.quantity,
						taxBasis: s.taxBasis,
						sharePrice: s.sharePrice,
						sourceTranches: [s], // now single
						notes: g.notes, // keep consolidated note for UI
					});
				});
			});
			return expanded;
		}

		const stubCalcMap = expandConsolidatedGifts(importTransMap);

		function sourceTranchesForGift(gift) {
			if (Array.isArray(gift.sourceTranches) && gift.sourceTranches.length) {
				return gift.sourceTranches.map((s) => (typeof s === 'string' ? s : s.tranche)).filter(Boolean);
			}

			return String(gift.tranche || '')
				.split('+')
				.map((t) => t.trim())
				.filter(Boolean);
		}

		if (CANCEL_REISSUE) {
			let uniqueTranches = [...new Set(stubCalcMap.flatMap((item) => sourceTranchesForGift(item)).filter(Boolean))];

			uniqueTranches.forEach((t) => {
				let theseSources = giftTransactions.filter((g) => g.tranche == t);
				if (theseSources.length != 1) {
					console.log('Gift source issue:', t, theseSources);
					alert('Gift source issue.');
					return;
				}
				const giftSource = theseSources[0];
				giftSources.push(giftSource);

				const giftDate = stubCalcMap.find((i) => sourceTranchesForGift(i).includes(t))?.date;
				const trancheSum = stubCalcMap.filter((i) => sourceTranchesForGift(i).includes(t)).reduce((acc, j) => acc + Number(j.quantity), 0);
				const stubAmount = Number(giftSource.quantity) - trancheSum;
				const nextCert = nextCertNum[giftSource.shareClass];

				if (stubAmount > 0) {
					// create two more transactions: a cancellation and a reissue
					let cancellation = {
						tranche: t,
						shareClass: giftSource.shareClass,
						securityType: giftSource.securityType,
						date: giftDate,
						notes: giftSource.certNumber ? 'Cancellation (' + giftSource.certNumber + ')' : 'Cancellation',
						sender: giftSource.receiver,
						senderName: giftSource.receiverName,
						receiver: '',
						receiverName: 'Issuer',
						quantity: stubAmount.toString(),
						sharePrice: giftSource.sharePrice || '',
						taxBasis: giftSource._effectiveTaxBasis != null ? giftSource._effectiveTaxBasis.toString() : '',
					};

					let reissuance = {
						tranche: t,
						shareClass: giftSource.shareClass,
						securityType: giftSource.securityType,
						date: giftDate,
						notes: nextCert ? 'Reissuance (' + nextCert + ' from ' + giftSource.certNumber + ')' : 'Reissuance',
						sender: '',
						senderName: 'Issuer',
						receiver: giftSource.receiver,
						receiverName: giftSource.receiverName,
						quantity: stubAmount.toString(),
						sharePrice: giftSource.sharePrice || '',
						taxBasis: giftSource._effectiveTaxBasis != null ? giftSource._effectiveTaxBasis.toString() : '',
					};

					let insertPoint = 0;
					for (let i = importTransMap.length - 1; i >= 0; i--) {
						if (sourceTranchesForGift(importTransMap[i]).includes(t)) {
							insertPoint = i;
							break;
						}
					}

					importTransMap.splice(insertPoint + 1, 0, cancellation);
					importTransMap.splice(insertPoint + 2, 0, reissuance);
					if (nextCert) incrementNextCertNumber(giftSource.shareClass);
				}
			});
		}

		if (selectedTranches.length > 0) {
			let reason = selectedTranches.length > 1 ? 'Stock Certificate' : 'Stock Certificate';
			let grossQty = 0;
			let grossDollars = 0;
			importTransMap = [];
			selectedTranches.sort();
			selectedTranches.forEach((t) => {
				let giftSource = giftTransactions.find((g) => g.tranche == t);
				giftSources.push(giftSource);
				let consolTranche = {
					tranche: t,
					shareClass: giftSource.shareClass,
					securityType: giftSource.securityType,
					date: Date.now().toString(),
					notes: reason + (giftSource.certNumber ? ' Cancellation (' + giftSource.certNumber + ')' : ' Cancellation'),
					sender: giftSource.receiver,
					senderName: giftSource.receiverName,
					receiver: '',
					receiverName: 'Issuer',
					quantity: giftSource.quantity,
					sharePrice: giftSource.sharePrice || '',
					taxBasis: giftSource._effectiveTaxBasis.toString() || '',
				};
				let consolQty = Number(giftSource.quantity.replace(/[^.\d]/g, ''));
				grossQty += consolQty;
				grossDollars += consolQty * Number(isNaN(giftSource.sharePrice) ? 0 : giftSource.sharePrice.replace(/[^.\d]/g, ''));
				importTransMap.push(consolTranche);
			});

			let reissuance = JSON.parse(JSON.stringify(importTransMap[0]));
			const nextCert = nextCertNum[reissuance.shareClass];
			reissuance.tranche = 'NEW';
			reissuance.notes = reason + (nextCert && CERT_COLUMN ? ' Reissuance (' + nextCert + ')' : ' Reissuance');
			reissuance.receiver = reissuance.sender;
			reissuance.receiverName = reissuance.senderName;
			reissuance.sender = '';
			reissuance.senderName = 'Issuer';
			reissuance.quantity = grossQty.toString();
			reissuance.sharePrice = (grossDollars / grossQty).toLocaleString('en-US', m5);

			importTransMap.push(reissuance);
			// incrementNextCertNumber(reissuance.shareClass);
		}

		let importTransTarget = importTransMap.length;
		let headings = ['Tranche', 'Date', 'Sender', 'Receiver', 'Description', 'Quantity', 'Tax Basis'];
		if (CLASS_COLUMN) headings = ['Tranche', 'Class', 'Date', 'Sender', 'Receiver', 'Description', 'Quantity', 'Tax Basis'];

		if (!importTransMap || !importTransMap.length) {
			importGiftTransferMarkup = `
			<div class="col s12">
				<div class="py-12 bg-grey-lightest border-blue-dotted rounded center-align">
					<p class="max-w-sm mx-auto">No transfer data found.</p>
				</div>
			</div>
			`;
		} else {
			rowErrors = new Array(importTransMap.length).fill('');
			importGiftTransferMarkup = `
				<div class="row">
					<div class="col s12">
					<h3 id="importGiftTransferHeading" class="text-lg center-align mb-0 font-bold">Ready for Import</h3>
					</div>
				</div>
				<div class="table-wrap border-grey" style="width: fit-content;">
					<div class="sm-hz-scroll-no-margin">
						<table id="importGiftTransferSortTable" class="highlight table-content">
							<thead>
								<tr>
									${headings
										.map(
											(h) => `
										<th class="text-xs center-align">${h}</th>
										`
										)
										.join('')}
									<th class="text-xs center-align">Status</th>
								</tr>
							</thead>
							<tbody>
							${importTransMap
								.map(
									(t, i) =>
										`
								<tr class="import-tranche">
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.tranche}</p>
									</td>
									${
										CLASS_COLUMN
											? `
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.shareClass}</p>
									</td>`
											: ``
									}
									<td>
										<p id="editableImportDate-${i}" class="text-xs mb-0 mt-0 center-align" contenteditable>${moment
											.unix(Number(t.date) / 1000)
											.utc()
											.format('MMM D, YYYY')}</p>
									</td>
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.senderName}</p>
									</td>
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${t.receiverName}</p>
									</td>
									<td>
										<p id="editableImportNotes-${i}" class="text-xs mb-0 mt-0 center-align" contenteditable>${t.notes}</p>
										<!-- <p class="text-xs mb-0 mt-0 center-align">${t.pre && t.notes ? t.pre + ' - ' + t.notes : t.pre ? t.pre : t.notes}</p> -->
									</td>
									<td>
										<p class="text-xs mb-0 mt-0 center-align">${Number(t.quantity).toLocaleString('en-US', stringOptions)}</p>
									</td>
									<td>
										<p id="editableImportBasis-${i}" class="text-xs mb-0 mt-0 center-align" contenteditable>${
											isKnownNumber(t.taxBasis)
												? Number(String(t.taxBasis).replace(/[^.\d]/g, '')).toLocaleString('en-US', usp)
												: isNA(t.taxBasis)
													? t.taxBasis
													: 'n.a.'
										}
										</p>
									</td>
									<td id="${'row-' + i}" class="center-align">${dataOkay(t, i) ? greenCheck : redClear}</td>
								</tr>
								`
								)
								.join('')}
							</tbody>
						</table>
					</div>
				</div>
				<div class="flex justify-between items-center">
					<a id="continueEditing" href="#" class="modal-close waves-effect waves-light btn grey mt-6 left">Go Back</a>
	                  <label class="mt-4" title="If checked, cap table (or capital account) balances will be&#10;adjusted according to the allocations. Otherwise the&#10;cap table will remain unchanged." style="transform: scale(0.8);">
	                    <input type="checkbox" id="adjustCapTableAutomatically" checked>
	                    <span style="display:inline-table;">Automatically adjust cap table balances</span>
	                  </label>
					<p class="mr-4 mt-8 text-sm right"><a id="exportGiftTransferMap" href="" download="" target="_blank" rel="noopener noreferrer">Export to Excel</a></p>
					<button id="proceedWithGiftTransferImport" class="right waves-effect waves-light btn mt-6 ml-8 bg-grey-darker">Proceed with Import</button>
				</div>
			`;
		}

		let importGiftTransfer = document.getElementById('importGiftTransfer');
		let importGiftTransferTable = document.getElementById('importGiftTransferTable');
		importGiftTransferTable.innerHTML = importGiftTransferMarkup;
		importGiftTransferTable.classList.remove('hidden');

		let proceedWithGiftTransferImport = document.getElementById('proceedWithGiftTransferImport');
		let importGiftTransferHeading = document.getElementById('importGiftTransferHeading');
		let statementWaitState = document.getElementById('statementWaitState');
		let continueEditing = document.getElementById('continueEditing');
		let processHeader = document.getElementById('processHeader');

		function dataOkay(newTrans, index) {
			if (!capTableData) capTableData = NthUtil.sessionStore.readCapTable(client);
			let validUsers = [];
			capTableData.forEach((u) => validUsers.push(u.userid));
			badDataCounter++;
			let thisSender = capTableData.find((s) => s.userid == newTrans.sender);
			let senderShares = thisSender ? thisSender.clients[client].shares[newTrans.shareClass] : null;
			let senderApproved = senderShares ? senderShares.approved : '0';
			let timeStamp = Number(newTrans.date);
			let types = [
				'Ordinary Shares',
				'Restricted Shares',
				'RSUs',
				'Profits Interest',
				'SARs',
				'Options',
				'Warrants',
				'Convertibles',
				'Debt',
				'Capital Contribution',
				'Partnership Interest',
			];
			if (!classes.includes(newTrans.shareClass)) {
				rowErrors[index] = newTrans.shareClass + ' is not a Class in Company Profile / Equity.';
				return false;
			}
			if (!types.includes(newTrans.securityType)) {
				rowErrors[index] = newTrans.securityType + ' is not a recognized Security Type.';
				return false;
			}
			if (newTrans.strikePrice && newTrans.strikePrice <= 0) {
				rowErrors[index] = newTrans.strikePrice + ' is not a valid Strike Price.';
				return false;
			}
			if (newTrans.expDate && newTrans.expDate.toLowerCase() == 'invalid date') {
				rowErrors[index] = newTrans.expDate + ' is not a valid exp date.';
				return false;
			}
			if (newTrans.date.toLowerCase() == 'invalid date' || timeStamp < 0 || timeStamp > 1924992000000) {
				// December 31, 2030
				rowErrors[index] =
					moment
						.unix(Number(newTrans.date) / 1000)
						.utc()
						.format('MMM D, YYYY') + ' is not a valid date.';
				return false;
			}
			if (!validUsers.includes(newTrans.sender) && newTrans.senderName.toLowerCase() != 'issuer') {
				rowErrors[index] = newTrans.sender + ' is not a valid Sender.';
				return false;
			}
			if (!validUsers.includes(newTrans.receiver) && !['issuer', clientData.company_name.toLowerCase()].includes(newTrans.receiverName.toLowerCase())) {
				rowErrors[index] = newTrans.receiver + ' is not a valid Receiver.';
				return false;
			}
			if (Number(newTrans.quantity) <= 0) {
				rowErrors[index] = newTrans.quantity + ' is not a valid Quantity.';
				return false;
			}
			// if (thisSender && thisSender.userid.toLowerCase() != "issuer" && Number(senderApproved) < Number(newTrans[7])) {
			// 	rowErrors[index] = newTrans[nmCol] + " exceeds Approved balance.";
			// 	return false;
			// }
			if (Number(newTrans.sharePrice) < 0) {
				rowErrors[index] = newTrans.sharePrice + ' is not a valid Share Price.';
				return false;
			}
			if (Number(newTrans.taxBasis) < 0) {
				rowErrors[index] = newTrans.taxBasis + ' is not a valid Tax Basis.';
				return false;
			}
			badDataCounter--;
			return true;
		}

		let num = 'zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen'.split(
			' '
		);
		let tens = 'twenty thirty forty fifty sixty seventy eighty ninety'.split(' ');
		function number2words(n) {
			if (n < 20) return num[n];
			let digit = n % 10;
			if (n < 100) return tens[~~(n / 10) - 2] + (digit ? '-' + num[digit] : '');
			if (n < 1000) return num[~~(n / 100)] + ' hundred' + (n % 100 == 0 ? '' : ' and ' + number2words(n % 100));
			return number2words(~~(n / 1000)) + ' thousand' + (n % 1000 != 0 ? ' ' + number2words(n % 1000) : '');
		}

		if (badDataCounter > 0) {
			rowErrors.forEach(function (err, i) {
				if (err.length)
					document.getElementById('row-' + i).innerHTML =
						`<span class="material-icons-outlined align-middle" style="color: red; font-size: 30px;" title="${err}">clear</span>`;
			});
			importGiftTransferHeading.innerHTML =
				capitalize(number2words(badDataCounter)) + (badDataCounter > 1 ? ' rows have' : ' row has') + ' bad data.  Please try again.';
			proceedWithGiftTransferImport.classList.add('disabled');
			// return false;
		} else if (importTransMap && importTransMap.length) {
			importGiftTransferHeading.innerHTML =
				capitalize(number2words(importTransMap.length)) + ' Transaction' + (Number(importTransMap.length) > 1 ? 's' : '') + ' Ready for Import';
			proceedWithGiftTransferImport.classList.remove('disabled');
		}

		let table = document.getElementById('importGiftTransferSortTable');
		if (table) {
			let sort = new Tablesort(table);
			document.getElementById('exportGiftTransferMap').addEventListener('click', function (e) {
				e.preventDefault();
				export_table_to_excel('importGiftTransferSortTable', 'Import Gift Transfer Map (' + new Date().toLocaleString() + ').csv');
			});
		}

		M.Modal.getInstance(viewGiftTransferModal).close();
		M.Modal.getInstance(importGiftTransfer).open();

		document.querySelectorAll('.import-tranche').forEach((tranche) => {
			tranche.addEventListener('keyup', function (e) {
				switch (e.target.id.split('-')[0]) {
					case 'editableImportDate':
						importTransMap[e.target.id.replace('editableImportDate-', '')].date = Date.parse(e.target.innerText).toString();
						break;
					case 'editableImportNotes':
						importTransMap[e.target.id.replace('editableImportNotes-', '')].notes = e.target.innerText;
						break;
					case 'editableImportBasis':
						importTransMap[e.target.id.replace('editableImportBasis-', '')].taxBasis = Number(
							e.target.innerText.replace(/[^-.\d]/g, '')
						).toLocaleString('en-US', usp);
						break;
				}
			});
		});

		if (continueEditing)
			continueEditing.addEventListener('click', function (e) {
				e.preventDefault();
				M.Modal.getInstance(importGiftTransfer).close();
				M.Modal.getInstance(viewGiftTransferModal).open();
			});

		if (proceedWithGiftTransferImport) {
			proceedWithGiftTransferImport.addEventListener('click', async function (e) {
				e.preventDefault();
				M.Modal.getInstance(importGiftTransfer).close();
				M.Modal.getInstance(statementWaitState).open();
				// Wait for axios call completion before continuing
				if (STD_EXT_DATA) compileNewTransactions();
				else importNewTransactions();
			});
		}

		async function compileNewTransactions() {
			statementWaitHeader.innerHTML = 'Compiling ' + importTransMap.length + ' new transaction' + (importTransMap.length > 1 ? 's.' : '.');
			let dataFile = clientData.transactions_data ? clientData.transactions_data : '';
			if (!dataFile) return;
			let dataFileUrl = await getContentUrl(dataFile);

			fetch(dataFileUrl)
				.then(function (response) {
					console.log(response);
					return response.text();
				})
				.then(function (results) {
					// remove header row
					let lines = results.split('\n');
					const certColumn = lines[0].split(',')[3]?.trim().toLowerCase().startsWith('cert');
					lines.splice(0, 1);
					results = lines.join('\n');
					modifyCSV(results, certColumn, dataFile);
				})
				.catch(function (err) {
					console.warn('Something went wrong.', err);
				});

			function csvSafe(str) {
				if (typeof str !== 'string') return str;
				return str.includes(',') || str.includes('"') || str.includes('\n') ? `"${str.replace(/"/g, '""')}"` : str;
			}

			async function modifyCSV(results, certColumn, dataFile) {
				console.log(importTransMap);
				let addedCSV = '';
				let adjust = document.getElementById('adjustCapTableAutomatically').checked;

				function cleanNumericString(val, allowNegative = false) {
					if (val == null) return '';
					let s = String(val).trim().toLowerCase();
					if (s === '' || isNA(s)) return '';
					return allowNegative ? String(val).replace(/[^-.\d]/g, '') : String(val).replace(/[^.\d]/g, '');
				}

				function formatNumericForCsv(val, allowNegative = false) {
					let clean = cleanNumericString(val, allowNegative);
					if (clean === '' || clean === '-' || clean === '.' || clean === '-.') return '';
					let num = Number(clean);
					return isNaN(num) ? '' : num.toLocaleString('en-US', usp);
				}

				for (let i = 0; i < importTransMap.length; i++) {
					let r = importTransMap[i];
					let newRow = '';
					let nrid = uuidv4();
					let cleanSharePrice = cleanNumericString(r.sharePrice, false);
					let cleanTaxBasis = cleanNumericString(r.taxBasis, true);
					newRow += r.shareClass + ',';
					newRow +=
						moment
							.unix(Number(r.date) / 1000)
							.utc()
							.format('YYYY-MM-DD') + ',';
					newRow += r.securityType + ',';
					newRow += csvSafe(r.notes) + ',';
					newRow += nrid + ',';
					newRow += csvSafe(r.senderName) + ',';
					newRow += r.sender + ',';
					newRow += csvSafe(r.receiverName) + ',';
					newRow += r.receiver + ',';
					newRow += r.quantity.replace(/[^.\d]/g, '') + ',';
					newRow += formatNumericForCsv(r.sharePrice, false) + ',';
					newRow += ','; // Exact Price
					newRow += ','; // Reference Price
					newRow += ','; // Qty * Exact Price
					newRow += ','; // Qty * Ref. Price
					newRow += ','; // Strike Price
					newRow += ','; // Expiration Date
					newRow += formatNumericForCsv(r.taxBasis, true) + '\r\n';
					addedCSV += newRow;

					if (adjust) {
						let adjustParams = {
							shareClass: r.shareClass,
							quantity: r.quantity.replace(/[^.\d]/g, ''),
							senderId: r.sender,
							receiverId: r.receiver,
						};
						await adjustCapTable(adjustParams);
					}
				}

				let rows = results.split('\n');
				giftSources.forEach((s) => {
					for (let i = 0; i < rows.length; i++) {
						if (rows[i].includes(s.nrid)) {
							let fields = rows[i].split(',');
							fields[3] = fields[3].replace('#', '');
							fields[4] = fields[4].replace('#', '');
							rows[i] = fields.join(',');
							break;
						}
					}
				});
				results = rows.join('\n');

				let header =
					'Class,Date,Security Type,Description,nrid,Sender,Sender Email,Receiver,Receiver Email,Quantity,Share Price,Exact Price,Reference Price,Qty * Exact Price, Qty * Ref. Price,Strike Price,Expiration Date,Tax Basis\r\n';

				let newResults = header + addedCSV + results;
				uploadCSV(newResults);
				if (giftSources[0]) incrementNextCertNumber(giftSources[0].shareClass);
			}

			function uploadCSV(file) {
				// send file to S3 bucket
				console.log(Date.now());
				if (clientData.transactions_data) {
					console.log(clientData.transactions_data.substring(13, 99));
					sendToS3(Date.now() + clientData.transactions_data.substring(13, 99)); // <-- CATCH 22 must be "seeded" in DynamoDB
				} else {
					sendToS3(Date.now() + '_' + client + '_transactions.csv');
				}

				function sendToS3(awsFileToUpload) {
					axios
						.get(authUploadUrl, {
							params: {
								filename: client + '/' + awsFileToUpload,
								bucket: 'reports.nthround.io',
								client: client,
								userid: authedUser,
								cookie: cookie,
							},
						})
						.then(function (res1) {
							//console.log(res1);
							let formData = secureFormData(res1);
							formData.append('file', file);
							axios
								.post(res1.data.url, formData, axconf)
								.then(function (res2) {
									console.log('DataSource update response: ', res2);
									let dataToUpdate = { transactions_data: awsFileToUpload };
									clientData.transactions_data = awsFileToUpload;
									console.log('dataToUpdate:', dataToUpdate);
									sendData(dataToUpdate, 'transactions-data', true);

									if (window.analytics)
										window.analytics.track('DataSource Updated', {
											userEmail: authedUser,
											workspace: client,
											dataSourceName: awsFileToUpload,
										});
								})
								.catch(function (err2) {
									console.error(err2);
								});
						})
						.catch(function (err1) {
							console.error(err1);
						});
				}
			}

			function sendData(params, api, toast) {
				sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));
				let apiUrl = 'https://api.nthround.io/portal/clientConfig/' + api;
				params.client = client;
				params.userid = authedUser;
				params.cookie = cookie;
				axios
					.put(
						apiUrl,
						{
							body: 'body',
						},
						{
							params,
						}
					)
					.then(function (response) {
						console.log(response);
						clearPendingRequests('Processed');
					})
					.catch(function (error) {
						console.error(error);
					});
			}
		}

		async function importNewTransactions() {
			statementWaitHeader.innerHTML = 'Importing ' + importTransMap.length + ' new transaction' + (importTransMap.length > 1 ? 's.' : '.');

			// Import transactions sequentially
			for (let i = 0; i < importTransMap.length; i++) {
				await createNewTransaction(transParams(importTransMap[i]), false);
			}

			console.log('Finished importing transactions.');

			// Process gift sources sequentially
			for (let i = 0; i < giftSources.length; i++) {
				let patchParams = {
					class_name: giftSources[i].shareClass,
					date: giftSources[i].date.toString(),
					quantity: giftSources[i].quantity.replace(/[^.\d]/g, ''),
					sender_id: giftSources[i].sender,
					sender_name: giftSources[i].senderName,
					receiver_id: giftSources[i].receiver,
					receiver_name: giftSources[i].receiverName,
					share_price: (giftSources[i].sharePrice || '').replace(/[^.\d]/g, ''),
					tax_basis: (giftSources[i].taxBasis || '').replace(/[^-.\d]/g, ''),
					security_type: giftSources[i].securityType,
					nrid: giftSources[i].nrid,
					notes: giftSources[i].notes.replace('#', ''),
					// expDate: giftSources[i].expDate,
					// strike_price: giftSources[i].strike_price,
					userid: authedUser,
					cookie: cookie,
					client: client,
				};

				try {
					const res = await axios.patch(urlTransactions, { body: 'body' }, { params: patchParams });
					console.log(res);
				} catch (err) {
					console.error(err);
				}
			}

			document.dispatchEvent(new Event('RefreshSessionStorage'));
			console.log('Completed processing gift sources.');
			if (CERT_COLUMN) incrementNextCertNumber(giftSources[0]?.shareClass);
		}

		// Transaction parameters helper
		function transParams(row) {
			return {
				shareClass: row.shareClass,
				securityType: row.securityType,
				date: (Number(row.date) / 1000).toFixed(0),
				description: row.notes,
				sender: row.sender,
				receiver: row.receiver,
				senderName: row.senderName,
				receiverName: row.receiverName,
				quantity: row.quantity.replace(/[^.\d]/g, ''),
				sharePrice: String(row.sharePrice || '').replace(/[^.\d]/g, ''),
				taxBasis: String(row.taxBasis || '').replace(/[^-.\d]/g, ''),
			};
		}

		// Updated createNewTransaction to support async/await
		async function createNewTransaction(transParams, isJustOne) {
			if (!isJustOne) importTransCounter++;
			let date = DOMPurify.sanitize(transParams.date);
			let expDate = DOMPurify.sanitize(transParams.expDate);
			let description = DOMPurify.sanitize(transParams.description);
			let shareClass = DOMPurify.sanitize(transParams.shareClass);
			let securityType = DOMPurify.sanitize(transParams.securityType);
			let strikePrice = DOMPurify.sanitize(String(transParams.strikePrice || '').replace(/[^.\d]/g, ''));
			let sharePrice = DOMPurify.sanitize(String(transParams.sharePrice || '').replace(/[^.\d]/g, ''));
			let taxBasis = DOMPurify.sanitize(String(transParams.taxBasis || '').replace(/[^-.\d]/g, ''));
			let quantity = DOMPurify.sanitize(transParams.quantity.replace(/[^.\d]/g, ''));
			let sender = DOMPurify.sanitize(transParams.sender);
			let receiver = DOMPurify.sanitize(transParams.receiver);

			if (sender.startsWith('Issuer')) {
				receiverId = receiver;
				senderName = 'Issuer';
			} else if (receiver.startsWith('Issuer')) {
				senderId = sender;
				receiverName = 'Issuer';
			} else {
				senderId = sender;
				receiverId = receiver;
			}

			if (document.getElementById('adjustCapTableAutomatically').checked) {
				await adjustCapTable({
					shareClass: shareClass,
					quantity: quantity,
					senderId: senderId,
					receiverId: receiverId,
				});
			}

			try {
				const res = await axios.put(
					urlTransactions,
					{
						body: 'body',
					},
					{
						params: {
							userid: authedUser,
							cookie: cookie,
							client: client,
							class_name: shareClass,
							date: date,
							expDate: expDate,
							notes: description,
							security_type: securityType,
							strike_price: strikePrice,
							share_price: sharePrice,
							tax_basis: taxBasis,
							quantity: quantity,
							sender_id: senderId,
							receiver_id: receiverId,
							sender_name: senderName,
							receiver_name: receiverName,
						},
					}
				);

				let newTransaction = {
					date: date,
					expDate: expDate,
					notes: description,
					securityType: securityType,
					shareClass: shareClass,
					strikePrice: strikePrice,
					sharePrice: sharePrice,
					taxBasis: taxBasis,
					quantity: quantity,
					sender: senderId,
					receiver: receiverId,
					senderName: senderName,
					receiverName: receiverName,
					nrid: res.data.nrid,
				};

				if (!clientData.equity[shareClass].transactions) clientData.equity[shareClass].transactions = [];
				clientData.equity[shareClass].transactions.push(newTransaction);
				sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

				if (!isJustOne && importTransCounter >= importTransTarget) {
					clearPendingRequests('Processed');
				}
			} catch (err) {
				console.error(err);
			}

			// if (isJustOne) M.Modal.getInstance(statementWaitState).close();
		}

		async function adjustCapTable(adjustParams) {
			let shareAmount = Number(adjustParams.quantity);
			if (!shareholderData) shareholderData = JSON.parse(sessionStorage.getItem('shareholder.Data'));
			if (!capTableData) capTableData = NthUtil.sessionStore.readCapTable(client);
			if (!capTableData || !shareholderData) return;
			if (adjustParams.senderId && adjustParams.senderId.includes('@')) {
				let senderOwned = 0;
				let senderApproved = 0;
				let senderIndex = capTableData.findIndex((x) => x.userid == adjustParams.senderId);
				let senderClient = capTableData[senderIndex].clients[client];
				if (senderClient) {
					let senderClass = senderClient.shares[adjustParams.shareClass];
					if (senderClass && Number(senderClass.owned) >= shareAmount && Number(senderClass.approved) >= shareAmount) {
						let senderOwned = Number(senderClass.owned);
						let senderApproved = Number(senderClass.approved);
						// senderOwned -= shareAmount;
						// senderApproved -= shareAmount;

						// PRECISION LOGIC
						// per-client precision (4 or 6, etc.)
						const SCALE = 3;
						const EPS = 0.5 * 10 ** -SCALE; // half-ULP at that scale
						// zero-aware subtract (one-liner)
						const sub = (x, y) => (Math.abs(x - y) <= EPS ? 0 : x - y);
						senderOwned = sub(senderOwned, shareAmount);
						senderApproved = sub(senderApproved, shareAmount);

						shareholderData.clients[client].shares[adjustParams.shareClass].owned = senderOwned.toString();
						shareholderData.clients[client].shares[adjustParams.shareClass].approved = senderApproved.toString();
						capTableData[senderIndex].clients[client].shares[adjustParams.shareClass].owned = senderOwned.toString();
						capTableData[senderIndex].clients[client].shares[adjustParams.shareClass].approved = senderApproved.toString();
						sessionStorage.setItem('shareholder.Data', JSON.stringify(shareholderData));
						NthUtil.sessionStore.updateCapTable(client, capTableData);
						await axios.post(
							'https://api.nthround.io/portal/user/update-user-client-data',
							JSON.stringify({
								client: client,
								userid: authedUser,
								cookie: cookie,
								holder: adjustParams.senderId,
								data: capTableData[senderIndex].clients[client],
							})
						);
					} else {
						// abort
					}
				}
			}
			if (adjustParams.receiverId && adjustParams.receiverId.includes('@')) {
				let receiverOwned = 0;
				let receiverApproved = 0;
				let receiverIndex = capTableData.findIndex((x) => x.userid == adjustParams.receiverId);
				let receiverClient = capTableData[receiverIndex].clients[client];
				if (receiverClient) {
					let receiverClass = receiverClient.shares[adjustParams.shareClass];
					if (receiverClass) {
						receiverOwned = Number(receiverClass.owned);
						receiverApproved = Number(receiverClass.approved);
					} else {
						let newSharesObj = {
							owned: '0',
							approved: '0',
							committed: '0',
							permitPurchase: true,
						};
						capTableData[receiverIndex].clients[client].shares[adjustParams.shareClass] = newSharesObj;
					}
					let itsClose = (Math.abs(receiverOwned - receiverApproved) * 200) / (receiverOwned + receiverApproved) < 1 ? true : false;
					if (receiverOwned + receiverApproved < 0.00001) itsClose = true;
					receiverOwned += shareAmount;
					if (itsClose) receiverApproved += shareAmount;

					// added 12-17-2024 (not sure we need the test, but it can't hurt)
					if (adjustParams.receiverId == shareholderData.userid) {
						shareholderData.clients[client].shares[adjustParams.shareClass].owned = receiverOwned.toString();
						shareholderData.clients[client].shares[adjustParams.shareClass].approved = receiverApproved.toString();
						sessionStorage.setItem('shareholder.Data', JSON.stringify(shareholderData));
					}

					capTableData[receiverIndex].clients[client].shares[adjustParams.shareClass].owned = receiverOwned.toString();
					capTableData[receiverIndex].clients[client].shares[adjustParams.shareClass].approved = receiverApproved.toString();
					NthUtil.sessionStore.updateCapTable(client, capTableData);
					await axios.post(
						'https://api.nthround.io/portal/user/update-user-client-data',
						JSON.stringify({
							client: client,
							userid: authedUser,
							cookie: cookie,
							holder: adjustParams.receiverId,
							data: capTableData[receiverIndex].clients[client],
						})
					);
				}
			}
		}
	}

	async function clearPendingRequests(newStatus) {
		// Get transfer requests for this user
		let requests = shareholderData.clients[client].transfer_requests;
		if (requests && Object.keys(requests).length > 0) {
			statementWaitHeader.innerHTML = 'Your browser will refresh. Stand by...';

			// Update all "Open" gifts' status to "Processed"
			Object.values(requests)
				.flat()
				.forEach((gift) => {
					if (gift.status === 'Open') gift.status = newStatus;
				});

			// Save updated data
			sessionStorage.setItem('shareholder.Data', JSON.stringify(shareholderData));

			try {
				const response = await axios.post(
					'https://api.nthround.io/portal/user/update-user-client-data',
					JSON.stringify({
						client: client,
						userid: authedUser,
						cookie: cookie,
						holder: shareholder,
						data: shareholderData.clients[client],
					})
				);
				console.log(response);
				showToast('success-toast', 'Data updated successfully!');
				document.dispatchEvent(new Event('RefreshSessionStorage'));
				setTimeout(() => {
					M.Modal.getInstance(statementWaitState).close();
					location.reload();
				}, 5000);
			} catch (error) {
				console.error(error);
			}
		} else {
			showToast('success-toast', 'Data updated successfully!');
			document.dispatchEvent(new Event('RefreshSessionStorage'));
			M.Modal.getInstance(statementWaitState).close();
			document.dispatchEvent(new CustomEvent('renderShareholderView', { detail: { shareholder: shareholder, refreshed: true } }));
		}
	}

	function sendThisRequest() {
		let timestamp = Date.now().toString();
		const waitingModal = document.getElementById('waitingModal');
		M.Modal.getInstance(viewGiftTransferModal).close();
		M.Modal.getInstance(waitingModal).open();
		// previewGiftTransfer.classList.add('disabled');
		// previewGiftTransfer.innerHTML = "One moment please...";
		let purpose = BUY_BACK ? labelBB + ' Request' : 'Share Transfer Request';
		let giftHtml =
			giftHeadline.innerHTML +
			'<br>' +
			balanceHeadline.innerHTML.replace('Shares Owned Now:', 'Shares Owned:') +
			'<br>' +
			userGiftTransferTable.innerHTML +
			'<br>' +
			totalCurrentValueDiv.innerHTML +
			'<br>' +
			viewRecipients.innerHTML;
		giftHtml = cleanAndFormatHtml(giftHtml);

		function cleanAndFormatHtml(giftHtml) {
			// Parse the raw HTML into a DOM object
			const parser = new DOMParser();
			const doc = parser.parseFromString(giftHtml, 'text/html');

			// Add professional heading at the top
			const headingDiv = document.createElement('div');
			const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
			headingDiv.innerHTML = `
				<h1 style="text-align: center; font-size: 20px; color: #2c3e50; margin: 34px 0 5px;">${purpose}</h1>
				<div style="text-align: center; font-size: 14px; color: #555; margin: 0 0 20px;">Made on ${today} by ${userData.user_name}</div>
			`;

			doc.getElementById('showHidePriorsDiv')?.remove();

			// Inject the heading before the content
			const body = doc.body;
			body.insertBefore(headingDiv, body.firstChild);

			// Remove all hidden elements
			doc.querySelectorAll(".hidden, [style*='display: none']").forEach((el) => el.remove());

			// Remove "Remove" buttons
			doc.querySelectorAll('.remove-gift-recipient').forEach((el) => el.remove());

			// Remove checkboxes but retain the "Tranche" designation
			doc.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
				const td = checkbox.closest('td');
				if (td) {
					const trancheDesignation = td.querySelector('div.shareholder-img');
					if (trancheDesignation) {
						td.innerHTML = trancheDesignation.outerHTML; // Keep the tranche designation
					} else {
						td.innerHTML = ''; // Replace with empty content if no designation exists
					}
				}
			});

			// Add professional styles
			const style = `
				<style>
					body {
						font-family: 'Source Sans Pro', sans-serif;
						font-size: 12px;
						margin: 1in;
					}
					h1, h2, h5 {
						color: #2c3e50;
						text-align: center;
						margin: 0.1in 0 0.1in;
					}
					.table-heading {
						background-color: #2c3e50;
						color: white;
						font-weight: bold;
						text-align: center;
						padding: 4px;
						font-size: 12px; /* Larger heading size */
					}
					table {
						width: 100%;
						border-collapse: collapse;
						margin: 0.1in 0;
					}
					th, td {
						border: 1px solid #ddd;
						text-align: center;
						padding: 4px;
						font-size: 12px; /* Table font size remains consistent */
					}
					th {
						background-color: #f4f4f4;
						font-weight: bold;
						font-size: 13px; /* Slightly larger than table rows */
					}
					strong {
						font-weight: bold;
						font-size: 14px; /* Larger font size for names */
					}
					.ownership {
						font-weight: bold;
						font-size: 14px; /* Match label size for numerals */
						color: #555;
					}
					.recip-div {
						margin-top: 0.2in; /* Add vertical spacing between recipient sections */
					}
				</style>
			`;

			// Inject the styles into the document head
			const styleElement = document.createElement('style');
			styleElement.innerHTML = style;
			doc.head.appendChild(styleElement);

			// Add "To: " before each recipient's name and ensure font size matches sender's name
			doc.querySelectorAll('.recip-div .row .col.s12.m6').forEach((el) => {
				el.innerHTML = `To: <strong>${el.textContent.trim()}</strong>`;
				el.querySelector('strong').style.fontSize = '14px'; // Larger size for names
			});

			// Make sender's name bold and ensure proper size
			const senderElement = doc.querySelector('span.text-light');
			if (senderElement) {
				senderElement.innerHTML = `<strong>${senderElement.textContent.trim()}</strong>`;
				senderElement.querySelector('strong').style.fontSize = '14px'; // Match recipient font size
			}

			// Ensure before/after ownership numerals match label size
			doc.querySelectorAll('.text-primary').forEach((el) => {
				el.style.fontSize = '14px'; // Match the subheading labels
				el.style.fontWeight = 'bold'; // Ensure boldness
				el.style.color = '#555'; // Consistent coloring
			});

			// Remove empty rows at the bottom of each recipient's section
			doc.querySelectorAll('.recip-div table tbody').forEach((tbody) => {
				const rows = Array.from(tbody.querySelectorAll('tr'));
				rows.forEach((row) => {
					const isEmptyRow = Array.from(row.cells).every((cell) => !cell.textContent.trim());
					if (isEmptyRow) row.remove();
				});
			});

			// Reduce vertical spacing for p, .row, and tables
			doc.querySelectorAll('p, .row, table').forEach((el) => {
				el.style.marginTop = '0.1in';
				el.style.marginBottom = '0.1in';
			});

			// Return the cleaned and formatted HTML as a string
			return doc.documentElement.outerHTML;
		}

		const giftString = JSON.stringify(theseGifts);
		const giftBlob = new Blob([JSON.stringify(theseGifts)], { type: 'application/json' });
		const giftFile = new File([giftBlob], purpose.replace(/ /g, '_') + '_from_' + userData.userid + '.json', { type: 'application/json' });

		uploadGiftRequestToYourDocs();

		async function uploadGiftRequestToYourDocs() {
			// Prepare new document to be added to the user's documents
			let newDoc = {
				type: 'Call/Notice',
				tag: 'ALL',
				name: purpose,
				investor: userData.userid,
				description: 'From ' + userData.user_name,
				require2Factor: false,
				date: moment().format('MMM D, YYYY'),
				id: timestamp,
			};

			// Prepare parameters for the document upload API
			let params = {
				...newDoc,
				client: client,
				userid: authedUser,
				cookie: cookie,
				htmlResults: giftHtml,
				callOrigin: 'gift-transfer',
			};

			// Add transfer_request to User json
			let userTransferRequests = userData.clients[client].transfer_requests || {};

			// Initialize an array for the timestamp if not present
			userTransferRequests[timestamp] = userTransferRequests[timestamp] || [];

			// Push all gifts into the transfer_requests, each with a status
			allGifts.forEach((gift) => {
				userTransferRequests[timestamp].push({ ...gift, status: 'Open' });
			});

			// Update the userData object and save it to session storage
			userData.clients[client].transfer_requests = userTransferRequests;
			sessionStorage.setItem('user.Data', JSON.stringify(userData));

			// Prepare the payload for the DynamoDB update API
			let dynamoDbPayload = {
				userid: authedUser,
				client: client,
				cookie: cookie,
				holder: userData.userid,
				data: userData.clients[client],
			};

			// Call both APIs sequentially
			try {
				// 1. Update transfer_requests in DynamoDB
				const dynamoRes = await axios.post('https://api.nthround.io/portal/user/update-user-client-data', JSON.stringify(dynamoDbPayload));
				console.log('DynamoDB update response:', dynamoRes);

				// 2. Upload the document
				const docRes = await axios.post('https://api.nthround.io/portal/auth/upload-to-your-docs', params);
				console.log('upload-to-your-docs response:', docRes);
				sendGiftRequestEmail(docRes.data.pdf_url);

				// If both succeed
				console.log('Transfer Request successfully uploaded and transfer_requests updated.');

				let holder = userData.userid; // preview breadcrumb
				document.dispatchEvent(new Event('RefreshSessionStorage'));
				setTimeout(() => {
					M.Modal.getInstance(waitingModal).close();
					M.Modal.getInstance(leaveMessageModal).open();
					// previewGiftTransfer.classList.remove('disabled');
					// previewGiftTransfer.innerHTML = "Request These Transfers";

					M.Modal.getInstance(leaveMessageModal).options.onCloseEnd = () => {
						if (sessionStorage.getItem('preview'))
							document.dispatchEvent(new CustomEvent('previewShareholder', { detail: { uid: holder, path: '' } }));
						else document.dispatchEvent(new Event('renderInvestorPortal'));
					};
				}, 2000);
			} catch (err) {
				// Log any errors from either API call
				console.error('Error during transfer request processing:', err);
			}
		}

		function sendGiftRequestEmail(pdfUrl) {
			const ending = `<br><br>${firstName(userData)}<br><br><a href="https://${client}.nthround.io/admin/users/edit/?email=${userData.userid}">View this ${purpose}</a>`;
			axios
				.post(
					'https://api.nthround.io/portal/auth/send-email',
					JSON.stringify({
						client: client,
						userid: authedUser,
						cookie: cookie,
						sender_email: 'messages@nthround.com',
						sender_name: userData.user_name,
						replyto_email: userData.userid,
						recipient: clientData.contact_email,
						cc_emails: [userData.userid],
						subject: purpose,
						message:
							'Hi--<br><br>Please review this ' +
							purpose +
							'.<br><br>I understand that you will reach out to me for confirmation prior to processing.<br><br>Thank you!' +
							ending +
							'<br><br>[Note: email replies will go to ' +
							userData.user_name +
							' &lt;' +
							userData.userid +
							'&gt;.]',
						attachment: pdfUrl,
					})
				)
				.then(function (res) {
					const btnGroupLink = document.getElementById('btnGroupLink');
					const leaveMessageLink = document.getElementById('leaveMessageLink');
					const leaveMessageModal = document.getElementById('leaveMessageModal');
					leaveMessageLink.classList.add('disabled');
					leaveMessageLink.innerHTML = purpose + ' Pending';
					btnGroupLink.classList.replace('bg-grey-darker', 'grey');
					leaveMessageModal.innerHTML = `
					<div class="p-2 center-align">
						<div class="mb-4"><img src="./../../resources/assets/celebrate-v4.svg" alt="Musicians celebrating" class="responsive-img px-12"/></div>
						<h3 class="text-lg mb-4 mt-4 font-bold">Your request has been sent!</h3>
						<p class="text-secondary text-sm mt-0 mb-0">We emailed a copy to ${userData.userid}.</p>
						<p class="text-secondary text-sm mt-0 mb-0">The company will reach out shortly to confirm your request.</p>
						<p class="text-secondary text-xs mt-0 mb-0">(On closing this modal your browser will refresh.)</p>
					</div>
				`;
				})
				.catch(function (err) {
					console.error(err);
				});
		}
	}

	function toNumber(str) {
		let num = Number(str);
		return isNaN(num) ? 1 : num; // assumed share price, zero is trouble mathwise!
	}

	function initModal() {}

	// Reinitialize M.Modal to include dynamically added instances
	// var modals = document.querySelectorAll('.modal');
	// let modalOptions = { onOpenStart: initModal };
	// var instances = M.Modal.init(modals, modalOptions);
}

export { giftTransfer, resetGiftTransferState };
